import styled, { keyframes, css } from 'styled-components';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Zoom from 'react-img-zoom';
import Slider from 'react-slick';
import { select, scaleOrdinal, pie, arc, easeLinear, interpolate, schemeCategory10, scaleLinear, extent, max, line, axisBottom, format, axisLeft, min, symbol, symbols, nest, stack, area, scaleBand } from 'd3';
import { feature } from 'topojson-client';
import { geoMercator, geoPath, geoGraticule10 } from 'd3-geo';

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

// 7.2.1 RequireObjectCoercible(argument)
var _defined = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// 7.1.13 ToObject(argument)

var _toObject = function (it) {
  return Object(_defined(it));
};

var hasOwnProperty = {}.hasOwnProperty;
var _has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var _core = createCommonjsModule(function (module) {
var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
var _core_1 = _core.version;

var _global = createCommonjsModule(function (module) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _library = true;

var _shared = createCommonjsModule(function (module) {
var SHARED = '__core-js_shared__';
var store = _global[SHARED] || (_global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: _core.version,
  mode: 'pure',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});
});

var id = 0;
var px = Math.random();
var _uid = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

var shared = _shared('keys');

var _sharedKey = function (key) {
  return shared[key] || (shared[key] = _uid(key));
};

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


var IE_PROTO = _sharedKey('IE_PROTO');
var ObjectProto = Object.prototype;

var _objectGpo = Object.getPrototypeOf || function (O) {
  O = _toObject(O);
  if (_has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

var _aFunction = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding

var _ctx = function (fn, that, length) {
  _aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var _isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject = function (it) {
  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var document$1 = _global.document;
// typeof document.createElement is 'object' in old IE
var is = _isObject(document$1) && _isObject(document$1.createElement);
var _domCreate = function (it) {
  return is ? document$1.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])

// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive = function (it, S) {
  if (!_isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP = Object.defineProperty;

var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject(O);
  P = _toPrimitive(P, true);
  _anObject(Attributes);
  if (_ie8DomDefine) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _objectDp = {
	f: f
};

var _propertyDesc = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide = _descriptors ? function (object, key, value) {
  return _objectDp.f(object, key, _propertyDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] : (_global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && _has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? _ctx(out, _global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) _hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
var _export = $export;

// most Object methods by ES6 should accept primitives



var _objectSap = function (KEY, exec) {
  var fn = (_core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  _export(_export.S + _export.F * _fails(function () { fn(1); }), 'Object', exp);
};

// 19.1.2.9 Object.getPrototypeOf(O)



_objectSap('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return _objectGpo(_toObject(it));
  };
});

var getPrototypeOf = _core.Object.getPrototypeOf;

var getPrototypeOf$1 = createCommonjsModule(function (module) {
module.exports = { "default": getPrototypeOf, __esModule: true };
});

var _Object$getPrototypeOf = unwrapExports(getPrototypeOf$1);

var classCallCheck = createCommonjsModule(function (module, exports) {

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
});

var _classCallCheck = unwrapExports(classCallCheck);

// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
_export(_export.S + _export.F * !_descriptors, 'Object', { defineProperty: _objectDp.f });

var $Object = _core.Object;
var defineProperty = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

var defineProperty$1 = createCommonjsModule(function (module) {
module.exports = { "default": defineProperty, __esModule: true };
});

unwrapExports(defineProperty$1);

var createClass = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _defineProperty2 = _interopRequireDefault(defineProperty$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
});

var _createClass = unwrapExports(createClass);

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
var _toInteger = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

// true  -> String#at
// false -> String#codePointAt
var _stringAt = function (TO_STRING) {
  return function (that, pos) {
    var s = String(_defined(that));
    var i = _toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var _redefine = _hide;

var _iterators = {};

var toString = {}.toString;

var _cof = function (it) {
  return toString.call(it).slice(8, -1);
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings

// eslint-disable-next-line no-prototype-builtins
var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof(it) == 'String' ? it.split('') : Object(it);
};

// to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject = function (it) {
  return _iobject(_defined(it));
};

// 7.1.15 ToLength

var min$1 = Math.min;
var _toLength = function (it) {
  return it > 0 ? min$1(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

var max$1 = Math.max;
var min$2 = Math.min;
var _toAbsoluteIndex = function (index, length) {
  index = _toInteger(index);
  return index < 0 ? max$1(index + length, 0) : min$2(index, length);
};

// false -> Array#indexOf
// true  -> Array#includes



var _arrayIncludes = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject($this);
    var length = _toLength(O.length);
    var index = _toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIndexOf = _arrayIncludes(false);
var IE_PROTO$1 = _sharedKey('IE_PROTO');

var _objectKeysInternal = function (object, names) {
  var O = _toIobject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO$1) _has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (_has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

// IE 8- don't enum bug keys
var _enumBugKeys = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

// 19.1.2.14 / 15.2.3.14 Object.keys(O)



var _objectKeys = Object.keys || function keys(O) {
  return _objectKeysInternal(O, _enumBugKeys);
};

var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject(O);
  var keys = _objectKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
  return O;
};

var document$2 = _global.document;
var _html = document$2 && document$2.documentElement;

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



var IE_PROTO$2 = _sharedKey('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE$1 = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate('iframe');
  var i = _enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  _html.appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
  return createDict();
};

var _objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE$1] = _anObject(O);
    result = new Empty();
    Empty[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$2] = O;
  } else result = createDict();
  return Properties === undefined ? result : _objectDps(result, Properties);
};

var _wks = createCommonjsModule(function (module) {
var store = _shared('wks');

var Symbol = _global.Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
};

$exports.store = store;
});

var def = _objectDp.f;

var TAG = _wks('toStringTag');

var _setToStringTag = function (it, tag, stat) {
  if (it && !_has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
_hide(IteratorPrototype, _wks('iterator'), function () { return this; });

var _iterCreate = function (Constructor, NAME, next) {
  Constructor.prototype = _objectCreate(IteratorPrototype, { next: _propertyDesc(1, next) });
  _setToStringTag(Constructor, NAME + ' Iterator');
};

var ITERATOR = _wks('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  _iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = _objectGpo($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      _setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!_library && typeof IteratorPrototype[ITERATOR] != 'function') _hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!_library || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    _hide(proto, ITERATOR, $default);
  }
  // Plug for library
  _iterators[NAME] = $default;
  _iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) _redefine(proto, key, methods[key]);
    } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

var $at = _stringAt(true);

// 21.1.3.27 String.prototype[@@iterator]()
_iterDefine(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

var _iterStep = function (done, value) {
  return { value: value, done: !!done };
};

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
var es6_array_iterator = _iterDefine(Array, 'Array', function (iterated, kind) {
  this._t = _toIobject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return _iterStep(1);
  }
  if (kind == 'keys') return _iterStep(0, index);
  if (kind == 'values') return _iterStep(0, O[index]);
  return _iterStep(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
_iterators.Arguments = _iterators.Array;

var TO_STRING_TAG = _wks('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = _global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) _hide(proto, TO_STRING_TAG, NAME);
  _iterators[NAME] = _iterators.Array;
}

var f$1 = _wks;

var _wksExt = {
	f: f$1
};

var iterator = _wksExt.f('iterator');

var iterator$1 = createCommonjsModule(function (module) {
module.exports = { "default": iterator, __esModule: true };
});

unwrapExports(iterator$1);

var _meta = createCommonjsModule(function (module) {
var META = _uid('meta');


var setDesc = _objectDp.f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !_fails(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!_isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!_has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!_has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !_has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};
});
var _meta_1 = _meta.KEY;
var _meta_2 = _meta.NEED;
var _meta_3 = _meta.fastKey;
var _meta_4 = _meta.getWeak;
var _meta_5 = _meta.onFreeze;

var defineProperty$3 = _objectDp.f;
var _wksDefine = function (name) {
  var $Symbol = _core.Symbol || (_core.Symbol = {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty$3($Symbol, name, { value: _wksExt.f(name) });
};

var f$2 = Object.getOwnPropertySymbols;

var _objectGops = {
	f: f$2
};

var f$3 = {}.propertyIsEnumerable;

var _objectPie = {
	f: f$3
};

// all enumerable object keys, includes symbols



var _enumKeys = function (it) {
  var result = _objectKeys(it);
  var getSymbols = _objectGops.f;
  if (getSymbols) {
    var symbols$$1 = getSymbols(it);
    var isEnum = _objectPie.f;
    var i = 0;
    var key;
    while (symbols$$1.length > i) if (isEnum.call(it, key = symbols$$1[i++])) result.push(key);
  } return result;
};

// 7.2.2 IsArray(argument)

var _isArray = Array.isArray || function isArray(arg) {
  return _cof(arg) == 'Array';
};

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)

var hiddenKeys = _enumBugKeys.concat('length', 'prototype');

var f$4 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return _objectKeysInternal(O, hiddenKeys);
};

var _objectGopn = {
	f: f$4
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window

var gOPN = _objectGopn.f;
var toString$1 = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

var f$5 = function getOwnPropertyNames(it) {
  return windowNames && toString$1.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(_toIobject(it));
};

var _objectGopnExt = {
	f: f$5
};

var gOPD = Object.getOwnPropertyDescriptor;

var f$6 = _descriptors ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = _toIobject(O);
  P = _toPrimitive(P, true);
  if (_ie8DomDefine) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (_has(O, P)) return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
};

var _objectGopd = {
	f: f$6
};

// ECMAScript 6 symbols shim





var META = _meta.KEY;





















var gOPD$1 = _objectGopd.f;
var dP$1 = _objectDp.f;
var gOPN$1 = _objectGopnExt.f;
var $Symbol = _global.Symbol;
var $JSON = _global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE$2 = 'prototype';
var HIDDEN = _wks('_hidden');
var TO_PRIMITIVE = _wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = _shared('symbol-registry');
var AllSymbols = _shared('symbols');
var OPSymbols = _shared('op-symbols');
var ObjectProto$1 = Object[PROTOTYPE$2];
var USE_NATIVE = typeof $Symbol == 'function' && !!_objectGops.f;
var QObject = _global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE$2] || !QObject[PROTOTYPE$2].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = _descriptors && _fails(function () {
  return _objectCreate(dP$1({}, 'a', {
    get: function () { return dP$1(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD$1(ObjectProto$1, key);
  if (protoDesc) delete ObjectProto$1[key];
  dP$1(it, key, D);
  if (protoDesc && it !== ObjectProto$1) dP$1(ObjectProto$1, key, protoDesc);
} : dP$1;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _objectCreate($Symbol[PROTOTYPE$2]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto$1) $defineProperty(OPSymbols, key, D);
  _anObject(it);
  key = _toPrimitive(key, true);
  _anObject(D);
  if (_has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!_has(it, HIDDEN)) dP$1(it, HIDDEN, _propertyDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (_has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _objectCreate(D, { enumerable: _propertyDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP$1(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  _anObject(it);
  var keys = _enumKeys(P = _toIobject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _objectCreate(it) : $defineProperties(_objectCreate(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = _toPrimitive(key, true));
  if (this === ObjectProto$1 && _has(AllSymbols, key) && !_has(OPSymbols, key)) return false;
  return E || !_has(this, key) || !_has(AllSymbols, key) || _has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = _toIobject(it);
  key = _toPrimitive(key, true);
  if (it === ObjectProto$1 && _has(AllSymbols, key) && !_has(OPSymbols, key)) return;
  var D = gOPD$1(it, key);
  if (D && _has(AllSymbols, key) && !(_has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN$1(_toIobject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!_has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto$1;
  var names = gOPN$1(IS_OP ? OPSymbols : _toIobject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (_has(AllSymbols, key = names[i++]) && (IS_OP ? _has(ObjectProto$1, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = _uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto$1) $set.call(OPSymbols, value);
      if (_has(this, HIDDEN) && _has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, _propertyDesc(1, value));
    };
    if (_descriptors && setter) setSymbolDesc(ObjectProto$1, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  _redefine($Symbol[PROTOTYPE$2], 'toString', function toString() {
    return this._k;
  });

  _objectGopd.f = $getOwnPropertyDescriptor;
  _objectDp.f = $defineProperty;
  _objectGopn.f = _objectGopnExt.f = $getOwnPropertyNames;
  _objectPie.f = $propertyIsEnumerable;
  _objectGops.f = $getOwnPropertySymbols;

  if (_descriptors && !_library) {
    _redefine(ObjectProto$1, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  _wksExt.f = function (name) {
    return wrap(_wks(name));
  };
}

_export(_export.G + _export.W + _export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)_wks(es6Symbols[j++]);

for (var wellKnownSymbols = _objectKeys(_wks.store), k = 0; wellKnownSymbols.length > k;) _wksDefine(wellKnownSymbols[k++]);

_export(_export.S + _export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return _has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

_export(_export.S + _export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = _fails(function () { _objectGops.f(1); });

_export(_export.S + _export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return _objectGops.f(_toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && _export(_export.S + _export.F * (!USE_NATIVE || _fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!_isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!_isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE$2][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE$2], TO_PRIMITIVE, $Symbol[PROTOTYPE$2].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
_setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
_setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
_setToStringTag(_global.JSON, 'JSON', true);

_wksDefine('asyncIterator');

_wksDefine('observable');

var symbol$1 = _core.Symbol;

var symbol$2 = createCommonjsModule(function (module) {
module.exports = { "default": symbol$1, __esModule: true };
});

unwrapExports(symbol$2);

var _typeof_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _iterator2 = _interopRequireDefault(iterator$1);



var _symbol2 = _interopRequireDefault(symbol$2);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};
});

var _typeof = unwrapExports(_typeof_1);

var possibleConstructorReturn = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _typeof3 = _interopRequireDefault(_typeof_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};
});

var _possibleConstructorReturn = unwrapExports(possibleConstructorReturn);

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */


var check = function (O, proto) {
  _anObject(O);
  if (!_isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
var _setProto = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = _ctx(Function.call, _objectGopd.f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

// 19.1.3.19 Object.setPrototypeOf(O, proto)

_export(_export.S, 'Object', { setPrototypeOf: _setProto.set });

var setPrototypeOf = _core.Object.setPrototypeOf;

var setPrototypeOf$1 = createCommonjsModule(function (module) {
module.exports = { "default": setPrototypeOf, __esModule: true };
});

unwrapExports(setPrototypeOf$1);

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
_export(_export.S, 'Object', { create: _objectCreate });

var $Object$1 = _core.Object;
var create = function create(P, D) {
  return $Object$1.create(P, D);
};

var create$1 = createCommonjsModule(function (module) {
module.exports = { "default": create, __esModule: true };
});

unwrapExports(create$1);

var inherits = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _setPrototypeOf2 = _interopRequireDefault(setPrototypeOf$1);



var _create2 = _interopRequireDefault(create$1);



var _typeof3 = _interopRequireDefault(_typeof_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};
});

var _inherits = unwrapExports(inherits);

// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
_export(_export.S + _export.F * !_descriptors, 'Object', { defineProperties: _objectDps });

var $Object$2 = _core.Object;
var defineProperties = function defineProperties(T, D) {
  return $Object$2.defineProperties(T, D);
};

var defineProperties$1 = createCommonjsModule(function (module) {
module.exports = { "default": defineProperties, __esModule: true };
});

unwrapExports(defineProperties$1);

// 19.1.2.5 Object.freeze(O)

var meta = _meta.onFreeze;

_objectSap('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && _isObject(it) ? $freeze(meta(it)) : it;
  };
});

var freeze = _core.Object.freeze;

var freeze$1 = createCommonjsModule(function (module) {
module.exports = { "default": freeze, __esModule: true };
});

unwrapExports(freeze$1);

var taggedTemplateLiteral = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _defineProperties2 = _interopRequireDefault(defineProperties$1);



var _freeze2 = _interopRequireDefault(freeze$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (strings, raw) {
  return (0, _freeze2.default)((0, _defineProperties2.default)(strings, {
    raw: {
      value: (0, _freeze2.default)(raw)
    }
  }));
};
});

var _taggedTemplateLiteral = unwrapExports(taggedTemplateLiteral);

var _templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  background: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  border: ", ";\n  border-radius: ", ";\n  padding: ", ";\n  cursor: pointer;\n  outline: 0;\n"], ["\n  width: 100%;\n  background: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  border: ", ";\n  border-radius: ", ";\n  padding: ", ";\n  cursor: pointer;\n  outline: 0;\n"]);

var Button = styled.button(_templateObject, function (props) {
  return props.backgroundColor ? props.backgroundColor : "rgb(221, 221, 221)";
}, function (props) {
  return props.textColor ? props.textColor : "#000000";
}, function (props) {
  return props.fontSize ? props.fontSize : "14px";
}, function (props) {
  return props.fontWeight ? props.fontWeight : "0";
}, function (props) {
  return props.border ? props.border : "0";
}, function (props) {
  return props.borderRadius ? props.borderRadius : "0";
}, function (props) {
  return props.padding ? props.padding : "0";
});

var Button$1 = function (_Component) {
  _inherits(Button$$1, _Component);

  function Button$$1() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Button$$1);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button$$1.__proto__ || _Object$getPrototypeOf(Button$$1)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (e) {
      var onClick = _this.props.onClick;

      e.preventDefault();
      if (onClick) {
        onClick();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Button$$1, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          id = _props.id,
          className = _props.className,
          name = _props.name,
          text = _props.text,
          textColor = _props.textColor,
          backgroundColor = _props.backgroundColor,
          width = _props.width,
          margin = _props.margin,
          padding = _props.padding,
          type = _props.type,
          fontSize = _props.fontSize,
          fontWeight = _props.fontWeight,
          border = _props.border,
          borderRadius = _props.borderRadius,
          value = _props.value,
          form = _props.form;

      return React.createElement(
        "div",
        {
          style: {
            width: width ? width : "100%",
            margin: margin ? margin : "5px"
          }
        },
        React.createElement(
          Button,
          {
            name: name,
            id: id,
            calss: className,
            type: type,
            textColor: textColor,
            backgroundColor: backgroundColor,
            fontSize: fontSize,
            fontWeight: fontWeight,
            border: border,
            padding: padding,
            borderRadius: borderRadius,
            value: value,
            form: form,
            onClick: this.onClick
          },
          text
        )
      );
    }
  }]);

  return Button$$1;
}(Component);

var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAAoAQAAAABBG0CsAAAAAW9yTlQBz6J3mgAAAB9JREFUGNNjYMAK7P////8HTNCCeYCBedgyqR9mWAEA5qIDSFU1SsQAAAAASUVORK5CYII=";

var _templateObject$1 = _taggedTemplateLiteral(["\n  &:before {\n    content: \"\";\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    margin-right: 10px;\n    position: absolute;\n    left: 0;\n    top: 2px;\n    background-image: url(", ");\n    background-repeat: no-repeat;\n    background-size: 32px 16px;\n    background-position: 0px 0px;\n    opacity: 0.8;\n  }\n  display: inline-block;\n  cursor: pointer;\n  position: relative;\n  padding-left: 25px;\n  margin-right: 15px;\n  font-weight: 400;\n  max-width: 100%;\n  margin-bottom: 5px;\n"], ["\n  &:before {\n    content: \"\";\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    margin-right: 10px;\n    position: absolute;\n    left: 0;\n    top: 2px;\n    background-image: url(", ");\n    background-repeat: no-repeat;\n    background-size: 32px 16px;\n    background-position: 0px 0px;\n    opacity: 0.8;\n  }\n  display: inline-block;\n  cursor: pointer;\n  position: relative;\n  padding-left: 25px;\n  margin-right: 15px;\n  font-weight: 400;\n  max-width: 100%;\n  margin-bottom: 5px;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  display: none;\n  &:checked + ", ":before {\n    background-position: -16px 0px;\n  }\n"], ["\n  display: none;\n  &:checked + ", ":before {\n    background-position: -16px 0px;\n  }\n"]);

var CheckboxLabel = styled.label(_templateObject$1, img);
var CheckboxInput = styled.input(_templateObject2, CheckboxLabel);

var Checkbox = function (_Component) {
  _inherits(Checkbox, _Component);

  function Checkbox() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Checkbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Checkbox.__proto__ || _Object$getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
      var checkboxValue = _this.props.checkboxValue;

      if (checkboxValue) {
        checkboxValue(e.target);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          dataList = _props.dataList,
          cbDefault = _props.cbDefault,
          className = _props.className;

      var defaultCheckbox = function defaultCheckbox(data, i) {
        if (typeof cbDefault === "string") {
          return cbDefault === data.text;
        } else if (typeof cbDefault === "boolean") {
          return i === 0;
        } else {
          return false;
        }
      };
      var defaultType = function defaultType(data) {
        if (data.type) {
          return data.type;
        } else {
          return "checkbox";
        }
      };
      return React.createElement(
        React.Fragment,
        null,
        dataList.map(function (data, i) {
          return React.createElement(
            "div",
            { key: i, style: { display: "flex", margin: "10px" } },
            React.createElement(CheckboxInput, {
              type: defaultType(data),
              id: data.id,
              calss: className,
              name: data.name,
              value: data.checkbox,
              onChange: _this2.onChange,
              defaultChecked: defaultCheckbox(data, i),
              disabled: data.disabled
            }),
            React.createElement(CheckboxLabel, { htmlFor: data.id }),
            React.createElement(
              "div",
              { style: { margin: "-3.5px 0 0 -20px" } },
              React.createElement(
                "p",
                { style: { margin: "0" } },
                data.text
              )
            )
          );
        })
      );
    }
  }]);

  return Checkbox;
}(Component);

// 19.1.2.1 Object.assign(target, source, ...)






var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
var _objectAssign = !$assign || _fails(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = _toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = _objectGops.f;
  var isEnum = _objectPie.f;
  while (aLen > index) {
    var S = _iobject(arguments[index++]);
    var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!_descriptors || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

// 19.1.3.1 Object.assign(target, source)


_export(_export.S + _export.F, 'Object', { assign: _objectAssign });

var assign = _core.Object.assign;

var assign$1 = createCommonjsModule(function (module) {
module.exports = { "default": assign, __esModule: true };
});

unwrapExports(assign$1);

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
  width: 92,
  height: 92,
  id: "img1",
  href: "data:image/png;base64,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"
}));

var _ref2 = /*#__PURE__*/React.createElement("use", {
  id: "Layer 0",
  href: "#img1",
  x: 2,
  y: 1
});

var closeBtn = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2096%2096%22%20width%3D%2296%22%20height%3D%2296%22%3E%20%3Cdefs%3E%20%20%3Cimage%20width%3D%2292%22%20height%3D%2292%22%20id%3D%22img1%22%20href%3D%22data%3Aimage%2Fpng%3Bbase64%2CiVBORw0KGgoAAAANSUhEUgAAAFwAAABcCAMAAADUMSJqAAAAAXNSR0IB2cksfwAAAppQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA1tr9yQAAAN50Uk5TAEyyCE%2F5%2F7cGqVNRtbBSVPqxtE6rrge2rAUJuLOqAwq5vaW%2FuqIMwr6fDcPAnQEPxAubx6gEmBDJpg7FlBHMo8iREs2gyo8Uz56NFdDOihbTmROGF9WV0YIZ1pPUgBrYkH0b2RjXeh3cdx%2Fdh9pzIN%2BEHHEh4IH%2BbyPiayXj4Wgn5XgiZSjmdCRiKudy%2FWEr6W78Xi7qbCnoWzDraVcx7GYsVTPuZPs07%2B048F8yOks88Vk1dfNWOfI%2B%2BEhN9fRaO102ai8tcHZ55CZ8f4OF3okei46XjNICpMuhwbtQyeM40AAABOJJREFUeJy12vlbFVUYB%2FDDxRlGwIVUwBBummKmct0xFbfSLDJcU0zLfQEXUhJFRUhT0TRFScCUJJUMF8xIMdvL9s0W9%2F%2FFc%2B98z%2BUus5wzczw%2F%2BNw5530%2Fc8%2F7nofnmTsSQkeMJ5Y8qtFOUeM0uaTWPl7%2FkKCoqpooVdc6qEpH%2F4dOnVX%2FSJKoa49RUOlCP3VV9dFNmp6cEgCVGHobD%2FTU7nLsx9MA9qAXWiIu0jNk2N4nwMUFjqAWh8v2EnRvT2CJyfpELLtZL9e690lQnmALvb0x1celntkXUIeQ4%2BF9CpP9XOlP92eHI%2BzoeQdgemCWc9s3CEjXiIM3mG1oiGPdNxTEsOGRS5nstiMc6tkjATxjUNpRo7E4xpGeMxbp4wzb5huP5QkO9InPIvk5kyPhm4SAycL281OQ%2BoLpcctmW3tR0M59ieM45ExF0MtCdt40pE23LOgM9hVmCtizZiPpFZtm5c5B4FxuO38eUl61PQi58xG6gNN%2B7XUkLOQ4ZHlsk4u47MVLhA7B0mUIX84RvGKl4BHIZ19mlW1oQSFCV3PadKtrkLLWJnBdEQLf4LYJWc82u8EyrPhNhG0UsGkpsd2STRZBm0uFWt82CrDhki2mIVu3CTQ%2BfBSXQd9uElBeAfstYZuQHfhiJTsNl9%2FeBXu3A5uQPUyvNFjcuw%2F2O45sWlRsfP%2BBqKV3D%2BLGhxzatKzYetXhiIUj1bDfc2wTcrQGem3YdN0x2O%2B7sGlp8RWrjodMnqiH%2FYErm5CTTG8ITn14Cq047dKm5UUJzuAphzR%2BhNtFt1l81J3VMf0ph3zcBPucBJuQ8yhD4CnnArNrbfP4RiNA5SJpvgT7E0k2IZeZ%2FmkLGvCZNJuQK9AxOneSaNNSXw2xlQSpNiHNLW12O8k2Ia3XWE1ipNvkcwX4tVbp9kUlWJaWZsn29TZbVa9ekGonhNqq2nRFoh0P%2B4tV%2BNB0WZrdoP8ko37ZGix9U6Mk%2B3gVSu1vZBfop85Lsb%2BCfenrwGVH6PV1EuxvqiKaGH9Gnzh2xLV9jtnfBqcaMFV90qVduR8lDm0ga0L1Xlf26RKdORvevlroNUdd2Nth15%2BIWDgMfVe5Y%2Fs72NXfRy0dQLkqtjq0D8E%2B%2BIPBYiUWt%2B1xZN9Aeo1x23ZiuXSHA3s3%2FkjtM2saa0jZOmH7R9gV5aYhW6AXFQjaP8H%2B%2BReLoE3QC1cI2b%2FCLrVu1w2ErVwvYP%2BGpDK7Zq1F4JrF3PbvSCkqtg1lrVmSz2n%2FgYQ%2FeRq1HMHLlnLZfyG88G%2Bu8EUIn53HEXyTlZG3SQuQMC3XLjLrH1ZE%2FhbNRcocGz1rAishb4P8YyaSpsywtMcgbB5fe9hgbZqaY2H%2Fi6D5s4RsQv5D4thsU3s6Qv63bU3UmIzUST7j9VsDWenEbZK1EMnjDfWMfqxwlm0x1Vm7Ro8ysPuwsk10YlN9BID%2BmVH2bSzdMW2JrT4ERF9vhD3MsmScOmvagDB9eDormAubHgnWtp4hupaKyUEGzRAZGXcB9Q7qWjdWrKhWCOu9QKXhxbOWhIl7g93aIc3TXzwHXrtGFsqFztrnf%2FEcm4KL%2B1JsejhYA5M0wt7jpkmyQ1qYTmL0p5A4iW%2F%2B0UT%2FTxsPAm%2Fmk%2BXZePGs%2F7RBn6A8sv9PQUrwp434VMk2PSae6%2FTfh6z1%2FXqohGO5AAAAAElFTkSuQmCC%22%2F%3E%20%3C%2Fdefs%3E%20%3Cstyle%3E%20%20tspan%20%7B%20white-space%3Apre%20%7D%20%3C%2Fstyle%3E%20%3Cuse%20id%3D%22Layer%200%22%20href%3D%22%23img1%22%20x%3D%222%22%20y%3D%221%22%20%2F%3E%3C%2Fsvg%3E";

var backBtn = "data:image/png;base64,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";

var _templateObject$2 = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n  }\n"], ["\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n  }\n"]),
    _templateObject2$1 = _taggedTemplateLiteral(["\n  padding: ", ";\n  color: ", ";\n  background: ", ";\n  border: ", ";\n  border-radius: 0;\n  outline: 0;\n  cursor: pointer;\n"], ["\n  padding: ", ";\n  color: ", ";\n  background: ", ";\n  border: ", ";\n  border-radius: 0;\n  outline: 0;\n  cursor: pointer;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  top: 0;\n  left: 0;\n  opacity: ", ";\n  pointer-events: ", ";\n  transition: all 300ms;\n  display: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n  overflow-y: ", ";\n  z-index: 99;\n  @media screen and (max-width: 991px) {\n    display: none;\n  }\n"], ["\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  top: 0;\n  left: 0;\n  opacity: ", ";\n  pointer-events: ", ";\n  transition: all 300ms;\n  display: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n  overflow-y: ", ";\n  z-index: 99;\n  @media screen and (max-width: 991px) {\n    display: none;\n  }\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  animation: ", " 300ms ease-out forwards;\n"], ["\n  animation: ", " 300ms ease-out forwards;\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  width: ", ";\n  margin: ", ";\n  min-height: ", ";\n  background: white;\n  border-radius: 5px;\n  text-align: center;\n  padding: 15px;\n  position: relative;\n  ", ";\n  h2 {\n    font-size: 36px;\n    font-weight: bolder;\n    border-bottom: 1px solid #ccc;\n    padding-bottom: 5px;\n  }\n  @media screen and (max-width: 760px) {\n    width: 85%;\n  }\n"], ["\n  width: ", ";\n  margin: ", ";\n  min-height: ", ";\n  background: white;\n  border-radius: 5px;\n  text-align: center;\n  padding: 15px;\n  position: relative;\n  ", ";\n  h2 {\n    font-size: 36px;\n    font-weight: bolder;\n    border-bottom: 1px solid #ccc;\n    padding-bottom: 5px;\n  }\n  @media screen and (max-width: 760px) {\n    width: 85%;\n  }\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  width: 25px;\n  height: 25px;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: url(", ") no-repeat center center;\n  background-size: contain;\n  opacity: 0.7;\n  cursor: pointer;\n  &:hover {\n    opacity: 0.5;\n  }\n  @media screen and (max-width: 760px) {\n    width: 15px;\n    height: 15px;\n  }\n"], ["\n  width: 25px;\n  height: 25px;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: url(", ") no-repeat center center;\n  background-size: contain;\n  opacity: 0.7;\n  cursor: pointer;\n  &:hover {\n    opacity: 0.5;\n  }\n  @media screen and (max-width: 760px) {\n    width: 15px;\n    height: 15px;\n  }\n"]),
    _templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"]),
    _templateObject8 = _taggedTemplateLiteral(["\n  min-width: 200px;\n  padding: 16px;\n  margin: 0 5px;\n  background: #e9e8e7;\n  color: #000000;\n  border: 0;\n  outline: 0;\n  cursor: pointer;\n  @media screen and (max-width: 991px) {\n    width: 100%;\n    margin: 10px 0 0 0;\n  }\n"], ["\n  min-width: 200px;\n  padding: 16px;\n  margin: 0 5px;\n  background: #e9e8e7;\n  color: #000000;\n  border: 0;\n  outline: 0;\n  cursor: pointer;\n  @media screen and (max-width: 991px) {\n    width: 100%;\n    margin: 10px 0 0 0;\n  }\n"]),
    _templateObject9 = _taggedTemplateLiteral(["\n  background: #000000;\n  color: #ffffff;\n"], ["\n  background: #000000;\n  color: #ffffff;\n"]),
    _templateObject10 = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 99;\n  background: #ffffff;\n  top: 0;\n  right: ", ";\n  width: 100%;\n  height: 100vh;\n  transition: all 300ms;\n  display: none;\n  @media screen and (max-width: 991px) {\n    display: block;\n  }\n"], ["\n  position: fixed;\n  z-index: 99;\n  background: #ffffff;\n  top: 0;\n  right: ", ";\n  width: 100%;\n  height: 100vh;\n  transition: all 300ms;\n  display: none;\n  @media screen and (max-width: 991px) {\n    display: block;\n  }\n"]),
    _templateObject11 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  width: 100%;\n  text-align: center;\n  height: 120px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  position: absolute;\n  top: 0;\n  width: 100%;\n  text-align: center;\n  height: 120px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]),
    _templateObject12 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  width: 40px;\n  height: 120px;\n  background: url(", ") no-repeat center center;\n  background-size: 15px 15px;\n"], ["\n  position: absolute;\n  left: 0;\n  width: 40px;\n  height: 120px;\n  background: url(", ") no-repeat center center;\n  background-size: 15px 15px;\n"]),
    _templateObject13 = _taggedTemplateLiteral(["\n  padding: 135px 15px 15px 15px;\n  overflow-y: scroll;\n  height: 100%;\n  text-align: center;\n"], ["\n  padding: 135px 15px 15px 15px;\n  overflow-y: scroll;\n  height: 100%;\n  text-align: center;\n"]),
    _templateObject14 = _taggedTemplateLiteral(["\n  min-height: ", ";\n"], ["\n  min-height: ", ";\n"]);

var slowlyBigger = keyframes(_templateObject$2);

var Button$2 = styled.button(_templateObject2$1, function (props) {
  return props.buttonPadding ? props.buttonPadding : "16px";
}, function (props) {
  return props.buttonColor ? props.buttonColor : "black";
}, function (props) {
  return props.buttonBackground ? props.buttonBackground : "white";
}, function (props) {
  return props.buttonBorder ? props.buttonBorder : "1px solid black";
});

var DialogBackground = styled.div(_templateObject3, function (props) {
  return props.show ? "1" : "0";
}, function (props) {
  return props.show ? "" : "none";
}, function (props) {
  return props.scrollBar ? "" : "flex";
}, function (props) {
  return props.scrollBar ? "" : "center";
}, function (props) {
  return props.scrollBar ? "" : "center";
}, function (props) {
  return props.scrollBar ? "scroll" : "";
});

var contentAnimation = css(_templateObject4, slowlyBigger);

var DialogContent = styled.div(_templateObject5, function (props) {
  return props.width ? props.width : "60%";
}, function (props) {
  return props.scrollBar ? "15vh auto" : "";
}, function (props) {
  return props.scrollBar ? "700px" : "";
}, function (props) {
  return props.animation ? contentAnimation : "";
});

var CloseButton = styled.div(_templateObject6, closeBtn);

var ButtonSection = styled.div(_templateObject7);

var CancelButton = styled.button(_templateObject8);

var AgreeButton = styled(CancelButton)(_templateObject9);

var MobileDialog = styled.div(_templateObject10, function (props) {
  return props.show ? "0" : "-105%";
});

var MobileDialogHeader = styled.div(_templateObject11);

var BackArrow = styled.div(_templateObject12, backBtn);

var MobileDialogBody = styled.div(_templateObject13);

var ContentBody = styled.div(_templateObject14, function (props) {
  return props.scrollBar ? "550px" : "";
});

var Dialog = function (_Component) {
  _inherits(Dialog, _Component);

  function Dialog() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Dialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dialog.__proto__ || _Object$getPrototypeOf(Dialog)).call.apply(_ref, [this].concat(args))), _this), _this.closeDialog = function () {
      _this.setState({
        show: false
      });
      document.body.style.overflow = "";
    }, _this.save = function () {
      _this.props.handleClose();
      _this.props.userAgreeFunc();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Dialog, [{
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        null,
        React.createElement(
          DialogBackground,
          {
            show: this.props.open,
            scrollBar: this.props.scrollBar
          },
          React.createElement(
            DialogContent,
            {
              scrollBar: this.props.scrollBar,
              width: this.props.width,
              animation: this.props.open
            },
            React.createElement(CloseButton, { onClick: this.props.handleClose }),
            this.props.contentHeader ? React.createElement(
              "h2",
              null,
              this.props.contentHeader
            ) : null,
            React.createElement(
              ContentBody,
              { scrollBar: this.props.scrollBar },
              this.props.contentBody
            ),
            this.props.userAgree ? React.createElement(
              ButtonSection,
              null,
              React.createElement(
                CancelButton,
                {
                  className: "dialog-cancel-button",
                  onClick: this.props.handleClose
                },
                "\u53D6\u6D88"
              ),
              React.createElement(
                AgreeButton,
                {
                  className: "dialog-agree-button",
                  onClick: this.save
                },
                "\u78BA\u8A8D"
              )
            ) : null
          )
        ),
        React.createElement(
          MobileDialog,
          { show: this.props.open },
          React.createElement(
            MobileDialogHeader,
            null,
            React.createElement(BackArrow, { onClick: this.props.handleClose }),
            React.createElement(
              "h2",
              null,
              this.props.contentHeader
            )
          ),
          React.createElement(
            MobileDialogBody,
            null,
            this.props.contentBody,
            this.props.userAgree ? React.createElement(
              "div",
              null,
              React.createElement(
                AgreeButton,
                {
                  className: "dialog-agree-button",
                  onClick: this.save
                },
                "\u78BA\u8A8D"
              ),
              React.createElement(
                CancelButton,
                {
                  className: "dialog-cancel-button",
                  onClick: this.props.handleClose
                },
                "\u53D6\u6D88"
              )
            ) : null
          )
        )
      );
    }
  }]);

  return Dialog;
}(Component);

Dialog.propTypes = {
  userAgreeFunc: PropTypes.func
};

Dialog.defaultProps = {
  userAgreeFunc: function userAgreeFunc() {}
};

var _templateObject$3 = _taggedTemplateLiteral(["\n  width: ", ";\n  border: ", ";\n  border-radius: ", ";\n"], ["\n  width: ", ";\n  border: ", ";\n  border-radius: ", ";\n"]);

var Form = styled.form(_templateObject$3, function (props) {
  return props.width ? props.width : "300px";
}, function (props) {
  return props.border ? props.border : "0";
}, function (props) {
  return props.borderRadius && props.borderRadius;
});

var Form$1 = function (_Component) {
  _inherits(Form$$1, _Component);

  function Form$$1() {
    _classCallCheck(this, Form$$1);

    return _possibleConstructorReturn(this, (Form$$1.__proto__ || _Object$getPrototypeOf(Form$$1)).apply(this, arguments));
  }

  _createClass(Form$$1, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          id = _props.id,
          className = _props.className,
          name = _props.name,
          action = _props.action,
          method = _props.method,
          width = _props.width,
          border = _props.border,
          borderRadius = _props.borderRadius,
          children = _props.children;

      return React.createElement(
        Form,
        {
          action: action,
          method: method,
          id: id,
          className: className,
          name: name,
          width: width,
          border: border,
          borderRadius: borderRadius
        },
        children
      );
    }
  }]);

  return Form$$1;
}(Component);

var _templateObject$4 = _taggedTemplateLiteral(["\n  background: black;\n  padding: 15px;\n"], ["\n  background: black;\n  padding: 15px;\n"]),
    _templateObject2$2 = _taggedTemplateLiteral(["\n  display: flex;\n  color: white;\n  padding: 15px;\n  margin: 0 auto;\n  flex-direction: row;\n  justify-content: space-around;\n  div {\n    top: 0;\n  }\n  ul {\n    list-style: none;\n    li {\n      color: white;\n    }\n  }\n  p {\n    font-size: 1em;\n  }\n  @media screen and (max-width: 769px) {\n    flex-direction: column;\n    p {\n      font-size: 1.5em;\n    }\n    ul {\n      list-style: none;\n    }\n  }\n"], ["\n  display: flex;\n  color: white;\n  padding: 15px;\n  margin: 0 auto;\n  flex-direction: row;\n  justify-content: space-around;\n  div {\n    top: 0;\n  }\n  ul {\n    list-style: none;\n    li {\n      color: white;\n    }\n  }\n  p {\n    font-size: 1em;\n  }\n  @media screen and (max-width: 769px) {\n    flex-direction: column;\n    p {\n      font-size: 1.5em;\n    }\n    ul {\n      list-style: none;\n    }\n  }\n"]),
    _templateObject3$1 = _taggedTemplateLiteral(["\n  p {\n    color: white;\n    text-align: center;\n  }\n  @media screen and (max-width: 769px) {\n    p {\n      font-size: 1em;\n      color: white;\n      text-align: left;\n      padding:30px\n    }\n  }\n"], ["\n  p {\n    color: white;\n    text-align: center;\n  }\n  @media screen and (max-width: 769px) {\n    p {\n      font-size: 1em;\n      color: white;\n      text-align: left;\n      padding:30px\n    }\n  }\n"]);

var Wrapper = styled.div(_templateObject$4);

var Div = styled.div(_templateObject2$2);
var CopyRight = styled.div(_templateObject3$1);

var FbIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAUCAYAAAC07qxWAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABh0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzT7MfTgAAABZ0RVh0Q3JlYXRpb24gVGltZQAwNy8wMy8xNNe5g1gAAACnSURBVCiR3ZAxCgJRDETfrltYewdP4wXEwsLGysMInkQEG2+hoCCojZ2Nq+iCwlj4i/zwXa19EJiQYQKDJBIzlHTWm1LSPGUaS7or5uhNXaW5FsQMjL4BC6ACSp+4MSkje8tdYmb01h688Wl0FSVImgQtoAe0wj4D9kADmGaSxHf6/nWKB7AsgJV53QaaYT8AF+AE7Hw9a1NP59d6rK415nXGj/yV8QXVk8V7EpgSZAAAAABJRU5ErkJggg==";

var IGIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAQAAAAngNWGAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfhDAwDMRPeT8gLAAABj0lEQVQoz42TsW4TURBFzy4bCW9iCbGmiJu4dGTsIj0Fn8EH0EIBhf8gW7iipsZpE8kVRZQ0kSiixFpL6UgkExcOUoTlCnYPhePFRSxxXzdzNdLMOxcRm/YcOTN3VbkzR/ZsigTCaz7R4icT5vxGBCBkg022SRjxjmPcdejc1LaJW8bGVqwYG7vlM3fdd+7QJvbU1Ggx5p9EfOVHG+6rPcyc2nHZDKzZsWNNrPhV/WDLqVnEDt/5AQUBJLzlDTvADX0+MyDkG7dMaGDhmVURE/vmjj300LG5X3zh0wKrnlmgnhqL2LVwYMvIyJYDC7sixp4q6omxWPPCsW35Q47YduyFNTH2RMOHBaFOg3OuIOIJwBXnNNh+2JKQ/9TCGAC3XLNHE3IKgCZ7XDNZ9sPSfMcBdVJaYRREvCSlzgF35aBHznPkkWNz+yZieZ6ZQxMpFtaul95776XdlerQX+u/MChrHadma6Eo0YhMF1CsYlY1XnlVE9umC8zWgRsQsMEmdZ6T8Z5jyihkj0YhW0bhL3IygV3fR6d3AAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE3LTEyLTEyVDAzOjQ5OjE5LTA1OjAwR8bQ/AAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxNy0xMi0xMlQwMzo0OToxOS0wNTowMDabaEAAAAAASUVORK5CYII=";

var Path = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAUCAYAAABSx2cSAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABh0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzT7MfTgAAABZ0RVh0Q3JlYXRpb24gVGltZQAwNy8wMy8xNNe5g1gAAAGaSURBVDiNjZS/b41hFMc/vYoiItKIRCq5BhGksfkLGDvaOzEYsFoIEYOBxMbQrhaDxcTYRW50ErHIpRVREtomovf2fgz3+8TjdSX3JCfneZ7v+X3O+06ojKBpYBaYAVaBDrD+j5Za8zn1pbqu9sPb6pb6Qp1TdxX9YnRQXVR7Ue6r39XP6kbeipO7TeNHVZSlRNhXZXReXQ7+S72htgqwGeN7jTJq3q8+UQfJYBb1WTx2GtHm1ZuRtYOPcbCI+i2XK5XSgn/TQoVdT7AVqibNBGw7mtrBT0e/1wImMrUid4waPFAWohU5aAEbMZzL41lg0DB8AHRzno/+V9SnqXlFPaq+z72j3lHPVPUeU7tJ+zHqiYzqjfowwBf1eGNUh9RXwT+op2rwsMON2lZv520qkW+p75JRT71ktWGoFx0uypp6RL2m/vDP5vWT0VV1UmWyasqFNOI18AmYAnYDPWANeA7cB96O+qpW4/1ylfKByJErWw571Z+pp9mo/3IZeBvYmRS7jEnFeE/kJrA1rnFpWIfhr+fkuIYAvwE0GLjfcKorSgAAAABJRU5ErkJggg==";

var Pinterest = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABh0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzT7MfTgAAABZ0RVh0Q3JlYXRpb24gVGltZQAwNy8wMy8xNNe5g1gAAAHdSURBVDiNhZU9a1RREIafXYMQk4CLkARrjQYhKibYBMReUCtjOjsLRbSz0sI/YBCymEbELiIWFhax9yvaavwqVBBEScyHCMJjsZMwe3I3DlzmnnfemXvmnJm5NZUtpA84AQzFegF4BCx39FCrnmH1sbrkZlkK23CVbwlsU6crgnSS6fDZiFFLKXcBT4EjRRJvgQ/ACtAPHAQayf4KOAr8LVOeKb4+qx6uSKtPvayuJu5MmfJIEexS4NvVC+p99aF6TR0I25i6mHxGcsC5ZJhKH/lScW4/IxjqRMLn1gM20vZ/RErd6ufAbqhX1OXk/CIdwZvAVtUG6tlEnA3SuVjfTI53E29NHQz8TsIn66loAT6GHgv9INl25PKNqgBYS/jeelEiO0OvhN4VuhsYT7xF4Hu8D+YAdVrttC7HQjeB38BowgcS7znwB6gBhxL+rrwU1atxNl/VM/F+vbjp8cCPJ2zjUsqyUZ231bO7w75PXVC/qefTRT1LPk/corBVX4etofba3i096r2C31bYqLcLwq3AJ9VP6kX1lK1ueV9wN7Ueapf6MpEmAp+q2H2W+fDtOL6aQRy1vROqpGkxvjoN2ANqv3q6IsgvWwN2f5VvnodV0gOcBPZEzf33F/APVYz2vWpoUQwAAAAASUVORK5CYII=";

var Weibo = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABh0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzT7MfTgAAABZ0RVh0Q3JlYXRpb24gVGltZQAwNy8wMy8xNNe5g1gAAAGxSURBVDiNldTPi49RGAXwY/JjGCOmhEKKRE2KjUaaYuFHFKFsbFAjVmxkqchfIEs1VppsbCzYWEijiZCxEGGIRpKNTDE+Ft/7/c7rNSPz1O29957nOe9zzr3dINMcC3BfIwaxtYpPlyxYjrd4ie/4iQv/QzgLu3ACKyfBFqMLl0q3F/9FeAyvTcRztFXw4xgv0mdXSHvqRHMw4O94VfCl6MVebMcT3EUHxjBYJZuLe5OQwQhuFc+acQSHynw+Pqh1d3sKsvEp9q9hNfo0DgoGmmSnK4ljuIqdGqZ3loI9Zf9XyesvqoJ2HEBXsAIfS9IDrC1JC3EYBzGvomQLvpT8UeyoKo2JQ3hRKTxVkzeKDZXCoxXss4aHLcJmnCyb68r6Wen4elnfqBCuqf2wdU/bktxJI76V7+YkI0m6k/Ql2V3Dk2RbZT6U5H1rhSV4h+GKd09xHg9LB5+wquDdRSaNa7Sp7mGwvhQ9Kl4tw+Ui82zxqB1n8KOQvUGPP69eZqDZbGeSc0n2F8mPk3xN0p5kY5LeJIuSDCfpT3KlZkNLcn10aDwIQzXjb2IfZk5S0xq/AdVdyKG2R3eGAAAAAElFTkSuQmCC";

var Footer = function (_Component) {
  _inherits(Footer, _Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, (Footer.__proto__ || _Object$getPrototypeOf(Footer)).apply(this, arguments));
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      var subTitleGroupList = this.props.subTitleGroup;
      return React.createElement(
        Wrapper,
        null,
        React.createElement(
          Div,
          null,
          this.props.subTitleGroup && subTitleGroupList.map(function (item, index) {
            return React.createElement(
              "div",
              { key: index },
              React.createElement(
                "ul",
                null,
                React.createElement(
                  "p",
                  { key: index },
                  item.title
                ),
                item.content.map(function (conItem, index) {
                  return React.createElement(
                    "a",
                    { key: index, href: conItem.link },
                    React.createElement(
                      "li",
                      {
                        style: {
                          display: conItem.displayInline,
                          paddingRight: conItem.paddingRight
                        }
                      },
                      conItem.icon === "fb" && React.createElement("img", { src: FbIcon }) || conItem.icon === "ig" && React.createElement("img", { src: IGIcon }) || conItem.icon === "path" && React.createElement("img", { src: Path }) || conItem.icon === "pinterest" && React.createElement("img", { src: Pinterest }) || conItem.icon === "weibo" && React.createElement("img", { src: Weibo }) || conItem.text
                    )
                  );
                })
              )
            );
          })
        ),
        React.createElement(
          CopyRight,
          null,
          React.createElement(
            "p",
            null,
            this.props.copyRight
          )
        )
      );
    }
  }]);

  return Footer;
}(Component);

var _templateObject$5 = _taggedTemplateLiteral(["\n  width: ", ";\n  padding: ", ";\n  border: ", ";\n  transition: all 0.5s;\n  border-radius: 0;\n  outline: 0;\n  font-size: ", ";\n  &:focus {\n    outline: 0;\n    border: ", ";\n  }\n"], ["\n  width: ", ";\n  padding: ", ";\n  border: ", ";\n  transition: all 0.5s;\n  border-radius: 0;\n  outline: 0;\n  font-size: ", ";\n  &:focus {\n    outline: 0;\n    border: ", ";\n  }\n"]);

var Input = styled.input(_templateObject$5, function (props) {
  return props.width ? props.width : "150px";
}, function (props) {
  return props.padding ? props.padding : "10px";
}, function (props) {
  return props.warning ? "1px solid red" : props.border ? props.border : "1px solid #e9e7e8";
}, function (props) {
  return props.fontSize ? props.fontSize : "16px";
}, function (props) {
  return props.focusBorder && props.focusBorder;
});

var Input$1 = function (_Component) {
  _inherits(Input$$1, _Component);

  function Input$$1() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Input$$1);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input$$1.__proto__ || _Object$getPrototypeOf(Input$$1)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
      var inputValue = _this.props.inputValue;

      if (inputValue) {
        inputValue(e.target);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Input$$1, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          id = _props.id,
          className = _props.className,
          name = _props.name,
          val = _props.val,
          placeholder = _props.placeholder,
          warning = _props.warning,
          width = _props.width,
          border = _props.border,
          focusBorder = _props.focusBorder,
          margin = _props.margin,
          padding = _props.padding,
          fontSize = _props.fontSize,
          type = _props.type;

      return React.createElement(
        "div",
        {
          style: {
            margin: margin ? margin : "5px"
          }
        },
        React.createElement(Input, {
          name: name,
          id: id,
          calss: className,
          type: type ? type : "text",
          width: width,
          padding: padding,
          border: border,
          fontSize: fontSize,
          focusBorder: focusBorder,
          placeholder: placeholder,
          value: val,
          onChange: this.onChange,
          warning: warning
        })
      );
    }
  }]);

  return Input$$1;
}(Component);

var _templateObject$6 = _taggedTemplateLiteral(["\n  min-width: ", ";\n  padding: ", ";\n  margin: 0 5px;\n  position: relative;\n  cursor: pointer;\n  display: inline-block;\n  font-size: 14px;\n  text-align: center;\n  input {\n    display: none;\n  }\n  input[type=\"radio\"]:checked ~ span {\n    background: ", ";\n    border: ", ";\n  }\n  input[type=\"radio\"]:checked ~ p {\n    color: ", ";\n  }\n  p {\n    margin: 0;\n    height: 100%;\n    line-height: 1.2;\n    color: ", ";\n    z-index: 2;\n    position: relative;\n    pointer-events: none;\n  }\n  span {\n    border: ", ";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    z-index: 1;\n  }\n"], ["\n  min-width: ", ";\n  padding: ", ";\n  margin: 0 5px;\n  position: relative;\n  cursor: pointer;\n  display: inline-block;\n  font-size: 14px;\n  text-align: center;\n  input {\n    display: none;\n  }\n  input[type=\"radio\"]:checked ~ span {\n    background: ", ";\n    border: ", ";\n  }\n  input[type=\"radio\"]:checked ~ p {\n    color: ", ";\n  }\n  p {\n    margin: 0;\n    height: 100%;\n    line-height: 1.2;\n    color: ", ";\n    z-index: 2;\n    position: relative;\n    pointer-events: none;\n  }\n  span {\n    border: ", ";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    z-index: 1;\n  }\n"]),
    _templateObject2$3 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  p {\n    color: ", ";\n  }\n  span {\n    background: ", ";\n    border: ", ";\n  }\n"], ["\n  cursor: pointer;\n  p {\n    color: ", ";\n  }\n  span {\n    background: ", ";\n    border: ", ";\n  }\n"]);

var Label = styled.label(_templateObject$6, function (props) {
  return props.width ? props.width : "46px";
}, function (props) {
  return props.padding ? props.padding : "12px 16px";
}, function (props) {
  return props.checkedBackground ? props.checkedBackground : "rgba(198, 153, 103, 0.2)";
}, function (props) {
  return props.checkedBorder ? props.checkedBorder : "1px solid rgba(198, 153, 103, 0.6)";
}, function (props) {
  return props.checkedColor ? props.checkedColor : "#00000";
}, function (props) {
  return props.color ? props.color : "#00000";
}, function (props) {
  return props.border ? props.border : "1px solid #e9e7e8";
});

var LabelDisable = styled(Label)(_templateObject2$3, function (props) {
  return props.color ? props.color : "#000000";
}, function (props) {
  return props.background ? props.background : "#e9e8e7";
}, function (props) {
  return props.border ? props.border : "1px solid #ccc";
});

var Radio = function (_Component) {
  _inherits(Radio, _Component);

  function Radio() {
    _classCallCheck(this, Radio);

    return _possibleConstructorReturn(this, (Radio.__proto__ || _Object$getPrototypeOf(Radio)).apply(this, arguments));
  }

  _createClass(Radio, [{
    key: "render",
    value: function render() {
      return this.props.disable ? React.createElement(
        LabelDisable,
        {
          color: this.props.color,
          border: this.props.border,
          padding: this.props.padding,
          background: this.props.background,
          width: this.props.width,
          checkedBackground: this.props.checkedBackground,
          checkedBorder: this.props.checkedBorder,
          checkedColor: this.props.checkedColor
        },
        React.createElement("input", {
          type: "radio",
          name: this.props.radioName,
          defaultChecked: this.props.defaultChecked,
          value: this.props.text,
          disabled: true
        }),
        React.createElement(
          "p",
          null,
          this.props.text
        ),
        React.createElement("span", null)
      ) : React.createElement(
        Label,
        {
          color: this.props.color,
          border: this.props.border,
          padding: this.props.padding,
          width: this.props.width,
          checkedBackground: this.props.checkedBackground,
          checkedBorder: this.props.checkedBorder,
          checkedColor: this.props.checkedColor
        },
        React.createElement("input", {
          type: "radio",
          name: this.props.radioName,
          defaultChecked: this.props.defaultChecked,
          value: this.props.text
        }),
        React.createElement(
          "p",
          null,
          this.props.text
        ),
        React.createElement("span", null)
      );
    }
  }]);

  return Radio;
}(Component);

var _ref$1 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
});

var closeBtn$1 = "data:image/svg+xml,%3Csvg%20aria-hidden%3D%22true%22%20focusable%3D%22false%22%20data-prefix%3D%22fas%22%20data-icon%3D%22times%22%20class%3D%22svg-inline--fa%20fa-times%20fa-w-11%22%20role%3D%22img%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20352%20512%22%3E%3Cpath%20fill%3D%22currentColor%22%20d%3D%22M242.72%20256l100.07-100.07c12.28-12.28%2012.28-32.19%200-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48%200L176%20189.28%2075.93%2089.21c-12.28-12.28-32.19-12.28-44.48%200L9.21%20111.45c-12.28%2012.28-12.28%2032.19%200%2044.48L109.28%20256%209.21%20356.07c-12.28%2012.28-12.28%2032.19%200%2044.48l22.24%2022.24c12.28%2012.28%2032.2%2012.28%2044.48%200L176%20322.72l100.07%20100.07c12.28%2012.28%2032.2%2012.28%2044.48%200l22.24-22.24c12.28-12.28%2012.28-32.19%200-44.48L242.72%20256z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

var _ref$2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
});

var searchBtn = "data:image/svg+xml,%3Csvg%20aria-hidden%3D%22true%22%20focusable%3D%22false%22%20data-prefix%3D%22fas%22%20data-icon%3D%22search%22%20class%3D%22svg-inline--fa%20fa-search%20fa-w-16%22%20role%3D%22img%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20512%20512%22%3E%3Cpath%20fill%3D%22currentColor%22%20d%3D%22M505%20442.7L405.3%20343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3%2044-79.7%2044-128C416%2093.1%20322.9%200%20208%200S0%2093.1%200%20208s93.1%20208%20208%20208c48.3%200%2092.7-16.4%20128-44v16.3c0%206.4%202.5%2012.5%207%2017l99.7%2099.7c9.4%209.4%2024.6%209.4%2033.9%200l28.3-28.3c9.4-9.4%209.4-24.6.1-34zM208%20336c-70.7%200-128-57.2-128-128%200-70.7%2057.2-128%20128-128%2070.7%200%20128%2057.2%20128%20128%200%2070.7-57.2%20128-128%20128z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

var _templateObject$7 = _taggedTemplateLiteral(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"]),
    _templateObject2$4 = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  @media only screen and (min-width: 992px) and (max-width: 1300px) {\n    .searchBar {\n      width: 160px;\n    }\n  }\n  @media only screen and (min-width: 1px) and (max-width: 991px) {\n    margin-left: 0px;\n    margin-top: 0px;\n    width: 100%;\n    display:", "\n    position: ", ";\n    z-index: ", ";\n    height: ", ";\n    background: ", ";\n    top: ", ";\n    left: ", ";\n  }\n"], ["\n  display: inline-block;\n  position: relative;\n  @media only screen and (min-width: 992px) and (max-width: 1300px) {\n    .searchBar {\n      width: 160px;\n    }\n  }\n  @media only screen and (min-width: 1px) and (max-width: 991px) {\n    margin-left: 0px;\n    margin-top: 0px;\n    width: 100%;\n    display:", "\n    position: ", ";\n    z-index: ", ";\n    height: ", ";\n    background: ", ";\n    top: ", ";\n    left: ", ";\n  }\n"]),
    _templateObject3$2 = _taggedTemplateLiteral(["\n  border: 1px solid black;\n  padding: 5px;\n  margin-top: 5px;\n  position: relative;\n  @media only screen and (min-width: 1px) and (max-width: 991px) {\n    border: none;\n    margin-top: ", ";\n    border-top: ", ";\n    border-bottom: ", ";\n    background: ", ";\n  }\n"], ["\n  border: 1px solid black;\n  padding: 5px;\n  margin-top: 5px;\n  position: relative;\n  @media only screen and (min-width: 1px) and (max-width: 991px) {\n    border: none;\n    margin-top: ", ";\n    border-top: ", ";\n    border-bottom: ", ";\n    background: ", ";\n  }\n"]),
    _templateObject4$1 = _taggedTemplateLiteral(["\n  vertical-align: middle;\n  cursor: pointer;\n  position: absolute;\n  z-index: 2;\n  top: 6px;\n  left: 3px;\n  color: black;\n  width: 30px;\n  height: 25px;\n  background: url(", ") no-repeat center center;\n  @media only screen and (min-width: 1px) and (max-width: 991px) {\n    display: none;\n    width: 14px;\n    height: 14px;\n    right: 5px;\n    text-align: center;\n    line-height: 35px;\n    top: 3px;\n  }\n  i {\n    font-size: 25px;\n    @media only screen and (max-width: 991px) {\n      font-size: 14px;\n    }\n  }\n"], ["\n  vertical-align: middle;\n  cursor: pointer;\n  position: absolute;\n  z-index: 2;\n  top: 6px;\n  left: 3px;\n  color: black;\n  width: 30px;\n  height: 25px;\n  background: url(", ") no-repeat center center;\n  @media only screen and (min-width: 1px) and (max-width: 991px) {\n    display: none;\n    width: 14px;\n    height: 14px;\n    right: 5px;\n    text-align: center;\n    line-height: 35px;\n    top: 3px;\n  }\n  i {\n    font-size: 25px;\n    @media only screen and (max-width: 991px) {\n      font-size: 14px;\n    }\n  }\n"]),
    _templateObject5$1 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 30px;\n  background: none;\n  border-radius: 0;\n  outline: 0 !important;\n  padding-left: 30px;\n  padding-right: 25px;\n\n  @media only screen and (min-width: 1px) and (max-width: 991px) {\n    height: ", ";\n    padding-left: 15px;\n  }\n"], ["\n  width: 100%;\n  height: 30px;\n  background: none;\n  border-radius: 0;\n  outline: 0 !important;\n  padding-left: 30px;\n  padding-right: 25px;\n\n  @media only screen and (min-width: 1px) and (max-width: 991px) {\n    height: ", ";\n    padding-left: 15px;\n  }\n"]),
    _templateObject6$1 = _taggedTemplateLiteral(["\n  display:", "\n  position: absolute;\n  width: 260px;\n  height: auto;\n  max-height: 480px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 10px;\n  background: white;\n  color: #454545 !important;\n  border: 1px solid #e9e7e8;\n  z-index: 100;\n\n  @media only screen and (max-width: 991px) {\n    width: 100%;\n    border: 0px solid black;\n    padding: 0 15px;\n  }\n"], ["\n  display:", "\n  position: absolute;\n  width: 260px;\n  height: auto;\n  max-height: 480px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 10px;\n  background: white;\n  color: #454545 !important;\n  border: 1px solid #e9e7e8;\n  z-index: 100;\n\n  @media only screen and (max-width: 991px) {\n    width: 100%;\n    border: 0px solid black;\n    padding: 0 15px;\n  }\n"]),
    _templateObject7$1 = _taggedTemplateLiteral(["\n  width: 100%;\n"], ["\n  width: 100%;\n"]),
    _templateObject8$1 = _taggedTemplateLiteral(["\n  font-weight: bold;\n  font-size: 11px;\n  float: left;\n  line-height: 30px;\n\n  @media only screen and (max-width: 991px) {\n    font-size: 14px;\n  }\n"], ["\n  font-weight: bold;\n  font-size: 11px;\n  float: left;\n  line-height: 30px;\n\n  @media only screen and (max-width: 991px) {\n    font-size: 14px;\n  }\n"]),
    _templateObject9$1 = _taggedTemplateLiteral(["\n  float: right;\n  margin-top: -7px;\n  font-size: 20px;\n  width: 15px;\n  height: 20px;\n  background: url(", ") no-repeat center center;\n  display: ", ";\n  @media only screen and (max-width: 991px) {\n    display: block;\n    position: fixed;\n    right: 15px;\n    width: 25px;\n    height: 25px;\n    text-align: center;\n    top: ", ";\n  }\n  i {\n    @media only screen and (max-width: 991px) {\n      font-size: 25px;\n    }\n  }\n"], ["\n  float: right;\n  margin-top: -7px;\n  font-size: 20px;\n  width: 15px;\n  height: 20px;\n  background: url(", ") no-repeat center center;\n  display: ", ";\n  @media only screen and (max-width: 991px) {\n    display: block;\n    position: fixed;\n    right: 15px;\n    width: 25px;\n    height: 25px;\n    text-align: center;\n    top: ", ";\n  }\n  i {\n    @media only screen and (max-width: 991px) {\n      font-size: 25px;\n    }\n  }\n"]),
    _templateObject10$1 = _taggedTemplateLiteral(["\n  line-height: 22px;\n  font-size: 11px;\n  a {\n    text-decoration: none;\n  }\n"], ["\n  line-height: 22px;\n  font-size: 11px;\n  a {\n    text-decoration: none;\n  }\n"]),
    _templateObject11$1 = _taggedTemplateLiteral(["\n  width: 50%;\n  float: left;\n  max-width: 110px;\n  margin: 0 0 5px 5px;\n  coloe: color: rgb(69, 69, 69);\n  &:hover {\n    color: #c69967;\n  }\n  @media only screen and (max-width: 991px) {\n    max-width: 150px;\n    font-size: 14px;\n  }\n"], ["\n  width: 50%;\n  float: left;\n  max-width: 110px;\n  margin: 0 0 5px 5px;\n  coloe: color: rgb(69, 69, 69);\n  &:hover {\n    color: #c69967;\n  }\n  @media only screen and (max-width: 991px) {\n    max-width: 150px;\n    font-size: 14px;\n  }\n"]),
    _templateObject12$1 = _taggedTemplateLiteral(["\n  font-weight: bold;\n  font-size: 11px;\n"], ["\n  font-weight: bold;\n  font-size: 11px;\n"]),
    _templateObject13$1 = _taggedTemplateLiteral(["\n  display: none;\n  font-size: 20px;\n  z-index: 2;\n  color: black;\n  width: 15px;\n  height: 20px;\n  background: url(", ") no-repeat center center;\n  @media only screen and (max-width: 991px) {\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n  }\n"], ["\n  display: none;\n  font-size: 20px;\n  z-index: 2;\n  color: black;\n  width: 15px;\n  height: 20px;\n  background: url(", ") no-repeat center center;\n  @media only screen and (max-width: 991px) {\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n  }\n"]);

var searchBarMainDiv = styled.div(_templateObject$7);
var searchBar = styled.div(_templateObject2$4, function (props) {
  return props.show ? "block" : "none";
}, function (props) {
  return props.show ? "fixed" : "none";
}, function (props) {
  return props.show ? "99999" : "1";
}, function (props) {
  return props.show ? "100vh" : "auto";
}, function (props) {
  return props.show ? "gainsboro" : "transparent";
}, function (props) {
  return props.show ? "0" : "";
}, function (props) {
  return props.show ? "0" : "";
});

var searchBarSecDiv = styled.div(_templateObject3$2, function (props) {
  return props.show ? "0px" : "5px";
}, function (props) {
  return props.show ? "none" : "1px solid black";
}, function (props) {
  return props.show ? "none" : "1px solid black";
}, function (props) {
  return props.show ? "white" : "transparent";
});

var btnIcon = styled.div(_templateObject4$1, searchBtn);

var searchInput = styled.input(_templateObject5$1, function (props) {
  return props.show ? "60px" : "30px";
});

var suggestSearch = styled.div(_templateObject6$1, function (props) {
  return props.show ? "block" : "none";
});
var resultSuggestListTable = styled.table(_templateObject7$1);

var searchHD = styled.div(_templateObject8$1);

var btnCloseSearch = styled.span(_templateObject9$1, closeBtn$1, function (props) {
  return props.displayBtnCloseSearch ? "block" : "none";
}, function (props) {
  return props.needContent ? "6%" : "1.5%";
});

var resultSuggestList = styled.div(_templateObject10$1);

var resultSuggestName = styled.a(_templateObject11$1);

var searchText = styled.div(_templateObject12$1);

var IconDivForMobile = styled.div(_templateObject13$1, searchBtn);

var SearchBar = function (_Component) {
  _inherits(SearchBar, _Component);

  function SearchBar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchBar.__proto__ || _Object$getPrototypeOf(SearchBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: false
    }, _this.onChange = function (e) {
      _this.props.handleSearch(e.target.value);
    }, _this.handleClick = function () {
      _this.setState({
        show: true
      });
    }, _this.handleClose = function () {
      _this.setState({
        show: false
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SearchBar, [{
    key: "render",
    value: function render() {
      var show = this.state.show;
      var _props = this.props,
          searchText$$1 = _props.searchText,
          needContent = _props.needContent,
          needSearchText = _props.needSearchText,
          placeholder = _props.placeholder;

      var List = this.props.List;
      var title = this.props.title;
      return React.createElement(
        searchBarMainDiv,
        null,
        React.createElement(IconDivForMobile, {
          className: "IconDivForMobile",
          onClick: this.handleClick
        }),
        React.createElement(
          searchBar,
          {
            show: show,
            needContent: needContent,
            className: "searchBar"
          },
          React.createElement(
            searchBarSecDiv,
            {
              className: "searchBarSecDiv",
              onClick: this.handleClick,
              show: show
            },
            React.createElement(btnIcon, { className: "btnIcon", show: show }),
            React.createElement(
              "form",
              null,
              React.createElement(searchInput, {
                id: "tb-css-desktop-search-input",
                type: "text",
                autoComplete: "off",
                placeholder: placeholder,
                style: { border: "0px" },
                onChange: this.onChange,
                value: searchText$$1
              })
            )
          ),
          needContent ? React.createElement(
            suggestSearch,
            { id: "suggestSearch", show: show },
            React.createElement(
              resultSuggestListTable,
              { className: "resultSuggestListTable" },
              React.createElement(
                "tbody",
                null,
                React.createElement(
                  "tr",
                  null,
                  React.createElement(
                    "td",
                    null,
                    React.createElement(
                      searchHD,
                      {
                        "data-bind": "text: searchHD",
                        className: "searchHD"
                      },
                      React.createElement(
                        "span",
                        null,
                        title
                      )
                    ),
                    React.createElement(btnCloseSearch, {
                      needContent: needContent,
                      className: "btnCloseSearch",
                      onClick: this.handleClose,
                      displayBtnCloseSearch: true
                    })
                  )
                ),
                React.createElement(
                  "tr",
                  null,
                  React.createElement(
                    "td",
                    null,
                    React.createElement(
                      resultSuggestList,
                      {
                        "data-bind": "foreach: resultSuggestList",
                        className: "resultSuggestList"
                      },
                      List ? List.map(function (item) {
                        return React.createElement(
                          resultSuggestName,
                          {
                            key: item.name,
                            className: "resultSuggestName"
                          },
                          React.createElement(
                            "div",
                            { "data-bind": item.bind },
                            item.name
                          )
                        );
                      }) : ""
                    )
                  )
                )
              )
            ),
            React.createElement(
              "table",
              null,
              React.createElement(
                "tbody",
                null,
                React.createElement(
                  "tr",
                  null,
                  React.createElement(
                    "td",
                    { colSpan: "2" },
                    React.createElement(
                      searchText,
                      {
                        "data-bind": "text: searchText",
                        className: "searchText"
                      },
                      needSearchText && searchText$$1.length !== 0 ? "\u6B63\u5728\u641C\u5C0B \"" + searchText$$1 + "\" ?" : ""
                    )
                  )
                )
              ),
              React.createElement("tbody", { "data-bind": "foreach: resultList" })
            ),
            React.createElement("div", { className: "txt", "data-bind": "text: msg" })
          ) : React.createElement(btnCloseSearch, {
            needContent: needContent,
            className: "btnCloseSearch",
            onClick: this.handleClose,
            displayBtnCloseSearch: false
          })
        )
      );
    }
  }]);

  return SearchBar;
}(Component);

SearchBar.defaultProps = {
  needContent: false,
  needSearchText: false,
  handleSearch: function handleSearch() {},
  placeholder: "",
  searchText: ""
};

SearchBar.propTypes = {
  show: PropTypes.bool,
  searchText: PropTypes.string,
  needContent: PropTypes.bool,
  needSearchText: PropTypes.bool,
  List: PropTypes.array,
  title: PropTypes.string
};

var _templateObject$8 = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  border: none;\n  border-radius: 0;\n  font-size: ", ";\n  font-weight: ", ";\n  padding: ", ";\n  &:focus {\n    outline: 0;\n  }\n  appearance: none;\n"], ["\n  width: ", ";\n  height: ", ";\n  border: none;\n  border-radius: 0;\n  font-size: ", ";\n  font-weight: ", ";\n  padding: ", ";\n  &:focus {\n    outline: 0;\n  }\n  appearance: none;\n"]),
    _templateObject2$5 = _taggedTemplateLiteral(["\n  width: ", ";\n  line-height: ", ";\n  height: ", ";\n  padding: ", "\n  font-size: ", ";\n  vertical-align: baseline;\n  text-align: center;\n  position: relative;\n"], ["\n  width: ", ";\n  line-height: ", ";\n  height: ", ";\n  padding: ", "\n  font-size: ", ";\n  vertical-align: baseline;\n  text-align: center;\n  position: relative;\n"]);

var Select = styled.select(_templateObject$8, function (props) {
  return props.width ? props.width : "150px";
}, function (props) {
  return props.height ? props.height : "40px";
}, function (props) {
  return props.fontSize ? props.fontSize : "14px";
}, function (props) {
  return props.fontWeight ? props.fontWeight : "0";
}, function (props) {
  return props.padding ? props.padding : "0 0 0 7px";
});

var Text = styled.span(_templateObject2$5, function (props) {
  return props.titleWidth ? props.titleWidth : "100px";
}, function (props) {
  return props.height ? props.height : "40px";
}, function (props) {
  return props.height ? props.height : "40px";
}, function (props) {
  return props.padding ? props.padding : "0";
}, function (props) {
  return props.titleFontSize ? props.titleFontSize : "14px";
});

var arrowImg = "data:image/png;base64,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";

var Select$1 = function (_Component) {
  _inherits(Select$$1, _Component);

  function Select$$1() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Select$$1);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Select$$1.__proto__ || _Object$getPrototypeOf(Select$$1)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (e) {
      var selectValue = _this.props.selectValue;

      if (selectValue) {
        selectValue(e.target);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Select$$1, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          id = _props.id,
          className = _props.className,
          name = _props.name,
          val = _props.val,
          dataList = _props.dataList,
          warning = _props.warning,
          title = _props.title,
          width = _props.width,
          height = _props.height,
          margin = _props.margin,
          fontSize = _props.fontSize,
          fontWeight = _props.fontWeight,
          titleWidth = _props.titleWidth,
          titleFontSize = _props.titleFontSize,
          padding = _props.padding;

      var text = function text() {
        if (title) {
          return React.createElement(
            Text,
            {
              titleWidth: titleWidth,
              height: height,
              titleFontSize: titleFontSize,
              padding: padding
            },
            title
          );
        } else {
          return;
        }
      };
      return React.createElement(
        "div",
        {
          style: {
            width: title ? width ? width : "150px" : width ? width : "100px",
            display: "flex",
            border: warning ? "1px solid red" : "1px solid #e9e7e8",
            margin: margin ? margin : "5px",
            position: "relative"
          }
        },
        text(),
        React.createElement(
          Select,
          {
            name: name,
            id: id,
            calss: className,
            warning: warning,
            width: width,
            height: height,
            fontSize: fontSize,
            fontWeight: fontWeight,
            title: title,
            value: val,
            onChange: this.onChange,
            padding: padding
          },
          dataList.map(function (item, i) {
            return React.createElement(
              "option",
              { key: i, value: item.option },
              item.option
            );
          })
        ),
        React.createElement(
          "span",
          {
            style: {
              position: "absolute",
              width: "8px",
              height: "8px",
              top: "10px",
              right: "7px",
              pointerEvents: "none"
            }
          },
          React.createElement("img", { src: arrowImg, style: { width: "8px", height: "8px" } })
        )
      );
    }
  }]);

  return Select$$1;
}(Component);

var defineProperty$4 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _defineProperty2 = _interopRequireDefault(defineProperty$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};
});

var _defineProperty = unwrapExports(defineProperty$4);

var _extends$3 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _assign2 = _interopRequireDefault(assign$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};
});

var _extends$4 = unwrapExports(_extends$3);

function styleInject(css$$1, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css$$1 || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css$$1;
  } else {
    style.appendChild(document.createTextNode(css$$1));
  }
}

var css$1 = " .SliderSet_imgLightBox_mobile__1SGwd {\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background: white;\r\n  position: fixed;\r\n  top: 0;\r\n  left: -105%;\r\n  z-index: 99;\r\n  padding-top: 40px;\r\n}\r\n .SliderSet_light-box-close__2TdaH {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 60px;\r\n  height: 60px;\r\n  line-height: 60px;\r\n  font-size: 30px;\r\n  background: white;\r\n}\r\n .SliderSet_videoDialog__3rzx5 {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 2;\r\n  background: white;\r\n}\r\n .SliderSet_videoMobileBtn__3rO0M {\r\n  width: 130px;\r\n  height: 40px;\r\n  border: 0px solid #e9e7e8;\r\n}\r\n .SliderSet_BtnImg__mA1Po {\r\n  width: 50px;\r\n  height: 40px;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n.SliderSet_BtnImg__mA1Po::after {\r\n  content: \"\";\r\n  display: block;\r\n  width: 40px;\r\n  height: 40px;\r\n  position: absolute;\r\n  background: url(\"../assets/play-btn-web.png\") no-repeat center center;\r\n  z-index: 2;\r\n}\r\n .SliderSet_BtnImgText__I6C8p {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n .SliderSet_videoItem__18obH {\r\n  width: 98.5%;\r\n  height: 100%;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n .SliderSet_videoCloseBtn__3FQmA {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  width: 30px;\r\n  height: 30px;\r\n  background-size: 20px 20px;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  cursor: pointer;\r\n  z-index: 99999;\r\n}\r\n .SliderSet_videoClose__2mIHs {\r\n  font-size: 30px;\r\n}\r\n@font-face {\r\n  font-family: \"FontAwesome\";\r\n  font-weight: normal;\r\n  font-style: normal;\r\n  src: url(\"../assets/font/fontawesome-webfont.eot\");\r\n  src: url(\"../assets/font/fontawesome-webfont-1.eot\")\r\n      format(\"embedded-opentype\"),\r\n    url(\"../assets/font/fontawesome-webfont-2.woff2\") format(\"woff2\"),\r\n    url(\"../assets/font/fontawesome-webfont-3.woff\") format(\"woff\"),\r\n    url(\"../assets/font/fontawesome-webfont.ttf\") format(\"truetype\"),\r\n    url(\"http://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/fonts/fontawesome-webfont.svg?v=4.3.0#fontawesomeregular\")\r\n      format(\"svg\");\r\n}\r\n .SliderSet_imgSize__3Ae31 {\r\n  max-width: 594px !important;\r\n  height: 594px;\r\n  outline: 0;\r\n  overflow: hidden;\r\n}\r\n .SliderSet_imgDiv__1Abhn {\r\n  cursor: crosshair;\r\n  outline: none;\r\n  padding-left: -8px;\r\n}\r\n .SliderSet_videoDiv__1vlXp {\r\n  cursor: default;\r\n}\r\n .SliderSet_imgSize__3Ae31 img {\r\n  max-width: 100%;\r\n  margin: 0 auto;\r\n}\r\n .SliderSet_imgSize_mobile__7QSnP {\r\n  max-width: 700px !important;\r\n  height: auto;\r\n  cursor: crosshair;\r\n  outline: 0;\r\n  overflow: hidden;\r\n  display: none !important;\r\n}\r\n .SliderSet_imgSize_mobile__7QSnP img {\r\n  width: 100% !important;\r\n}\r\n .SliderSet_imgSize_mobile__7QSnP video {\r\n  width: 100% !important;\r\n  height: auto;\r\n}\r\n .SliderSet_small-slider__3MesC {\r\n  display: flex;\r\n  margin-top: 10px;\r\n}\r\n .SliderSet_imgSize2__2cDXN {\r\n  max-width: 96px !important;\r\n  height: atuo;\r\n  border: 1px solid #e9e7e8;\r\n  cursor: pointer;\r\n  transition: border 0.5s;\r\n}\r\n.SliderSet_imgSize2__2cDXN:focus {\r\n  border: 1px solid #c69967;\r\n  outline: 0;\r\n}\r\n .SliderSet_imgSize2__2cDXN img {\r\n  width: 100%;\r\n}\r\n .SliderSet_imageSize2VideoDiv__1ac4Z {\r\n  position: relative;\r\n  left: 10%;\r\n  max-width: 96px !important;\r\n  height: 96px;\r\n  cursor: pointer;\r\n  transition: border 0.5s;\r\n}\r\n .SliderSet_imageSize2VideoDiv__1ac4Z:focus {\r\n  border: 1px solid #c69967;\r\n  outline: 0;\r\n}\r\n\r\n .SliderSet_imageSize2VideoDiv__1ac4Z::after {\r\n  content: \"\";\r\n  display: block;\r\n  width: 40px;\r\n  height: 40px;\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  margin-top: -20px;\r\n  margin-left: -20px;\r\n  background: url(\"../assets/play-btn-web.png\") no-repeat center center;\r\n  background-size: 35px 35px;\r\n  pointer-events: none;\r\n  z-index: 9999;\r\n}\r\n .SliderSet_imageSize2Video__2g-vx {\r\n  width: 100%;\r\n  height: auto;\r\n}\r\n .SliderSet_AsNavForTwo__28LhC {\r\n  width: 72% !important;\r\n}\r\n .SliderSet_slider_mobile__2z2Fz {\r\n  display: none !important;\r\n}\r\n .SliderSet_slick-prev__WjQE1,\r\n .SliderSet_slick-next__1IKsR {\r\n  z-index: 10;\r\n  font-size: 0;\r\n  line-height: 0;\r\n  position: absolute;\r\n  top: 50%;\r\n  display: block;\r\n  width: 20px;\r\n  height: 20px;\r\n  padding: 0;\r\n  -webkit-transform: translate(0, -50%);\r\n  -ms-transform: translate(0, -50%);\r\n  transform: translate(0, -50%);\r\n  cursor: pointer;\r\n  color: transparent;\r\n  border: none;\r\n  outline: none;\r\n  background: transparent;\r\n}\r\n .SliderSet_slick-prev__WjQE1:hover,\r\n .SliderSet_slick-prev__WjQE1:focus,\r\n .SliderSet_slick-next__1IKsR:hover,\r\n .SliderSet_slick-next__1IKsR:focus {\r\n  color: transparent;\r\n  outline: none;\r\n  background: transparent;\r\n}\r\n .SliderSet_slick-prev__WjQE1:hover:before,\r\n .SliderSet_slick-prev__WjQE1:focus:before,\r\n .SliderSet_slick-next__1IKsR:hover:before,\r\n .SliderSet_slick-next__1IKsR:focus:before {\r\n  opacity: 1;\r\n}\r\n .SliderSet_slick-prev__WjQE1.SliderSet_slick-disabled__1ZO_8:before,\r\n .SliderSet_slick-next__1IKsR.SliderSet_slick-disabled__1ZO_8:before {\r\n  opacity: 0.25;\r\n}\r\n\r\n .SliderSet_sliderDiv__2Qjqz .SliderSet_slick-prev__WjQE1:before,\r\n .SliderSet_sliderDiv__2Qjqz .SliderSet_slick-next__1IKsR:before,\r\n .SliderSet_small-slider__3MesC .SliderSet_slick-prev__WjQE1:before,\r\n .SliderSet_small-slider__3MesC .SliderSet_slick-next__1IKsR:before {\r\n  font-family: \"FontAwesome\";\r\n  font-size: 30px;\r\n  line-height: 1;\r\n  color: #000 !important;\r\n  opacity: 0.75;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n .SliderSet_slick-prev__WjQE1 {\r\n  left: -15px;\r\n}\r\n[dir=\"rtl\"] .SliderSet_slick-prev__WjQE1 {\r\n  right: -25px;\r\n  left: auto;\r\n}\r\n .SliderSet_slick-prev__WjQE1:before {\r\n  content: \"\\F104\" !important;\r\n}\r\n[dir=\"rtl\"] .SliderSet_slick-prev__WjQE1:before {\r\n  content: \"\\F104\";\r\n}\r\n\r\n .SliderSet_slick-next__1IKsR {\r\n  right: -25px;\r\n}\r\n[dir=\"rtl\"] .SliderSet_slick-next__1IKsR {\r\n  right: auto;\r\n  left: -25px;\r\n}\r\n .SliderSet_slick-next__1IKsR:before {\r\n  content: \"\\F105\" !important;\r\n}\r\n[dir=\"rtl\"] .SliderSet_slick-next__1IKsR:before {\r\n  content: \"\\F105\";\r\n}\r\n .SliderSet_slick-arrow__1fRGu {\r\n  z-index: 2;\r\n  background: transparent !important;\r\n}\r\n\r\n .SliderSet_zoomup__2RBQ- {\r\n  display: none !important;\r\n}\r\n .SliderSet_slick-list__Ff29f {\r\n  height: auto !important;\r\n}\r\n .SliderSet_mobileBtn__2zlT7 {\r\n  display: none !important;\r\n}\r\n@media only screen and (max-width: 1200px) {\r\n  .SliderSet_imgSize_mobile__7QSnP {\r\n    display: block !important;\r\n  }\r\n  .SliderSet_slider_web__22dwx {\r\n    display: none !important;\r\n  }\r\n  .SliderSet_slider_mobile__2z2Fz {\r\n    display: block !important;\r\n  }\r\n  .SliderSet_AsNavForTwo__28LhC {\r\n    width: 0% !important;\r\n    height: 50px;\r\n  }\r\n  .SliderSet_mobileBtn__2zlT7 {\r\n    display: block !important;\r\n  }\r\n  .SliderSet_small-slider__3MesC {\r\n    display: none !important;\r\n  }\r\n  .SliderSet_small-slider__3MesC button {\r\n    display: none !important;\r\n  }\r\n  .SliderSet_imageSize2VideoDiv__1ac4Z {\r\n    display: none !important;\r\n  }\r\n}\r\n@media only screen and (max-width: 980px) {\r\n  .SliderSet_videoItem__18obH {\r\n    width: 100%;\r\n    max-width: 700px !important;\r\n    max-height: 700px !important;\r\n  }\r\n}\r\n\r\n.SliderSet_slick-slide__RaI7T img {\r\n  display: block;\r\n  max-width: 100%\r\n}\r\n ";
var SliderCss = { "imgLightBox_mobile": "SliderSet_imgLightBox_mobile__1SGwd", "light-box-close": "SliderSet_light-box-close__2TdaH", "videoDialog": "SliderSet_videoDialog__3rzx5", "videoMobileBtn": "SliderSet_videoMobileBtn__3rO0M", "BtnImg": "SliderSet_BtnImg__mA1Po", "BtnImgText": "SliderSet_BtnImgText__I6C8p", "videoItem": "SliderSet_videoItem__18obH", "videoCloseBtn": "SliderSet_videoCloseBtn__3FQmA", "videoClose": "SliderSet_videoClose__2mIHs", "imgSize": "SliderSet_imgSize__3Ae31", "imgDiv": "SliderSet_imgDiv__1Abhn", "videoDiv": "SliderSet_videoDiv__1vlXp", "imgSize_mobile": "SliderSet_imgSize_mobile__7QSnP", "small-slider": "SliderSet_small-slider__3MesC", "imgSize2": "SliderSet_imgSize2__2cDXN", "imageSize2VideoDiv": "SliderSet_imageSize2VideoDiv__1ac4Z", "imageSize2Video": "SliderSet_imageSize2Video__2g-vx", "AsNavForTwo": "SliderSet_AsNavForTwo__28LhC", "slider_mobile": "SliderSet_slider_mobile__2z2Fz", "slick-prev": "SliderSet_slick-prev__WjQE1", "slick-next": "SliderSet_slick-next__1IKsR", "slick-disabled": "SliderSet_slick-disabled__1ZO_8", "sliderDiv": "SliderSet_sliderDiv__2Qjqz", "slick-arrow": "SliderSet_slick-arrow__1fRGu", "zoomup": "SliderSet_zoomup__2RBQ-", "slick-list": "SliderSet_slick-list__Ff29f", "mobileBtn": "SliderSet_mobileBtn__2zlT7", "slider_web": "SliderSet_slider_web__22dwx", "slick-slide": "SliderSet_slick-slide__RaI7T" };
styleInject(css$1);

var _ref$3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
  width: 92,
  height: 92,
  id: "img1",
  href: "data:image/png;base64,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"
}));

var _ref2$1 = /*#__PURE__*/React.createElement("use", {
  id: "Layer 0",
  href: "#img1",
  x: 2,
  y: 1
});

var closeBtn$2 = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2096%2096%22%20width%3D%2296%22%20height%3D%2296%22%3E%20%3Cdefs%3E%20%20%3Cimage%20width%3D%2292%22%20height%3D%2292%22%20id%3D%22img1%22%20href%3D%22data%3Aimage%2Fpng%3Bbase64%2CiVBORw0KGgoAAAANSUhEUgAAAFwAAABcCAMAAADUMSJqAAAAAXNSR0IB2cksfwAAAppQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA1tr9yQAAAN50Uk5TAEyyCE%2F5%2F7cGqVNRtbBSVPqxtE6rrge2rAUJuLOqAwq5vaW%2FuqIMwr6fDcPAnQEPxAubx6gEmBDJpg7FlBHMo8iREs2gyo8Uz56NFdDOihbTmROGF9WV0YIZ1pPUgBrYkH0b2RjXeh3cdx%2Fdh9pzIN%2BEHHEh4IH%2BbyPiayXj4Wgn5XgiZSjmdCRiKudy%2FWEr6W78Xi7qbCnoWzDraVcx7GYsVTPuZPs07%2B048F8yOks88Vk1dfNWOfI%2B%2BEhN9fRaO102ai8tcHZ55CZ8f4OF3okei46XjNICpMuhwbtQyeM40AAABOJJREFUeJy12vlbFVUYB%2FDDxRlGwIVUwBBummKmct0xFbfSLDJcU0zLfQEXUhJFRUhT0TRFScCUJJUMF8xIMdvL9s0W9%2F%2FFc%2B98z%2BUus5wzczw%2F%2BNw5530%2Fc8%2F7nofnmTsSQkeMJ5Y8qtFOUeM0uaTWPl7%2FkKCoqpooVdc6qEpH%2F4dOnVX%2FSJKoa49RUOlCP3VV9dFNmp6cEgCVGHobD%2FTU7nLsx9MA9qAXWiIu0jNk2N4nwMUFjqAWh8v2EnRvT2CJyfpELLtZL9e690lQnmALvb0x1celntkXUIeQ4%2BF9CpP9XOlP92eHI%2BzoeQdgemCWc9s3CEjXiIM3mG1oiGPdNxTEsOGRS5nstiMc6tkjATxjUNpRo7E4xpGeMxbp4wzb5huP5QkO9InPIvk5kyPhm4SAycL281OQ%2BoLpcctmW3tR0M59ieM45ExF0MtCdt40pE23LOgM9hVmCtizZiPpFZtm5c5B4FxuO38eUl61PQi58xG6gNN%2B7XUkLOQ4ZHlsk4u47MVLhA7B0mUIX84RvGKl4BHIZ19mlW1oQSFCV3PadKtrkLLWJnBdEQLf4LYJWc82u8EyrPhNhG0UsGkpsd2STRZBm0uFWt82CrDhki2mIVu3CTQ%2BfBSXQd9uElBeAfstYZuQHfhiJTsNl9%2FeBXu3A5uQPUyvNFjcuw%2F2O45sWlRsfP%2BBqKV3D%2BLGhxzatKzYetXhiIUj1bDfc2wTcrQGem3YdN0x2O%2B7sGlp8RWrjodMnqiH%2FYErm5CTTG8ITn14Cq047dKm5UUJzuAphzR%2BhNtFt1l81J3VMf0ph3zcBPucBJuQ8yhD4CnnArNrbfP4RiNA5SJpvgT7E0k2IZeZ%2FmkLGvCZNJuQK9AxOneSaNNSXw2xlQSpNiHNLW12O8k2Ia3XWE1ipNvkcwX4tVbp9kUlWJaWZsn29TZbVa9ekGonhNqq2nRFoh0P%2B4tV%2BNB0WZrdoP8ko37ZGix9U6Mk%2B3gVSu1vZBfop85Lsb%2BCfenrwGVH6PV1EuxvqiKaGH9Gnzh2xLV9jtnfBqcaMFV90qVduR8lDm0ga0L1Xlf26RKdORvevlroNUdd2Nth15%2BIWDgMfVe5Y%2Fs72NXfRy0dQLkqtjq0D8E%2B%2BIPBYiUWt%2B1xZN9Aeo1x23ZiuXSHA3s3%2FkjtM2saa0jZOmH7R9gV5aYhW6AXFQjaP8H%2B%2BReLoE3QC1cI2b%2FCLrVu1w2ErVwvYP%2BGpDK7Zq1F4JrF3PbvSCkqtg1lrVmSz2n%2FgYQ%2FeRq1HMHLlnLZfyG88G%2Bu8EUIn53HEXyTlZG3SQuQMC3XLjLrH1ZE%2FhbNRcocGz1rAishb4P8YyaSpsywtMcgbB5fe9hgbZqaY2H%2Fi6D5s4RsQv5D4thsU3s6Qv63bU3UmIzUST7j9VsDWenEbZK1EMnjDfWMfqxwlm0x1Vm7Ro8ysPuwsk10YlN9BID%2BmVH2bSzdMW2JrT4ERF9vhD3MsmScOmvagDB9eDormAubHgnWtp4hupaKyUEGzRAZGXcB9Q7qWjdWrKhWCOu9QKXhxbOWhIl7g93aIc3TXzwHXrtGFsqFztrnf%2FEcm4KL%2B1JsejhYA5M0wt7jpkmyQ1qYTmL0p5A4iW%2F%2B0UT%2FTxsPAm%2Fmk%2BXZePGs%2F7RBn6A8sv9PQUrwp434VMk2PSae6%2FTfh6z1%2FXqohGO5AAAAAElFTkSuQmCC%22%2F%3E%20%3C%2Fdefs%3E%20%3Cstyle%3E%20%20tspan%20%7B%20white-space%3Apre%20%7D%20%3C%2Fstyle%3E%20%3Cuse%20id%3D%22Layer%200%22%20href%3D%22%23img1%22%20x%3D%222%22%20y%3D%221%22%20%2F%3E%3C%2Fsvg%3E";

var playBtn = "data:image/png;base64,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";

function SampleNextArrow(props) {
  var className = props.className,
      style = props.style,
      onClick = props.onClick;

  return React.createElement(
    "div",
    {
      className: className,
      style: _extends$4({}, style, { display: "block" }),
      onClick: onClick
    },
    React.createElement("i", {
      style: { fontSize: "20px", color: "black" },
      className: "fas fa-angle-right"
    })
  );
}

function SamplePrevArrow(props) {
  var className = props.className,
      style = props.style,
      onClick = props.onClick;

  return React.createElement(
    "div",
    {
      className: className,
      style: _extends$4({}, style, { display: "block" }),
      onClick: onClick
    },
    React.createElement("i", {
      style: { fontSize: "20px", color: "black" },
      className: "fas fa-angle-left"
    })
  );
}

var SliderSet = function (_Component) {
  _inherits(SliderSet, _Component);

  function SliderSet(props) {
    _classCallCheck(this, SliderSet);

    var _this = _possibleConstructorReturn(this, (SliderSet.__proto__ || _Object$getPrototypeOf(SliderSet)).call(this, props));

    _this.handleClick = function (e) {
      _this.slider1.slickGoTo(e);
    };

    _this.openVideo = function () {
      _this.setState({
        openVideoDialog: true
      });
      if (_this.state.openVideoDialog) {
        _this.videoDialog.load();
        _this.videoDialog.play();
      }
    };

    _this.closeVideo = function () {
      _this.setState({
        openVideoDialog: false
      });
    };

    _this.showLightBox = function (id) {
      _this.setState({
        showLightBox: true,
        LightBoxId: id
      });
    };

    _this.mobileOpenVideo = function () {
      _this.setState({
        openVideoDialog: true
      });
      if (_this.state.openVideoDialog) {
        _this.videoDialog.load();
        _this.videoDialog.play();
      }
    };

    _this.state = {
      nav1: null,
      nav2: null,
      nav3: null,
      openVideoDialog: false,
      showLightBox: false,
      LightBoxId: 0
    };
    _this.handleClick = _this.handleClick.bind(_this);
    _this.openVideo = _this.openVideo.bind(_this);
    return _this;
  }

  _createClass(SliderSet, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        nav1: this.slider1,
        nav2: this.slider2,
        nav3: this.slider3
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _React$createElement,
          _React$createElement2;

      var _props = this.props,
          dots = _props.dots,
          infinite = _props.infinite;

      var focusSettings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: infinite,
        dots: dots,
        arrow: true,
        nextArrow: React.createElement(SampleNextArrow, null),
        prevArrow: React.createElement(SamplePrevArrow, null)
      };
      var thumbnailSettings = {
        focusOnSelect: true,
        adaptiveHeight: true,
        arrows: true,
        dots: false,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: 0
      };
      var BigimgList = function BigimgList() {
        var imgListItem = _this2.props.ImageData.images;
        return imgListItem.map(function (productImg, id) {
          return React.createElement(
            "div",
            { className: SliderCss.imgDiv, key: id },
            _this2.props.showZoom ? React.createElement(Zoom, {
              img: productImg.zoomInUrl,
              key: productImg.zoomInUrl,
              zoomScale: 2,
              height: 594,
              width: 680,
              transitionTime: 0.5
            }) : React.createElement(
              "div",
              { style: { margin: "0 auto" } },
              React.createElement("img", {
                style: { maxWidth: "100%" },
                src: productImg.displayUrl,
                alt: "",
                key: productImg.displayUrl
              })
            )
          );
        });
      };
      var smallImgList = function smallImgList() {
        if (!_this2.props.ImageData.images) return;
        var imgListItem = _this2.props.ImageData.images;
        return imgListItem.map(function (productImg, id) {
          return React.createElement(
            "div",
            { className: SliderCss.imgSize2, key: id },
            React.createElement("img", {
              style: { maxWidth: "100%", margin: "0 auto" },
              src: "" + productImg.zoomOutUrl,
              alt: "",
              key: productImg.zoomOutUrl,
              onClick: function onClick() {
                return _this2.handleClick(id);
              }
            })
          );
        });
      };

      var VideoPlayBtn = function VideoPlayBtn() {
        var productData = _this2.props.ImageData.images;
        var VideoItem = productData.video;
        if (!VideoItem) return;
        return React.createElement(
          "button",
          {
            onClick: _this2.mobileOpenVideo.bind(_this2),
            style: {
              background: "transparent",
              border: "0",
              fontSize: "14px",
              margin: "43px auto 0px"
            },
            className: SliderCss.mobileBtn
          },
          React.createElement(
            "div",
            { className: SliderCss.videoMobileBtn },
            React.createElement("div", { className: SliderCss.BtnImg }),
            React.createElement(
              "span",
              { className: SliderCss.BtnImgText },
              "\u64AD\u653E"
            )
          )
        );
      };
      var VideoDialog = function VideoDialog() {
        if (_this2.state.openVideoDialog) return React.createElement(
          "div",
          { className: SliderCss.videoDialog },
          React.createElement(
            "video",
            {
              className: SliderCss.videoItem,
              ref: function ref(videoDialog) {
                return _this2.videoDialog = videoDialog;
              },
              autoPlay: true
            },
            React.createElement("source", { src: _this2.props.ImageData.video, type: "video/mp4" })
          ),
          React.createElement("div", {
            className: "videoCloseBtn",
            onClick: _this2.closeVideo.bind(_this2)
          })
        );
      };

      return React.createElement(
        "div",
        { className: SliderCss.sliderContainer },
        React.createElement(
          "style",
          null,
          "\n          .videoCloseBtn{\n            background: url(" + closeBtn$2 + ");\n            position: absolute;\n            top: 0;\n            right: 0;\n            width: 30px;\n            height: 30px;\n            background-size: 20px 20px;\n            background-repeat: no-repeat;\n            background-position: center;\n            cursor: pointer;\n            z-index: 99999;\n          }\n          .imageSize2VideoDiv {\n            position: relative;\n            left: 10%;\n            max-width: 96px !important;\n            height: 96px;\n            cursor: pointer;\n            transition: border 0.5s;\n          }\n          .imageSize2VideoDiv::after {\n            content: \"\";\n            display: block;\n            width: 40px;\n            height: 40px;\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            margin-top: -20px;\n            margin-left: -20px;\n            background: url(" + playBtn + ") no-repeat center center;\n            background-size: 35px 35px;\n            pointer-events: none;\n            z-index: 9999;\n          }\n          .imageSize2VideoDiv:focus {\n            border: 1px solid #c69967;\n            outline: 0;\n          }\n          .slick-prev {\n            left: -15px !important;\n          }\n          .small-slider .slick-active  {\n            width:103px !important;\n          }\n        "
        ),
        React.createElement(
          "div",
          (_React$createElement2 = {
            className: SliderCss.sliderDiv
          }, _defineProperty(_React$createElement2, "className", SliderCss.slickPrev), _defineProperty(_React$createElement2, "style", { position: "relative" }), _React$createElement2),
          VideoDialog(),
          React.createElement(
            Slider,
            _extends$4({}, focusSettings, {
              asNavFor: this.state.nav2,
              ref: function ref(slider) {
                return _this2.slider1 = slider;
              },
              className: SliderCss.slider_web
            }),
            BigimgList()
          ),
          React.createElement(
            "div",
            null,
            React.createElement(
              "div",
              { className: "small-slider" },
              React.createElement(
                Slider,
                _extends$4({}, thumbnailSettings, {
                  ref: function ref(slider) {
                    return _this2.slider2 = slider;
                  }
                }),
                this.props.showSmallImg ? smallImgList() : "",
                this.props.showSmallImg ? this.props.showVideo ? React.createElement(
                  "div",
                  (_React$createElement = {
                    className: SliderCss.imageSize2VideoDiv
                  }, _defineProperty(_React$createElement, "className", "imageSize2VideoDiv"), _defineProperty(_React$createElement, "onClick", this.openVideo), _React$createElement),
                  React.createElement(
                    "div",
                    { className: SliderCss.imgSize2 },
                    React.createElement("img", {
                      src: "" + this.props.ImageData.images[0].displayUrl,
                      alt: ""
                    })
                  )
                ) : "" : ""
              ),
              VideoPlayBtn()
            )
          )
        )
      );
    }
  }]);

  return SliderSet;
}(Component);

var arrowImage = "data:image/png;base64,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";

var _templateObject$9 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  cursor: pointer;\n  margin: 0 15px;\n  padding: 25px 0;\n  text-decoration: none;\n  &:hover,\n  &:active,\n  &:focus {\n    text-decoration: none;\n    color: black;\n  }\n"], ["\n  font-size: 14px;\n  cursor: pointer;\n  margin: 0 15px;\n  padding: 25px 0;\n  text-decoration: none;\n  &:hover,\n  &:active,\n  &:focus {\n    text-decoration: none;\n    color: black;\n  }\n"]),
    _templateObject2$6 = _taggedTemplateLiteral(["\n  position: absolute;\n  padding: 35px;\n  /* text-align: center; */\n  top: 70px;\n  left: 0;\n  width: 100%;\n  background: white;\n  border: 1px solid #ccc;\n  opacity: ", ";\n  pointer-events: ", ";\n  transition: all 300ms;\n  color: black;\n"], ["\n  position: absolute;\n  padding: 35px;\n  /* text-align: center; */\n  top: 70px;\n  left: 0;\n  width: 100%;\n  background: white;\n  border: 1px solid #ccc;\n  opacity: ", ";\n  pointer-events: ", ";\n  transition: all 300ms;\n  color: black;\n"]),
    _templateObject3$3 = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  margin-left: 2px;\n  background: url(", ") no-repeat center center;\n  background-size: contain;\n"], ["\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  margin-left: 2px;\n  background: url(", ") no-repeat center center;\n  background-size: contain;\n"]);

var Tag = styled.span(_templateObject$9);

var ColumnContent = styled.div(_templateObject2$6, function (props) {
  return props.showColumnContent ? "1" : "0";
}, function (props) {
  return props.showColumnContent ? "" : "none";
});

var DownArrow = styled.div(_templateObject3$3, arrowImage);

var NavWithColumn = function (_Component) {
  _inherits(NavWithColumn, _Component);

  function NavWithColumn() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NavWithColumn);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NavWithColumn.__proto__ || _Object$getPrototypeOf(NavWithColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showColumnContent: false
    }, _this.show = function () {
      _this.setState({
        showColumnContent: true
      });
    }, _this.unshow = function () {
      _this.setState({
        showColumnContent: false
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // 顯示欄位區塊


  _createClass(NavWithColumn, [{
    key: "render",
    value: function render() {
      return React.createElement(
        Tag,
        { onMouseMove: this.show, onMouseLeave: this.unshow },
        this.props.title,
        React.createElement(DownArrow, null),
        React.createElement(
          ColumnContent,
          { showColumnContent: this.state.showColumnContent },
          this.props.children
        )
      );
    }
  }]);

  return NavWithColumn;
}(Component);

var _templateObject$a = _taggedTemplateLiteral(["\n  font-size: 14px;\n  cursor: pointer;\n  margin: 0 15px;\n  text-decoration: none;\n  &:hover,\n  &:active,\n  &:focus {\n    text-decoration: none;\n    color: black;\n  }\n"], ["\n  font-size: 14px;\n  cursor: pointer;\n  margin: 0 15px;\n  text-decoration: none;\n  &:hover,\n  &:active,\n  &:focus {\n    text-decoration: none;\n    color: black;\n  }\n"]);

var Tag$1 = styled.a(_templateObject$a);

var Nav = function (_Component) {
  _inherits(Nav, _Component);

  function Nav() {
    _classCallCheck(this, Nav);

    return _possibleConstructorReturn(this, (Nav.__proto__ || _Object$getPrototypeOf(Nav)).apply(this, arguments));
  }

  _createClass(Nav, [{
    key: "render",
    value: function render() {
      return React.createElement(
        Tag$1,
        { href: this.props.href },
        this.props.title
      );
    }
  }]);

  return Nav;
}(Component);

var _templateObject$b = _taggedTemplateLiteral(["\n  background: ", ";\n  width: 100%;\n  height: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: ", ";\n  top: ", ";\n  left: 0;\n  z-index: ", ";\n  a {\n    color: ", ";\n  }\n"], ["\n  background: ", ";\n  width: 100%;\n  height: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: ", ";\n  top: ", ";\n  left: 0;\n  z-index: ", ";\n  a {\n    color: ", ";\n  }\n"]),
    _templateObject2$7 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  right: 15px;\n  transform: translateY(-50%);\n"], ["\n  position: absolute;\n  top: 50%;\n  right: 15px;\n  transform: translateY(-50%);\n"]),
    _templateObject3$4 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 15px;\n  transform: translateY(-50%);\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 15px;\n  transform: translateY(-50%);\n"]);

var Div$1 = styled.div(_templateObject$b, function (props) {
  return props.background ? props.background : "#f4f4f4";
}, function (props) {
  return props.height ? props.height : "70px";
}, function (props) {
  return props.sticky ? "fixed" : "relative";
}, function (props) {
  return props.sticky ? props.top + "px" : "0";
}, function (props) {
  return props.sticky ? "99" : "10";
}, function (props) {
  return props.color ? props.color : "#000000";
});

var RightSection = styled.div(_templateObject2$7);

var LeftSection = styled.div(_templateObject3$4);

var NavBar = function (_Component) {
  _inherits(NavBar, _Component);

  function NavBar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NavBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NavBar.__proto__ || _Object$getPrototypeOf(NavBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      position: 0,
      sticky: false
    }, _this.componentDidMount = function () {
      // 紀錄navBar的初始位置，減去距離上方的高度。
      if (_this.props.name) {
        var navBarRef = document.getElementById(_this.props.name);
        _this.setState({
          position: navBarRef.offsetTop - _this.props.top
        });
      }

      // 開發模式的sticky
      if (_this.props.devSticky) {
        var mainContentRef = document.getElementById("main-content");
        mainContentRef.addEventListener("scroll", _this.devScrollToSticky.bind(_this, mainContentRef));
      }
      // 一般模式的sticky
      if (_this.props.sticky) {
        window.addEventListener("scroll", _this.scrollToSticky);
      }
    }, _this.devScrollToSticky = function (mainContentRef) {
      if (mainContentRef.scrollTop > _this.state.position) {
        _this.setState({ sticky: true });
      } else {
        _this.setState({ sticky: false });
      }
    }, _this.scrollToSticky = function () {
      if (window.pageYOffset > _this.state.position) {
        _this.setState({ sticky: true });
      } else {
        _this.setState({ sticky: false });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // 開發模式的事件


  // 一般模式的事件


  _createClass(NavBar, [{
    key: "render",
    value: function render() {
      var navbarLists = this.props.navbarLists ? this.props.navbarLists : [];
      var titleKey = this.props.titleKey ? this.props.titleKey : "titleName";
      var columnKey = this.props.columnKey ? this.props.columnKey : "subitems";
      var componentLists = this.props.componentLists ? this.props.componentLists : [];
      return React.createElement(
        "div",
        null,
        React.createElement(
          Div$1,
          {
            id: this.props.name,
            height: this.props.height,
            sticky: this.state.sticky,
            top: this.props.top,
            background: this.props.background,
            color: this.props.color
          },
          this.props.leftSection ? React.createElement(
            LeftSection,
            null,
            this.props.leftSection
          ) : null,
          React.createElement(
            "div",
            null,
            navbarLists.map(function (data, i) {
              return data[columnKey] ? React.createElement(
                NavWithColumn,
                { title: data[titleKey], key: i },
                componentLists.map(function (item, k) {
                  return item[titleKey] === data[titleKey] ? React.createElement(
                    "div",
                    { key: k },
                    item.component
                  ) : null;
                })
              ) : React.createElement(Nav, { href: "#", title: data[titleKey], key: i });
            })
          ),
          this.props.rightSection ? React.createElement(
            RightSection,
            null,
            this.props.rightSection
          ) : null
        ),
        React.createElement("div", { style: { height: this.state.sticky ? this.props.height : "0" } })
      );
    }
  }]);

  return NavBar;
}(Component);

var runtime = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = module.exports;

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);
});

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

var runtimeModule = runtime;

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

var regenerator = runtimeModule;

// getting tag from 19.1.3.6 Object.prototype.toString()

var TAG$1 = _wks('toStringTag');
// ES3 wrong here
var ARG = _cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

var _classof = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG$1)) == 'string' ? T
    // builtinTag case
    : ARG ? _cof(O)
    // ES3 arguments fallback
    : (B = _cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

var _anInstance = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

// call something on iterator step with safe closing on error

var _iterCall = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(_anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) _anObject(ret.call(iterator));
    throw e;
  }
};

// check on default Array iterator

var ITERATOR$1 = _wks('iterator');
var ArrayProto = Array.prototype;

var _isArrayIter = function (it) {
  return it !== undefined && (_iterators.Array === it || ArrayProto[ITERATOR$1] === it);
};

var ITERATOR$2 = _wks('iterator');

var core_getIteratorMethod = _core.getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$2]
    || it['@@iterator']
    || _iterators[_classof(it)];
};

var _forOf = createCommonjsModule(function (module) {
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : core_getIteratorMethod(iterable);
  var f = _ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (_isArrayIter(iterFn)) for (length = _toLength(iterable.length); length > index; index++) {
    result = entries ? f(_anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = _iterCall(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;
});

// 7.3.20 SpeciesConstructor(O, defaultConstructor)


var SPECIES = _wks('species');
var _speciesConstructor = function (O, D) {
  var C = _anObject(O).constructor;
  var S;
  return C === undefined || (S = _anObject(C)[SPECIES]) == undefined ? D : _aFunction(S);
};

// fast apply, http://jsperf.lnkit.com/fast-apply/5
var _invoke = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};

var process = _global.process;
var setTask = _global.setImmediate;
var clearTask = _global.clearImmediate;
var MessageChannel = _global.MessageChannel;
var Dispatch = _global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      _invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (_cof(process) == 'process') {
    defer = function (id) {
      process.nextTick(_ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(_ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = _ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (_global.addEventListener && typeof postMessage == 'function' && !_global.importScripts) {
    defer = function (id) {
      _global.postMessage(id + '', '*');
    };
    _global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in _domCreate('script')) {
    defer = function (id) {
      _html.appendChild(_domCreate('script'))[ONREADYSTATECHANGE] = function () {
        _html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(_ctx(run, id, 1), 0);
    };
  }
}
var _task = {
  set: setTask,
  clear: clearTask
};

var macrotask = _task.set;
var Observer = _global.MutationObserver || _global.WebKitMutationObserver;
var process$1 = _global.process;
var Promise$1 = _global.Promise;
var isNode = _cof(process$1) == 'process';

var _microtask = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process$1.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process$1.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(_global.navigator && _global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise$1.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(_global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};

// 25.4.1.5 NewPromiseCapability(C)


function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = _aFunction(resolve);
  this.reject = _aFunction(reject);
}

var f$7 = function (C) {
  return new PromiseCapability(C);
};

var _newPromiseCapability = {
	f: f$7
};

var _perform = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

var navigator = _global.navigator;

var _userAgent = navigator && navigator.userAgent || '';

var _promiseResolve = function (C, x) {
  _anObject(C);
  if (_isObject(x) && x.constructor === C) return x;
  var promiseCapability = _newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var _redefineAll = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else _hide(target, key, src[key]);
  } return target;
};

var SPECIES$1 = _wks('species');

var _setSpecies = function (KEY) {
  var C = typeof _core[KEY] == 'function' ? _core[KEY] : _global[KEY];
  if (_descriptors && C && !C[SPECIES$1]) _objectDp.f(C, SPECIES$1, {
    configurable: true,
    get: function () { return this; }
  });
};

var ITERATOR$3 = _wks('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR$3]();
  riter['return'] = function () { SAFE_CLOSING = true; };
} catch (e) { /* empty */ }

var _iterDetect = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR$3]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR$3] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

var task = _task.set;
var microtask = _microtask();




var PROMISE = 'Promise';
var TypeError$1 = _global.TypeError;
var process$2 = _global.process;
var versions = process$2 && process$2.versions;
var v8 = versions && versions.v8 || '';
var $Promise = _global[PROMISE];
var isNode$1 = _classof(process$2) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper$1;
var newPromiseCapability = newGenericPromiseCapability = _newPromiseCapability.f;

var USE_NATIVE$1 = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[_wks('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode$1 || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && _userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return _isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$1('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(_global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = _perform(function () {
        if (isNode$1) {
          process$2.emit('unhandledRejection', value, promise);
        } else if (handler = _global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = _global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode$1 || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(_global, function () {
    var handler;
    if (isNode$1) {
      process$2.emit('rejectionHandled', promise);
    } else if (handler = _global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError$1("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, _ctx($resolve, wrapper, 1), _ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE$1) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    _anInstance(this, $Promise, PROMISE, '_h');
    _aFunction(executor);
    Internal.call(this);
    try {
      executor(_ctx($resolve, this, 1), _ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = _redefineAll($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(_speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode$1 ? process$2.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = _ctx($resolve, promise, 1);
    this.reject = _ctx($reject, promise, 1);
  };
  _newPromiseCapability.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper$1
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

_export(_export.G + _export.W + _export.F * !USE_NATIVE$1, { Promise: $Promise });
_setToStringTag($Promise, PROMISE);
_setSpecies(PROMISE);
Wrapper$1 = _core[PROMISE];

// statics
_export(_export.S + _export.F * !USE_NATIVE$1, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
_export(_export.S + _export.F * (_library || !USE_NATIVE$1), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return _promiseResolve(_library && this === Wrapper$1 ? $Promise : this, x);
  }
});
_export(_export.S + _export.F * !(USE_NATIVE$1 && _iterDetect(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = _perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      _forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = _perform(function () {
      _forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

_export(_export.P + _export.R, 'Promise', { 'finally': function (onFinally) {
  var C = _speciesConstructor(this, _core.Promise || _global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return _promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return _promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });

// https://github.com/tc39/proposal-promise-try




_export(_export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = _newPromiseCapability.f(this);
  var result = _perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });

var promise = _core.Promise;

var promise$1 = createCommonjsModule(function (module) {
module.exports = { "default": promise, __esModule: true };
});

unwrapExports(promise$1);

var asyncToGenerator = createCommonjsModule(function (module, exports) {

exports.__esModule = true;



var _promise2 = _interopRequireDefault(promise$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};
});

var _asyncToGenerator = unwrapExports(asyncToGenerator);

var _templateObject$c = _taggedTemplateLiteral(["\n  width: 100%;\n"], ["\n  width: 100%;\n"]),
    _templateObject2$8 = _taggedTemplateLiteral(["\n  width: ", ";\n  border-bottom: ", ";\n  padding: 30px 0;\n"], ["\n  width: ", ";\n  border-bottom: ", ";\n  padding: 30px 0;\n"]),
    _templateObject3$5 = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  margin-right: 0.25em;\n  font-size: ", ";\n  border: ", ";\n  color: ", ";\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n"], ["\n  width: ", ";\n  height: ", ";\n  margin-right: 0.25em;\n  font-size: ", ";\n  border: ", ";\n  color: ", ";\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n"]),
    _templateObject4$2 = _taggedTemplateLiteral(["\n  font-size: 30px;\n  border: ", ";\n  color: ", ";\n  display: inline-block;\n  vertical-align: middle;\n"], ["\n  font-size: 30px;\n  border: ", ";\n  color: ", ";\n  display: inline-block;\n  vertical-align: middle;\n"]),
    _templateObject5$2 = _taggedTemplateLiteral(["\n  max-height: ", ";\n  height: auto;\n  overflow: hidden;\n  transform-origin: top;\n  transition: max-height 0.2s;\n"], ["\n  max-height: ", ";\n  height: auto;\n  overflow: hidden;\n  transform-origin: top;\n  transition: max-height 0.2s;\n"]),
    _templateObject6$2 = _taggedTemplateLiteral(["\n  display: block;\n  width: 100vw;\n  height: 100vh;\n  background: white;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 2147483647;\n  opacity: 0.8;\n"], ["\n  display: block;\n  width: 100vw;\n  height: 100vh;\n  background: white;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 2147483647;\n  opacity: 0.8;\n"]),
    _templateObject7$2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%);\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%);\n"]);

var Div$2 = styled.div(_templateObject$c);

var Step = styled.div(_templateObject2$8, function (props) {
  return props.stepWidth ? props.stepWidth : "400px";
}, function (props) {
  return props.stepBorderBottom ? props.stepBorderBottom : "1px solid rgb(152, 152, 152)";
});

var Number = styled.span(_templateObject3$5, function (props) {
  return _typeof(props.numberStep) === "object" && props.numberStep.numberSize ? props.numberStep.numberSize : "40px";
}, function (props) {
  return _typeof(props.numberStep) === "object" && props.numberStep.numberSize ? props.numberStep.numberSize : "40px";
}, function (props) {
  return _typeof(props.numberStep) === "object" && props.numberStep.numberFontSize ? props.numberStep.numberFontSize : "30px";
}, function (props) {
  return _typeof(props.numberStep) === "object" && props.numberStep.numberBorder ? props.numberStep.numberBorder : "1px solid rgb(152, 152, 152)";
}, function (props) {
  return props.color ? props.color : "#000";
});

var Title = styled.span(_templateObject4$2, function (props) {
  return props.titleBorder ? props.titleBorder : "0";
}, function (props) {
  return props.color ? props.color : "#000";
});

var Content = styled.div(_templateObject5$2, function (props) {
  return props.maxHeight ? "5000px" : "0";
});

var loadingContent = styled.div(_templateObject6$2);

var loadingCenter = styled.div(_templateObject7$2);

var LoadingGif = "data:image/gif;base64,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";

var LoadingWhite = function (_React$Component) {
  _inherits(LoadingWhite, _React$Component);

  function LoadingWhite() {
    _classCallCheck(this, LoadingWhite);

    return _possibleConstructorReturn(this, (LoadingWhite.__proto__ || _Object$getPrototypeOf(LoadingWhite)).apply(this, arguments));
  }

  _createClass(LoadingWhite, [{
    key: "render",
    value: function render() {
      if (!this.props.show) return null;
      return React.createElement(
        loadingContent,
        null,
        React.createElement(
          loadingCenter,
          null,
          React.createElement("img", { src: LoadingGif })
        )
      );
    }
  }]);

  return LoadingWhite;
}(React.Component);

var Step$1 = function (_Component) {
  _inherits(Step$$1, _Component);

  function Step$$1(props) {
    var _this2 = this;

    _classCallCheck(this, Step$$1);

    var _this = _possibleConstructorReturn(this, (Step$$1.__proto__ || _Object$getPrototypeOf(Step$$1)).call(this, props));

    _this.defaultOpenStatus = function () {
      var _this$props = _this.props,
          defaultOpen = _this$props.defaultOpen,
          dataList = _this$props.dataList;

      var defaultOpenStatus = void 0;
      for (var i = 0; i < dataList.length; i++) {
        if (defaultOpen === dataList[i].id) {
          defaultOpenStatus = defaultOpen;
          break;
        }
      }
      _this.setState({ maxHeight: _defineProperty({}, defaultOpenStatus, true) });
    };

    _this.openPurview = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var maxHeight, dataList, purview, i, key;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              maxHeight = _this.state.maxHeight;
              dataList = _this.props.dataList;
              purview = {};
              i = 0;

            case 4:
              if (!(i < dataList.length)) {
                _context.next = 12;
                break;
              }

              key = dataList[i].id;

              purview = _extends$4({}, purview, _defineProperty({}, key, true));

              if (!maxHeight[key]) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("break", 12);

            case 9:
              i++;
              _context.next = 4;
              break;

            case 12:
              _context.next = 14;
              return _this.setState({ openPurview: purview });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.loadingSetTime = function () {
      var loading = _this.props.loading;

      var second = void 0;
      if (typeof loading === "number") {
        second = loading;
      } else {
        second = 1000;
      }
      setTimeout(function () {
        _this.setState({ isLoading: false });
      }, second);
    };

    _this.openContent = function (key) {
      var openPurview = _this.state.openPurview;

      if (openPurview[key]) {
        _this.setState({ maxHeight: _defineProperty({}, key, true), isLoading: true });
        _this.goScroll(key);
        _this.loadingSetTime();
      } else {
        return false;
      }
    };

    _this.goScroll = function (key, i, nextStep) {
      var scrollSetup = _this.props.scrollSetup;

      if (scrollSetup) {
        var element = document.getElementById(key);
        var scrollHeight = element.offsetTop;
        var div = scrollSetup.elementId ? document.getElementById("" + scrollSetup.elementId) : window;
        //設定下一步的高度幅度
        var nextScroll = scrollSetup.nextScrollTop ? scrollSetup.nextScrollTop : 100;
        //設定起始高度
        var startingHeight = scrollSetup.startingHeight ? scrollSetup.startingHeight : 0;
        //判定下一步還是上一步，滾動幅度不一致
        var scrollTop = nextStep ? startingHeight + nextScroll * (i + 1) : scrollHeight - scrollSetup.prevScroll;
        var scrollOptions = {
          left: 0,
          top: scrollTop,
          behavior: "smooth"
        };
        div.scrollTo(scrollOptions);
      } else {
        return false;
      }
    };

    _this.prevStep = function (key) {
      _this.setState({ maxHeight: _defineProperty({}, key, true), isLoading: true });
      _this.loadingSetTime();
      _this.goScroll(key);
    };

    _this.prevButton = function (key, prevkey, i) {
      var button = _this.props.button;
      // ↓為了可以不放button物件內部特定keyName也不會出現錯誤

      if (button) {
        if (button.prevButton) {
          if (i === 0 && !button.prevButton.firstPrevButton) {
            return;
          } else if (i === 0 && button.prevButton.firstPrevButton) {
            return button.prevButton.firstPrevButton;
          } else {
            return React.createElement(Button$1, {
              text: "\u4E0A\u4E00\u6B65",
              padding: "16px 62px",
              onClick: function onClick() {
                button && button.prevButton.function.forEach(function (item) {
                  key === item.id ? item.onClick() : false;
                });
                _this.prevStep(prevkey);
              }
            });
          }
        }
      } else {
        if (i === 0) {
          return;
        } else {
          return React.createElement(Button$1, {
            text: "\u4E0A\u4E00\u6B65",
            padding: "16px 62px",
            onClick: function onClick() {
              button && button.prevButton.function.forEach(function (item) {
                key === item.id ? item.onClick() : false;
              });
              _this.prevStep(prevkey);
            }
          });
        }
      }
    };

    _this.nextStep = function (key, i) {
      var nextStep = true;
      _this.setState({ maxHeight: _defineProperty({}, key, true), isLoading: true });
      _this.loadingSetTime();
      _this.goScroll(key, i, nextStep);
    };

    _this.nextButton = function (key, nexykey, i) {
      var _this$props2 = _this.props,
          button = _this$props2.button,
          dataList = _this$props2.dataList;

      if (button) {
        if (button.nextButton) {
          if (i === dataList.length - 1 && !button.nextButton.lastNextButton) {
            return;
          } else if (i === dataList.length - 1 && button.nextButton.lastNextButton) {
            return button.nextButton.lastNextButton;
          } else {
            return React.createElement(Button$1, {
              text: "\u4E0B\u4E00\u6B65",
              textColor: "#fff",
              backgroundColor: "#000",
              padding: "16px 62px",
              onClick: function onClick() {
                button && button.nextButton.function.forEach(function (item) {
                  key === item.id ? item.onClick() : false;
                });
                _this.nextStep(nexykey, i);
              }
            });
          }
        }
      } else {
        if (i === dataList.length - 1) {
          return;
        } else {
          return React.createElement(Button$1, {
            text: "\u4E0B\u4E00\u6B65",
            textColor: "#fff",
            backgroundColor: "#000",
            padding: "16px 62px",
            onClick: function onClick() {
              button && button.nextButton.function.forEach(function (item) {
                key === item.id ? item.onClick() : false;
              });
              _this.nextStep(nexykey, i);
            }
          });
        }
      }
    };

    _this.state = {
      maxHeight: {}, //當下展開步驟的內容
      openPurview: {}, // onClick title 跳轉其他步驟的判定狀態
      isLoading: false //轉場頁面狀態
    };
    return _this;
  }
  //第一次讀取資料 並預設顯示步驟


  _createClass(Step$$1, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.defaultOpenStatus();
    }
    //根據預設顯示步驟資料 判定 是否可以觸發點擊事件

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.openPurview();
    }
    //根據顯示的步驟改變 重新判定觸發點擊事件

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.maxHeight !== prevState.maxHeight) {
        this.openPurview();
      }
    }
    //判定預設設定的值，輸入id沒有的參數，固定顯示最後一筆

    //判定觸發點擊事件

    //一秒後從true改成false -> 轉場頁面預設持續一秒

    // onClick title -> 更改顯示步驟

    //滾動到某高度

    // 上一步的行為與按鈕樣式

    // 下一步的行為與按鈕樣式

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          maxHeight = _state.maxHeight,
          openPurview = _state.openPurview,
          isLoading = _state.isLoading;
      var _props = this.props,
          dataList = _props.dataList,
          stepBorderBottom = _props.stepBorderBottom,
          stepWidth = _props.stepWidth,
          numberStep = _props.numberStep,
          titleWidth = _props.titleWidth,
          titleBorder = _props.titleBorder,
          color = _props.color,
          loading = _props.loading,
          button = _props.button;

      return React.createElement(
        Div$2,
        null,
        loading && isLoading ? React.createElement(LoadingWhite, { show: true }) : "",
        dataList.map(function (item, i) {
          var key = dataList[i].id;
          //上一步按鈕的指定對象
          var prevKey = i === 0 ? dataList[0].id : dataList[i - 1].id;
          //下一步按鈕的指定對象
          var nextKey = i === dataList.length - 1 ? dataList[dataList.length - 1].id : dataList[i + 1].id;
          return React.createElement(
            Step,
            {
              key: i,
              stepWidth: stepWidth,
              stepBorderBottom: i === dataList.length - 1 ? "0" : stepBorderBottom // 計算最後element去底線

            },
            React.createElement(
              "div",
              {
                id: item.id,
                style: {
                  cursor: "pointer",
                  width: titleWidth ? titleWidth : "100%"
                },
                onClick: function onClick() {
                  _this3.openContent(key);
                }
              },
              React.createElement(
                Number,
                {
                  numberStep: numberStep,
                  color: openPurview[key] ? color : "rgb(149, 152, 154)"
                },
                item.number
              ),
              React.createElement(
                Title,
                {
                  titleBorder: titleBorder,
                  color: openPurview[key] ? color : "rgb(149, 152, 154)"
                },
                item.title
              )
            ),
            React.createElement(
              "div",
              null,
              React.createElement(
                Content,
                { maxHeight: maxHeight[key] },
                React.createElement(
                  "div",
                  { style: { marginTop: "40px" } },
                  item.content
                ),
                React.createElement(
                  "div",
                  {
                    style: {
                      width: "100%",
                      display: "flex",
                      marginTop: "30px"
                    }
                  },
                  React.createElement(
                    "div",
                    null,
                    _this3.prevButton(key, prevKey, i)
                  ),
                  React.createElement(
                    "div",
                    {
                      style: {
                        marginLeft: button && button.prevButton ? i === 0 && !button.prevButton.firstPrevButton ? "0px" : "50px" : i === 0 ? "0px" : "50px"
                      }
                    },
                    _this3.nextButton(key, nextKey, i)
                  )
                )
              )
            )
          );
        })
      );
    }
  }]);

  return Step$$1;
}(Component);

var _templateObject$d = _taggedTemplateLiteral(["\n  position: relative;\n  background: ", ";\n  width: 100%;\n  height: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  left: 0;\n"], ["\n  position: relative;\n  background: ", ";\n  width: 100%;\n  height: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  left: 0;\n"]),
    _templateObject2$9 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 15px;\n  transform: translateY(-50%);\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 15px;\n  transform: translateY(-50%);\n"]),
    _templateObject3$6 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  right: 15px;\n  transform: translateY(-50%);\n"], ["\n  position: absolute;\n  top: 50%;\n  right: 15px;\n  transform: translateY(-50%);\n"]);

var Header = styled.div(_templateObject$d, function (props) {
  return props.background ? props.background : "#f4f4f4";
}, function (props) {
  return props.height ? props.height : "70px";
});

var LeftSection$1 = styled.div(_templateObject2$9);

var RightSection$1 = styled.div(_templateObject3$6);

var Header$1 = function (_Component) {
  _inherits(Header$$1, _Component);

  function Header$$1() {
    _classCallCheck(this, Header$$1);

    return _possibleConstructorReturn(this, (Header$$1.__proto__ || _Object$getPrototypeOf(Header$$1)).apply(this, arguments));
  }

  _createClass(Header$$1, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          height = _props.height;

      return React.createElement(
        Header,
        { backgroundColor: backgroundColor, height: height },
        React.createElement(
          LeftSection$1,
          null,
          this.props.leftSection
        ),
        this.props.centerSection,
        this.props.children,
        React.createElement(
          RightSection$1,
          null,
          this.props.rightSection
        )
      );
    }
  }]);

  return Header$$1;
}(Component);
Header$1.propTypes = {
  children: PropTypes.object,
  leftSection: PropTypes.object,
  rightSection: PropTypes.object,
  centerSection: PropTypes.object,
  backgroundColor: PropTypes.string,
  height: PropTypes.string
};

var _templateObject$e = _taggedTemplateLiteral(["\n  width: ", ";\n  text-align: center;\n  display: ", ";\n  margin:", ";\n"], ["\n  width: ", ";\n  text-align: center;\n  display: ", ";\n  margin:", ";\n"]),
    _templateObject2$a = _taggedTemplateLiteral(["\n  width: 100%;\n  background-image: url(", ");\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n  cursor: pointer;\n  margin-bottom: 10px;\n  position: relative;\n  &::after {\n    content: \"\";\n    display: block;\n    clear: both;\n  }\n  &:hover {\n    img {\n      opacity: ", ";\n    }\n  }\n  img {\n    width: 100%;\n    max-width: 100%;\n    transition: all 300ms;\n    float: left;\n  }\n"], ["\n  width: 100%;\n  background-image: url(", ");\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n  cursor: pointer;\n  margin-bottom: 10px;\n  position: relative;\n  &::after {\n    content: \"\";\n    display: block;\n    clear: both;\n  }\n  &:hover {\n    img {\n      opacity: ", ";\n    }\n  }\n  img {\n    width: 100%;\n    max-width: 100%;\n    transition: all 300ms;\n    float: left;\n  }\n"]),
    _templateObject3$7 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  font-size: 11px;\n  z-index: 5;\n  border: 1px solid #e9e7e8;\n  padding: 3px 6px;\n  color: #95989a;\n  background: #ffffff;\n"], ["\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  font-size: 11px;\n  z-index: 5;\n  border: 1px solid #e9e7e8;\n  padding: 3px 6px;\n  color: #95989a;\n  background: #ffffff;\n"]);

var Div$3 = styled.div(_templateObject$e, function (props) {
  return props.width ? props.width : "100%";
}, function (props) {
  return props.displayInline ? "inline-block" : "flex";
}, function (props) {
  return props.margin ? props.margin : "5px";
});

var Wrapper$2 = styled.div(_templateObject2$a, function (props) {
  return props.hoverImg ? props.hoverImg : "";
}, function (props) {
  return props.hoverImg ? "0" : "1";
});

var Tag$2 = styled.div(_templateObject3$7);

var Card = function (_Component) {
  _inherits(Card, _Component);

  function Card() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Card);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Card.__proto__ || _Object$getPrototypeOf(Card)).call.apply(_ref, [this].concat(args))), _this), _this.clickHandler = function () {
      _this.props.onClick();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Card, [{
    key: "render",
    value: function render() {
      return React.createElement(
        Div$3,
        { width: this.props.width, onClick: this.clickHandler, margin: this.props.margin, displayInline: this.props.displayInline },
        React.createElement(
          Wrapper$2,
          { hoverImg: this.props.hoverImg },
          this.props.tag ? React.createElement(
            Tag$2,
            null,
            this.props.tag
          ) : null,
          React.createElement("img", {
            src: this.props.img ? this.props.img : "https://cdn.chowsangsang.com/hkeshop/images/p/c/90704c/EPCM90704GDC_3bd718db-9ea1-4b47-9fd5-8ef197305902_350.jpg",
            alt: ""
          })
        ),
        this.props.content ? React.createElement(
          "div",
          null,
          this.props.content
        ) : null
      );
    }
  }]);

  return Card;
}(Component);

Card.defaultProps = {
  onClick: function onClick() {}
};

var _templateObject$f = _taggedTemplateLiteral(["\n  width: 100%;\n  margin: 0 auto;\n"], ["\n  width: 100%;\n  margin: 0 auto;\n"]),
    _templateObject2$b = _taggedTemplateLiteral(["\n  display: flex;\n"], ["\n  display: flex;\n"]),
    _templateObject3$8 = _taggedTemplateLiteral(["\n  width: ", ";\n  margin: 10px 0 0 0;\n"], ["\n  width: ", ";\n  margin: 10px 0 0 0;\n"]),
    _templateObject4$3 = _taggedTemplateLiteral(["\n  font-weight: ", "\n  margin:", "\n"], ["\n  font-weight: ", "\n  margin:", "\n"]),
    _templateObject5$3 = _taggedTemplateLiteral(["\n  margin: ", "\n  font-size: ", "\n  font-weight: ", "\n  color: ", "\n    \n"], ["\n  margin: ", "\n  font-size: ", "\n  font-weight: ", "\n  color: ", "\n    \n"]),
    _templateObject6$3 = _taggedTemplateLiteral(["\n  width: ", ";\n"], ["\n  width: ", ";\n"]);

var Div$4 = styled.div(_templateObject$f);

var Content$1 = styled.div(_templateObject2$b);

var List = styled.div(_templateObject3$8, function (props) {
  return props.listWidth ? props.listWidth : "160px";
});

var Headline = styled.h3(_templateObject4$3, function (props) {
  return props.headlineSetup && props.headlineSetup.fontWeight ? props.headlineSetup.fontWeight : "700";
}, function (props) {
  return props.headlineSetup && props.headlineSetup.margin ? props.headlineSetup.margin : "0 0 30px 0";
});

var Li = styled.li(_templateObject5$3, function (props) {
  return props.subtitleStep && props.subtitleStep.margin ? props.subtitleStep.margin : "8px 0 0 0";
}, function (props) {
  return props.subtitleStep && props.subtitleStep.fontSize ? props.subtitleStep.fontSize : "14px";
}, function (props) {
  return props.subtitleStep && props.subtitleStep.fontWeight ? props.subtitleStep.fontWeight : "0";
}, function (props) {
  return props.subtitleStep && props.subtitleStep.color ? props.subtitleStep.color : "#000";
});

var Img = styled.div(_templateObject6$3, function (props) {
  return props.imgWidth ? props.imgWidth : "240px";
});

var SubMenu = function (_Component) {
  _inherits(SubMenu, _Component);

  function SubMenu() {
    _classCallCheck(this, SubMenu);

    return _possibleConstructorReturn(this, (SubMenu.__proto__ || _Object$getPrototypeOf(SubMenu)).apply(this, arguments));
  }

  _createClass(SubMenu, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          totalSetup = _props.totalSetup,
          listWidth = _props.listWidth,
          headlineSetup = _props.headlineSetup,
          imgWidth = _props.imgWidth,
          background = _props.background,
          type = _props.type,
          subMenuKey = _props.subMenuKey,
          imageTextStep = _props.imageTextStep,
          subtitleStep = _props.subtitleStep;

      var dataList = this.props.dataList[subMenuKey];
      return type === "list" ? React.createElement(
        "div",
        {
          style: {
            maxWidth: "1200px",
            margin: "0 auto",
            background: background ? background : "#fff"
          }
        },
        dataList.map(function (item, i) {
          var total = item.total,
              image = item.image;

          var list = type === "list" ? item.list : [];
          return React.createElement(
            Div$4,
            { key: i },
            React.createElement(
              "a",
              {
                href: total["link"],
                style: {
                  fontSize: totalSetup && totalSetup.fontSize ? totalSetup.fontSize : "14px",
                  fontWeight: totalSetup && totalSetup.fontWeight ? totalSetup.fontWeight : "0",
                  color: totalSetup && totalSetup.color ? totalSetup.color : "#000"
                }
              },
              total["text"]
            ),
            React.createElement(
              Content$1,
              null,
              list.map(function (item, i) {
                return React.createElement(
                  List,
                  { key: i, listWidth: listWidth },
                  React.createElement(
                    "div",
                    { style: { padding: "0" } },
                    React.createElement(
                      Headline,
                      { headlineSetup: headlineSetup },
                      item.headline
                    ),
                    item.subtitle.map(function (item, i) {
                      return React.createElement(
                        Li,
                        { key: i, subtitleStep: subtitleStep },
                        React.createElement(
                          "a",
                          {
                            style: {
                              color: subtitleStep && subtitleStep.color ? subtitleStep.color : "#000"
                            },
                            href: item["link"]
                          },
                          item["text"]
                        )
                      );
                    })
                  )
                );
              }),
              React.createElement(
                Img,
                { imgWidth: imgWidth },
                React.createElement(
                  "a",
                  { href: image.link },
                  React.createElement("img", { style: { maxWidth: "100%" }, src: image.url })
                )
              )
            )
          );
        })
      ) : type === "image" ? React.createElement(
        "div",
        {
          style: {
            maxWidth: "1200px",
            margin: "0 auto",
            background: background ? background : "#fff"
          }
        },
        React.createElement(
          Content$1,
          null,
          dataList.map(function (item, i) {
            return React.createElement(
              Img,
              {
                key: i,
                imgWidth: imgWidth,
                style: {
                  textAlign: imageTextStep && imageTextStep.textAlign ? imageTextStep.textAlign : "center"
                }
              },
              React.createElement(
                "a",
                { href: item.link },
                React.createElement("img", { style: { maxWidth: "100%" }, src: item.image })
              ),
              React.createElement("br", null),
              React.createElement(
                "a",
                {
                  href: item.link,
                  style: {
                    width: "100%",
                    fontSize: imageTextStep && imageTextStep.fontSize ? imageTextStep.fontSize : "14px",
                    fontWeight: imageTextStep && imageTextStep.fontWeight ? imageTextStep.fontWeight : "0",
                    color: imageTextStep && imageTextStep.color ? imageTextStep.color : "#000"
                  }
                },
                item.text
              )
            );
          })
        )
      ) : "";
    }
  }]);

  return SubMenu;
}(Component);

// 19.1.2.14 Object.keys(O)



_objectSap('keys', function () {
  return function keys(it) {
    return _objectKeys(_toObject(it));
  };
});

var keys = _core.Object.keys;

var keys$1 = createCommonjsModule(function (module) {
module.exports = { "default": keys, __esModule: true };
});

var _Object$keys = unwrapExports(keys$1);

var PieGraph = function (_Component) {
  _inherits(PieGraph, _Component);

  function PieGraph() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, PieGraph);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PieGraph.__proto__ || _Object$getPrototypeOf(PieGraph)).call.apply(_ref, [this].concat(args))), _this), _this.percentage = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
      var data, total, i, percentage;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = _this.props.data;
              total = 0;
              _context.next = 4;
              return data.forEach(function (item) {
                total = total + item.percentage;
              });

            case 4:
              i = 0;

            case 5:
              if (!(i < data.length)) {
                _context.next = 16;
                break;
              }

              percentage = Math.round(data[i].percentage / total * 100);

              if (!(data.length >= 8 || percentage <= 15)) {
                _context.next = 12;
                break;
              }

              _this.pieLine();
              return _context.abrupt("break", 16);

            case 12:
              _this.pie();

            case 13:
              i++;
              _context.next = 5;
              break;

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _this.pie = function () {
      var _this$props = _this.props,
          clsNa = _this$props.clsNa,
          data = _this$props.data,
          svgSetup = _this$props.svgSetup;

      select("." + clsNa + " svg g").remove();
      var margin = { top: 10, right: 10, bottom: 10, left: 10 },
          svgWidth = svgSetup && svgSetup.width ? svgSetup.width : 200 - margin.right - margin.left,
          svgHeight = svgSetup && svgSetup.height ? svgSetup.height : 200 - margin.top - margin.bottom,
          stateRadius = Math.min(svgWidth, svgHeight) / 2;

      var color = scaleOrdinal(svgSetup && svgSetup.color ? svgSetup.color : ["rgba(198,153,103,1)", "rgba(198,153,103,0.9)", "rgba(198,153,103,0.8)", "rgba(198,153,103,0.7)", "rgba(198,153,103,0.6)", "rgba(198,153,103,0.5)", "rgba(198,153,103,0.4)", "rgba(198,153,103,0.3)", "rgba(198,153,103,0.2)", "rgba(198,153,103,0.1)"]);

      var svg = select("." + clsNa + " svg").attr("width", svgWidth).attr("height", svgHeight).append("g").attr("transform", "translate(" + stateRadius + "," + stateRadius + ")");

      var pie$$1 = pie().sort(null).value(function (d) {
        return d.percentage;
      });

      var path = arc() // 弧
      .outerRadius(svgSetup && svgSetup.radius ? svgSetup.radius.outerRadius === 0 ? 0 : svgSetup.radius.outerRadius : stateRadius) // 外圈大小
      .innerRadius(svgSetup && svgSetup.radius ? svgSetup.radius.innerRadius === 0 ? 0 : svgSetup.radius.innerRadius : 0); // 內圈大小

      var g = svg // 扇形
      .selectAll("arc").data(pie$$1(data)).enter().append("g"); //資料筆數先進來，再append g，所以筆數會相等

      g.append("path") // 內圈到外圈之間的範圍塗滿顏色
      .attr("stroke", svgSetup && svgSetup.stroke ? svgSetup.stroke : "#fff").attr("d", path).attr("fill", function (d) {
        // 照百分比填滿顏色，不然只會有一個顏色
        return color(d.data.percentage);
      }).transition().ease(easeLinear).duration(svgSetup && svgSetup.duration ? svgSetup.duration : 500).attrTween("d", pieTween);
      function pieTween(b) {
        b.innerRadius = 0;
        var i = interpolate({ startAngle: 0, endAngle: 0 }, b);
        return function (t) {
          return path(i(t));
        };
      }
      var labelArc = arc().outerRadius(stateRadius - stateRadius * 2 / 5).innerRadius(stateRadius - stateRadius * 2 / 5);

      g.append("text").transition() //位置有差
      .ease(easeLinear).duration(svgSetup && svgSetup.duration ? svgSetup.duration : 500).attr("transform", function (d) {
        return "translate(" + labelArc.centroid(d) + ")";
      }).attr("fill", svgSetup.textColor).attr("text-anchor", "middle").attr("dy", "0em").text(function (d) {
        var keys = _Object$keys(d.data);
        return d.data[keys[0]];
      });
      var total = 0;
      data.forEach(function (item) {
        total = total + item.percentage;
      });
      // g.append("text")
      //   .transition()
      //   .ease(d3.easeLinear)
      //   .duration(svgSetup && svgSetup.duration ? svgSetup.duration : 500)
      //   .attr("transform", function(d) {
      //     return "translate(" + labelArc.centroid(d) + ")";
      //   })
      //   .attr("fill", svgSetup.textColor)
      //   .attr("text-anchor", "middle")
      //   .attr("dy", "1em")
      //   .text(function(d) {
      //     let keys = Object.keys(d.data);
      //     return ((d.data[keys[1]] / total) * 100).toFixed(1) + "%";
      //   });
    }, _this.pieLine = function () {
      var _this$props2 = _this.props,
          clsNa = _this$props2.clsNa,
          data = _this$props2.data,
          svgSetup = _this$props2.svgSetup;

      select("." + clsNa + " svg g").remove();
      var margin = { top: 10, right: 10, bottom: 10, left: 10 },
          svgWidth = svgSetup && svgSetup.width ? svgSetup.width : 200 - margin.right - margin.left,
          svgHeight = svgSetup && svgSetup.height ? svgSetup.height : 200 - margin.top - margin.bottom,
          stateRadius = Math.min(svgWidth, svgHeight) / 2;

      var color = scaleOrdinal(svgSetup && svgSetup.color ? svgSetup.color : schemeCategory10
      // [
      //     "rgba(198,153,103,1)",
      //     "rgba(198,153,103,0.9)",
      //     "rgba(198,153,103,0.8)",
      //     "rgba(198,153,103,0.7)",
      //     "rgba(198,153,103,0.6)",
      //     "rgba(198,153,103,0.5)",
      //     "rgba(198,153,103,0.4)",
      //     "rgba(198,153,103,0.3)",
      //     "rgba(198,153,103,0.2)",
      //     "rgba(198,153,103,0.1)"
      //   ]
      );

      var svg = select("." + clsNa + " svg").attr("width", svgWidth * 2).attr("height", svgHeight * 1.5).append("g").attr("transform", "translate(" + (stateRadius + svgWidth / 2) + "," + (stateRadius + stateRadius / 2) + ")");

      var pie$$1 = pie().sort(null).value(function (d) {
        return d.percentage;
      });

      var slices = svg.append("g");
      var labels = svg.append("g").selectAll("text").data(pie$$1(data)).enter();
      var lines = svg.append("g").selectAll("polyline").data(pie$$1(data)).enter();

      var path = arc().outerRadius(svgSetup && svgSetup.radius ? svgSetup.radius.outerRadius === 0 ? 0 : svgSetup.radius.outerRadius : stateRadius).innerRadius(svgSetup && svgSetup.radius ? svgSetup.radius.innerRadius === 0 ? 0 : svgSetup.radius.innerRadius : 0);

      function pieTween(b) {
        b.innerRadius = 0;
        var i = interpolate({ startAngle: 0, endAngle: 0 }, b);
        return function (t) {
          return path(i(t));
        };
      }
      slices.selectAll("arc").data(pie$$1(data)).enter().append("path").attr("stroke", svgSetup && svgSetup.stroke ? svgSetup.stroke : "#fff").attr("d", path).attr("fill", function (d) {
        return color(d.data.percentage);
      }).transition().ease(easeLinear).duration(svgSetup && svgSetup.duration ? svgSetup.duration : 500).attrTween("d", pieTween);

      // let labelArc = d3
      //   .arc()
      //   .outerRadius(stateRadius - (stateRadius * 2) / 7)
      //   .innerRadius(stateRadius - (stateRadius * 2) / 5);

      var startPoint = arc().outerRadius(stateRadius).innerRadius(stateRadius);

      var midPoint = arc().outerRadius(stateRadius * 1.1).innerRadius(stateRadius * 1.1);

      function midAngle(d) {
        return d.startAngle + (d.endAngle - d.startAngle) / 2;
      }
      lines.append("polyline").attr("fill", "none").attr("stroke", "#000").attr("points", function (d) {
        var mid = midAngle(d) < Math.PI ? 1 : -1;
        var lastPoint = midPoint.centroid(d);
        if (mid === 1) {
          lastPoint = [midPoint.centroid(d)[0] + svgWidth / 5, midPoint.centroid(d)[1]];
        } else {
          lastPoint = [midPoint.centroid(d)[0] - svgWidth / 5, midPoint.centroid(d)[1]];
        }
        return [startPoint.centroid(d), midPoint.centroid(d), lastPoint];
      });

      labels.append("text").attr("transform", function (d) {
        var mid = midAngle(d) < Math.PI ? 1 : -1;
        var lastPoint = midPoint.centroid(d);
        if (mid === 1) {
          lastPoint = [midPoint.centroid(d)[0] + svgWidth / 5, midPoint.centroid(d)[1] + svgHeight / 80];
        } else {
          lastPoint = [midPoint.centroid(d)[0] - svgWidth / 5, midPoint.centroid(d)[1] + svgHeight / 80];
        }
        return "translate(" + lastPoint + ")";
      }).attr("fill", svgSetup.textColor).attr("text-anchor", "middle").attr("dy", "1em").text(function (d) {
        var keys = _Object$keys(d.data);
        return d.data[keys[0]];
      });
      var total = 0;
      data.forEach(function (item) {
        total = total + item.percentage;
      });
      // labels
      //   .append("text")
      //   .attr("transform", function(d) {
      //     let mid = midAngle(d) < Math.PI ? 1 : -1;
      //     let lastPoint = midPoint.centroid(d);
      //     if (mid === 1) {
      //       lastPoint = [
      //         midPoint.centroid(d)[0] + svgWidth / 4.8,
      //         midPoint.centroid(d)[1] + svgHeight / 80
      //       ];
      //     } else {
      //       lastPoint = [
      //         midPoint.centroid(d)[0] - svgWidth / 4.8,
      //         midPoint.centroid(d)[1] + svgHeight / 80
      //       ];
      //     }
      //     return "translate(" + lastPoint + ")";
      //   })
      //   .attr("fill", svgSetup.textColor)
      //   .attr("text-anchor", "middle")
      //   .attr("dy", "2em")
      //   .text(function(d) {
      //     let keys = Object.keys(d.data);
      //     return ((d.data[keys[1]] / total) * 100).toFixed(1) + "%";
      //   });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PieGraph, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var type = this.props.type;

      type ? type === "pie" ? this.pie() : type === "linePie" ? this.pieLine() : this.percentage() : this.percentage();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.data !== prevProps.data) {
        var type = this.props.type;

        type ? type === "pie" ? this.pie() : type === "linePie" ? this.pieLine() : this.percentage() : this.percentage();
      }
    }
    //判定是否用有線圓餅圖

    //一般圓餅圖

    //有線圓餅圖

  }, {
    key: "render",
    value: function render() {
      var clsNa = this.props.clsNa;

      return React.createElement(
        "div",
        { className: clsNa, style: { textAlign: "center" } },
        React.createElement("svg", null)
      );
    }
  }]);

  return PieGraph;
}(Component);

var ClassicLineGraph = function (_Component) {
  _inherits(ClassicLineGraph, _Component);

  function ClassicLineGraph() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ClassicLineGraph);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ClassicLineGraph.__proto__ || _Object$getPrototypeOf(ClassicLineGraph)).call.apply(_ref, [this].concat(args))), _this), _this.line = function () {
      var _this$props = _this.props,
          data = _this$props.data,
          clsNa = _this$props.clsNa,
          needDot = _this$props.needDot,
          svgSetup = _this$props.svgSetup,
          needCoordinate = _this$props.needCoordinate;

      var margin = { top: 20, right: 20, bottom: 30, left: 50 };
      var width = svgSetup.width - margin.left - margin.right,
          height = svgSetup.height - margin.top - margin.bottom;
      var svgWidth = svgSetup.width;
      var svgHeight = svgSetup.height;

      var keys = _Object$keys(data[0]);

      var svg = select("." + clsNa).style("position", "relative").style("width", "100%").style("height", "100%").append("svg").attr("width", svgWidth).attr("height", svgHeight).append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");
      var x = scaleLinear().rangeRound([0, width]).domain(extent(data, function (d) {
        return d[keys[0]];
      }));
      var y = scaleLinear().rangeRound([height, 0]).domain([0, max(data, function (d) {
        return d[keys[1]];
      })]);

      var line$$1 = line().x(function (d) {
        var keys = _Object$keys(d);
        return x(d[keys[0]]);
      }).y(function (d) {
        var keys = _Object$keys(d);
        return y(d[keys[1]]);
      });

      var xAxis = function xAxis(g) {
        return g.append("g").attr("transform", "translate(0," + height + ")").call(axisBottom(x).ticks(data.length).tickFormat(format("d"))).append("text").attr("transform", "translate(" + width + ",0)").attr("fill", "#000").attr("dy", "-0.5em").attr("font-size", "12px").text(keys[0]);
      };

      var yAxis = function yAxis(g) {
        g.call(axisLeft(y).ticks(data.length)).append("text").attr("fill", "#000").attr("transform", "rotate(-90)").attr("dy", "1.25em").attr("font-size", "12px").text(keys[1]);
      };
      if (needCoordinate) {
        svg.append("g").call(xAxis);
        svg.append("g").call(yAxis);
      }

      var path = svg.append("path").datum(data).attr("fill", "none").attr("stroke", svgSetup && svgSetup.pathColor ? svgSetup.pathColor : "#bc937c").attr("d", line$$1);

      var totalLength = path.node().getTotalLength();

      path.attr("stroke-dasharray", totalLength + " " + totalLength).attr("stroke-dashoffset", totalLength).transition().duration(2000).ease(easeLinear).attr("stroke-dashoffset", 0).attr("stroke-width", svgSetup && svgSetup.pathWidth ? svgSetup.pathWidth : "");

      var dotTextDiv = select("." + clsNa).append("div").attr("class", "tooltip").style("height", "16px").style("width", "60px").style("position", "absolute").style("background", svgSetup && svgSetup.dotTextBg ? svgSetup.dotTextBg : "rgba(198,153,103,0.2)").style("margin-left", "5%").style("margin-top", "5px").style("text-align", "center").style("opacity", 0);

      if (needDot) {
        svg.selectAll("dot").data(data).enter().append("circle").attr("r", svgSetup && svgSetup.dotSize ? svgSetup.dotSize : 5).attr("cx", function (d) {
          return x(d[keys[0]]);
        }).attr("cy", function (d) {
          return y(d[keys[1]]);
        }).attr("fill", svgSetup && svgSetup.dotColor ? svgSetup.dotColor : "rgba(198,153,103,1)").attr("opacity", ".6").on("mouseover", function (d) {
          select(this).transition().duration(100).style("fill", svgSetup && svgSetup.dotHoverColor ? svgSetup.dotHoverColor : "rgba(198,153,103,.8)").attr("r", svgSetup && svgSetup.dotHoverSize ? svgSetup.dotHoverSize : 8);
          dotTextDiv.transition().duration(200).style("opacity", 0.8);
          dotTextDiv.html(d[keys[1]]).style("left", x(d[keys[0]]) + "px").style("top", y(d[keys[1]]) + "px");
        }).on("mouseout", function (d) {
          select(this).transition().duration(100).style("fill", svgSetup && svgSetup.dotColor ? svgSetup.dotColor : "rgba(198,153,103,1)").attr("r", svgSetup && svgSetup.dotSize ? svgSetup.dotSize : 5);
          dotTextDiv.transition().duration(500).style("opacity", 0);
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ClassicLineGraph, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.line();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.data !== prevProps.data) {
        this.line();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var clsNa = this.props.clsNa;

      return React.createElement("div", { className: clsNa });
    }
  }]);

  return ClassicLineGraph;
}(Component);

var LineGraphForMultipleSets = function (_Component) {
  _inherits(LineGraphForMultipleSets, _Component);

  function LineGraphForMultipleSets() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LineGraphForMultipleSets);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LineGraphForMultipleSets.__proto__ || _Object$getPrototypeOf(LineGraphForMultipleSets)).call.apply(_ref, [this].concat(args))), _this), _this.line = function () {
      var _this$props = _this.props,
          data = _this$props.data,
          clsNa = _this$props.clsNa,
          svgSetup = _this$props.svgSetup,
          needDot = _this$props.needDot,
          needCoordinate = _this$props.needCoordinate;

      var margin = { top: 20, right: 20, bottom: 30, left: 50 };
      var width = svgSetup.width - margin.left - margin.right,
          height = svgSetup.height - margin.top - margin.bottom;
      var svgWidth = svgSetup.width;
      var svgHeight = svgSetup.height;

      var keys = _Object$keys(data[0]);
      var LvTwoMax = 0;
      for (var i = 0; i < data.length; i++) {
        var currentLvTwo = max(data[i][keys[1]], function (d) {
          var keysForLv2 = _Object$keys(d);
          return d[keysForLv2[1]];
        });
        if (currentLvTwo > LvTwoMax) {
          LvTwoMax = currentLvTwo;
        }
      }

      var LvTwoForXMax = 0;
      var LvTwoForXLow = 0;
      for (var i = 0; i < data.length; i++) {
        var currentLvTwoForXMax = max(data[i][keys[1]], function (d) {
          var keysForLv2 = _Object$keys(d);
          return d[keysForLv2[0]];
        });
        var currentLvTwoForXLow = min(data[i][keys[1]], function (d) {
          var keysForLv2 = _Object$keys(d);
          return d[keysForLv2[0]];
        });
        if (currentLvTwoForXMax > LvTwoForXMax) {
          LvTwoForXMax = currentLvTwoForXMax;
        }
        if (currentLvTwoForXLow > LvTwoForXLow) {
          LvTwoForXLow = currentLvTwoForXLow;
        }
      }

      var svg = select("." + clsNa).style("position", "relative").style("width", "100%").style("height", "100%").append("svg").attr("width", svgWidth).attr("height", svgHeight + 30).append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");
      var x = scaleLinear().rangeRound([0, width]).domain([LvTwoForXLow, LvTwoForXMax]);
      var y = scaleLinear().rangeRound([height, 0]).domain([0, LvTwoMax]);

      var line$$1 = line().x(function (d) {
        var keysForLv2 = _Object$keys(d);
        return x(d[keysForLv2[0]]);
      }).y(function (d) {
        var keysForLv2 = _Object$keys(d);
        return y(d[keysForLv2[1]]);
      });
      var color = scaleOrdinal(svgSetup && svgSetup.color ? svgSetup.color : ["#bc937c", "#4a5c68", "#E9E7E8", "#111111", "rgba(198,153,103,0.6)", "rgba(198,153,103,0.5)", "rgba(198,153,103,0.4)", "rgba(198,153,103,0.3)", "rgba(198,153,103,0.2)", "rgba(198,153,103,0.1)"]);
      svg.selectAll("path").data(data).enter().append("path").attr("d", function (d) {
        return line$$1(d[keys[1]]);
      }).attr("fill", "none").attr("stroke", function (d, i) {
        return color(i);
      });
      var xAxis = function xAxis(g) {
        return g.append("g").attr("transform", "translate(0," + height + ")").call(axisBottom(x).tickFormat(format("d")));
      };
      var yAxis = function yAxis(g) {
        g.call(axisLeft(y));
      };

      if (needCoordinate) {
        svg.append("g").call(xAxis);
        svg.append("g").call(yAxis);
      }

      svg.selectAll(".mark").data(data).enter().append("path").attr("d", symbol().type(function (d, i) {
        return symbols[3];
      })).attr("transform", function (d, i) {
        return "translate(" + (margin.right + i * 60) + ", " + (height + 40) + ")";
      }).attr("fill", function (d, i) {
        return color(i);
      });
      svg.selectAll(".markText").data(data).enter().append("text").attr("class", "markText").attr("transform", function (d, i) {
        return "translate(" + (margin.right + 10 + i * 60) + ", " + (height + 45) + ")";
      }).attr("font-size", 12).text(function (d) {
        return d[keys[0]];
      });
      var dotTextDiv = select("." + clsNa).append("div").attr("class", "tooltip").style("height", "16px").style("width", "60px").style("position", "absolute").style("margin-left", "5%").style("margin-top", "5px").style("text-align", "center").style("opacity", 0);
      if (needDot) {
        svg.selectAll("dot").data(data).enter().append("g").style("fill", function (d, i) {
          return color(i);
        }).selectAll("circle").data(function (d) {
          return d[keys[1]];
        }).enter().append("g").attr("class", "circle").append("circle").attr("cx", function (d) {
          var keysForLv2 = _Object$keys(d);
          return x(d[keysForLv2[0]]);
        }).attr("cy", function (d) {
          var keysForLv2 = _Object$keys(d);
          return y(d[keysForLv2[1]]);
        }).attr("r", 5).style("opacity", 0.6).on("mouseover", function (d) {
          var keysForLv2 = _Object$keys(d);
          select(this).transition().duration(100).attr("r", svgSetup && svgSetup.dotHoverSize ? svgSetup.dotHoverSize : 8);
          dotTextDiv.transition().duration(200).style("opacity", 0.8);
          dotTextDiv.html(d[keysForLv2[1]]).style("left", x(d[keysForLv2[0]]) + "px").style("top", y(d[keysForLv2[1]]) + "px");
        }).on("mouseout", function (d) {
          select(this).transition().duration(100).attr("r", svgSetup && svgSetup.dotSize ? svgSetup.dotSize : 5);
          dotTextDiv.transition().duration(500).style("opacity", 0);
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LineGraphForMultipleSets, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.line();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.data !== prevProps.data) {
        this.line();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var clsNa = this.props.clsNa;

      return React.createElement("div", { className: clsNa });
    }
  }]);

  return LineGraphForMultipleSets;
}(Component);

var StackedAreaChart = function (_Component) {
  _inherits(StackedAreaChart, _Component);

  function StackedAreaChart() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, StackedAreaChart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StackedAreaChart.__proto__ || _Object$getPrototypeOf(StackedAreaChart)).call.apply(_ref, [this].concat(args))), _this), _this.line = function () {
      var _this$props = _this.props,
          clsNa = _this$props.clsNa,
          data = _this$props.data,
          svgSetup = _this$props.svgSetup,
          needCoordinate = _this$props.needCoordinate,
          needDot = _this$props.needDot;

      var keys = _Object$keys(data[0]);
      var margin = { top: 61, right: 140, bottom: 101, left: 50 },
          width = svgSetup.width - margin.left - margin.right,
          height = svgSetup.height - margin.top - margin.bottom;

      var svg = select("." + clsNa).style("position", "relative").style("width", "100%").style("height", "100%").append("svg").attr("width", width + margin.left + margin.right).attr("height", height + margin.top + margin.bottom).append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      var sumstat = nest().key(function (d) {
        return d[keys[0]];
      }).entries(data);

      var mygroup = svgSetup && svgSetup.group ? svgSetup.group : []; // list of group names

      var stackedData = stack().keys(mygroup).value(function (d, key) {
        return d.values[key - 1][keys[1]];
      })(sumstat);
      var x = scaleLinear().domain(extent(data, function (d) {
        return d[keys[0]];
      })).range([0, width]);

      var y = scaleLinear().domain([0, max(data, function (d) {
        return +d[keys[1]];
      }) * 5]).range([height, 0]);

      if (needCoordinate) {
        svg.append("g").attr("transform", "translate(0," + height + ")").call(axisBottom(x).ticks(max(data, function (d) {
          return d[keys[0]];
        })));
        // Add Y axis
        svg.append("g").call(axisLeft(y));
      }
      // color palette
      var color = scaleOrdinal().domain(mygroup).range(svgSetup && svgSetup.color ? svgSetup.color : ["#bc937c", "#4a5c68", "#E9E7E8", "#111111", "rgba(198,153,103,0.6)", "rgba(198,153,103,0.5)", "rgba(198,153,103,0.4)", "rgba(198,153,103,0.3)", "rgba(198,153,103,0.2)", "rgba(198,153,103,0.1)"]);
      // Show the areas
      svg.selectAll("mylayers").data(stackedData).enter().append("path").style("fill", function (d) {
        name = mygroup[d.key - 1];
        return color(name);
      }).attr("d", area().x(function (d, i) {
        return x(d.data.key);
      }).y0(function (d) {
        return y(d[0]);
      }).y1(function (d) {
        return y(d[1]);
      }));

      var dotTextDiv = select("." + clsNa).append("div").attr("class", "tooltip").style("height", "16px").style("width", "60px").style("position", "absolute").style("background", "white").style("margin-left", "5%").style("margin-top", "5px").style("text-align", "center").style("opacity", 0);
      if (needDot) {
        svg.selectAll("dot").data(stackedData).enter().append("g").style("fill", function (d) {
          name = mygroup[d.key - 1];
          return color(name);
        }).selectAll("circle").data(function (d) {
          return d;
        }).enter().append("g").attr("class", "circle").append("circle").attr("r", 5).style("opacity", 0.6).style("stroke-width", "2").attr("cx", function (d, i) {
          return x(i + 1);
        }).attr("cy", function (d) {
          return y(d[1]);
        }).on("mouseover", function (d, i) {
          select(this).style("opacity", 0.8).attr("r", 8);
          dotTextDiv.transition().duration(200).style("opacity", 0.8);
          dotTextDiv.html(d[1]).style("left", x(i + 1) + "px").style("top", y(d[1]) + 30 + "px");
        }).on("mouseout", function (d) {
          select(this).style("opacity", 0.6).attr("r", 5);

          dotTextDiv.transition().duration(500).style("opacity", 0);
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(StackedAreaChart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.line();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.data !== prevProps.data) {
        this.line();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var clsNa = this.props.clsNa;

      return React.createElement("div", { className: clsNa });
    }
  }]);

  return StackedAreaChart;
}(Component);

var LineGraph = function (_Component) {
  _inherits(LineGraph, _Component);

  function LineGraph() {
    _classCallCheck(this, LineGraph);

    return _possibleConstructorReturn(this, (LineGraph.__proto__ || _Object$getPrototypeOf(LineGraph)).apply(this, arguments));
  }

  _createClass(LineGraph, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          data = _props.data,
          clsNa = _props.clsNa,
          needDot = _props.needDot,
          svgSetup = _props.svgSetup,
          type = _props.type,
          needCoordinate = _props.needCoordinate;

      return type === "classic" && React.createElement(ClassicLineGraph, {
        clsNa: clsNa,
        data: data,
        needDot: needDot,
        svgSetup: svgSetup,
        needCoordinate: needCoordinate
      }) || type === "MultipleLineGraph" && React.createElement(LineGraphForMultipleSets, {
        clsNa: clsNa,
        data: data,
        needDot: needDot,
        svgSetup: svgSetup,
        needCoordinate: needCoordinate
      }) || type === "StackedArea" && React.createElement(StackedAreaChart, {
        clsNa: clsNa,
        data: data,
        needDot: needDot,
        svgSetup: svgSetup,
        needCoordinate: needCoordinate
      });
    }
  }]);

  return LineGraph;
}(Component);

LineGraph.defaultProps = {
  type: "classic",
  needCoordinate: true,
  needDot: false
};

var _templateObject$g = _taggedTemplateLiteral(["\n  svg {\n    overflow: visible !important;\n    .show {\n      opacity: 1;\n    }\n    .hide {\n      opacity: 0;\n    }\n  }\n"], ["\n  svg {\n    overflow: visible !important;\n    .show {\n      opacity: 1;\n    }\n    .hide {\n      opacity: 0;\n    }\n  }\n"]);

var Wrapper$3 = styled.div(_templateObject$g);

var Classic = function (_Component) {
  _inherits(Classic, _Component);

  function Classic() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Classic);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Classic.__proto__ || _Object$getPrototypeOf(Classic)).call.apply(_ref, [this].concat(args))), _this), _this.drawChart = function () {
      var _this$props = _this.props,
          id = _this$props.id,
          data = _this$props.data,
          margin = _this$props.margin,
          svgWidth = _this$props.svgWidth,
          svgHeight = _this$props.svgHeight,
          barWidth = _this$props.barWidth,
          barSet = _this$props.barSet,
          color = _this$props.color,
          textHeight = _this$props.textHeight,
          textRight = _this$props.textRight,
          textHover = _this$props.textHover,
          showText = _this$props.showText,
          showPercent = _this$props.showPercent,
          decimal = _this$props.decimal,
          showAxis = _this$props.showAxis,
          initX = _this$props.initX;


      var width = svgWidth - margin.left - margin.right;
      var height = svgHeight - margin.top - margin.bottom;
      var mycolor = scaleOrdinal(color);
      var key = _Object$keys(data[0]);
      var BarArray = key.slice(1, key.length);

      var x = scaleBand().domain(initX.concat(data.map(function (d) {
        return d[key[0]];
      }))).rangeRound([0, width]).padding(barWidth);

      var y0 = scaleLinear().domain([0, max(data.map(function (d, i) {
        return d[key[1]];
      }).concat(data.map(function (d, i) {
        return d[key[2]];
      })))]).range([height, 0]);

      var xAxis = axisBottom().scale(x);

      // create left yAxis
      var yAxisLeft = axisLeft().scale(y0).ticks(6);

      // create right yAxis

      var svg = select("#" + id).append("svg").attr("width", width + margin.left + margin.right).attr("height", height + margin.top + margin.bottom).attr("class", "graph").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      showAxis.xAxis && svg.append("g").attr("class", "x axis").attr("transform", "translate(0," + height + ")").call(xAxis);

      showAxis.yAxis && svg.append("g").attr("class", "y axis axisLeft").attr("transform", "translate(0,0)").call(yAxisLeft) && svg.selectAll("text").append("text").attr("y", 6).attr("dy", "-2em").style("text-anchor", "end").text("Dollars");

      var bars = svg.append("g").selectAll("rect").data(data).enter().append("g");

      BarArray.map(function (bar, index) {
        textHover ? bars.append("rect").attr("class", "bar").attr("x", function (d) {
          return x(d[key[0]]) + x.bandwidth() * index / barSet;
        }).attr("width", x.bandwidth() / barSet).attr("y", function (d) {
          return y0(d[key[index + 1]]);
        }).attr("height", function (d) {
          return height - y0(d[key[index + 1]]);
        }).attr("fill", mycolor(color[index + 1])).on("mouseover", function () {
          select(this.parentNode.childNodes[index * 2 + 1]).attr("class", "show");
        }).on("mouseout", function () {
          select(this.parentNode.childNodes[index * 2 + 1]).attr("class", "hide");
        }) : bars.append("rect").attr("class", "bar").attr("x", function (d) {
          return x(d[key[0]]) + x.bandwidth() * index / barSet;
        }).attr("width", x.bandwidth() / barSet).attr("y", function (d) {
          return y0(d[key[index + 1]]);
        }).attr("height", function (d) {
          return height - y0(d[key[index + 1]]);
        }).attr("fill", mycolor(color[index + 1]));
        showText ? bars.append("text").attr("class", "show").text(function (d) {
          return d[key[index + 1]];
        }).attr("x", function (d) {
          return x(d[key[0]]) + x.bandwidth() * index / barSet + textRight;
        }).attr("y", function (d) {
          return y0(d[key[index + 1]] + textHeight);
        }) : bars.append("text").attr("class", "hide").text(function (d) {
          return d[key[index + 1]];
        }).attr("x", function (d) {
          return x(d[key[0]]) + x.bandwidth() * index / barSet + textRight;
        }).attr("y", function (d) {
          return y0(d[key[index + 1]] + textHeight);
        });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Classic, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.drawChart();
    }
  }, {
    key: "render",
    value: function render() {
      var id = this.props.id;

      return React.createElement("div", { id: "" + id });
    }
  }]);

  return Classic;
}(Component);

var StackedBar = function (_Component) {
  _inherits(StackedBar, _Component);

  function StackedBar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, StackedBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StackedBar.__proto__ || _Object$getPrototypeOf(StackedBar)).call.apply(_ref, [this].concat(args))), _this), _this.drawChart = function () {
      var _this$props = _this.props,
          id = _this$props.id,
          data = _this$props.data,
          margin = _this$props.margin,
          svgWidth = _this$props.svgWidth,
          svgHeight = _this$props.svgHeight,
          barWidth = _this$props.barWidth,
          barSet = _this$props.barSet,
          color = _this$props.color,
          textHeight = _this$props.textHeight,
          textRight = _this$props.textRight,
          textHover = _this$props.textHover,
          showText = _this$props.showText,
          showPercent = _this$props.showPercent,
          decimal = _this$props.decimal,
          showAxis = _this$props.showAxis,
          initX = _this$props.initX;


      var width = svgWidth - margin.left - margin.right;
      var height = svgHeight - margin.top - margin.bottom;
      var key = _Object$keys(data[0]);

      var mycolor = scaleOrdinal(color);

      var x = scaleBand().domain(initX.concat(data.map(function (d) {
        return d[key[0]];
      }))).rangeRound([0, width]).padding(barWidth);

      var y0 = scaleLinear().domain([0, max(data.map(function (d) {
        return d[key[1]];
      }))]).range([height, 0]);

      var xAxis = axisBottom().scale(x);

      // create left yAxis
      var yAxisLeft = axisLeft().scale(y0).ticks(4);

      // create right yAxis

      var svg = select("#" + id).append("svg").attr("width", width + margin.left + margin.right).attr("height", height + margin.top + margin.bottom).attr("class", "graph").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      showAxis.xAxis && svg.append("g").attr("class", "x axis").attr("transform", "translate(0," + height + ")").call(xAxis);
      showAxis.yAxis && svg.append("g").attr("class", "y axis axisLeft").attr("transform", "translate(0,0)").call(yAxisLeft).append("text").attr("y", 6).attr("dy", "-2em").style("text-anchor", "end").text("Dollars");

      var bars = svg.append("g").selectAll("g").data(data).enter().append("g");

      var BarArray = key.slice(1, key.length);
      BarArray.map(function (bar, index) {
        var interIndex = index + 1;
        bars.append("rect").attr("x", function (d) {
          return x(d[key[0]]);
        }).attr("width", x.bandwidth() / barSet).attr("y", function (d) {
          var total = 0;
          for (var i = 1; i <= interIndex; i++) {
            total += d[key[i]];
          }
          return height - total;
        }).attr("height", function (d) {
          var total = 0;
          for (var i = 1; i <= interIndex; i++) {
            total += d[key[i]];
          }
          return total;
        }).attr("fill", mycolor(index));
      });

      var percent = data.map(function (d) {
        return d[key[1]] + d[key[2]] + d[key[3]];
      });

      if (showText) {
        showPercent ? BarArray.map(function (bar, index) {
          var interIndex = index + 1;
          svg.append("g").selectAll("text").data(data).enter().append("text").attr("class", "textClass").text(function (d, i) {
            return (d[key[index + 1]] / percent[i] * 100).toFixed(decimal) + "%";
          }).attr("x", function (d) {
            return x(d[key[0]]);
          }).attr("y", function (d) {
            var total = 0;
            for (var i = 1; i <= interIndex; i++) {
              total += d[key[i]];
            }
            return height - total - textHeight;
          });
        }) : BarArray.map(function (bar, index) {
          var interIndex = index + 1;
          svg.append("g").selectAll("text").data(data).enter().append("text").attr("class", "textClass").text(function (d) {
            return d[key[index + 1]];
          }).attr("x", function (d) {
            return x(d[key[0]]);
          }).attr("y", function (d) {
            var total = 0;
            for (var i = 1; i <= interIndex; i++) {
              total += d[key[i]];
            }
            return height - total - textHeight;
          });
        });
      } else return;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(StackedBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.drawChart();
    }
  }, {
    key: "render",
    value: function render() {
      var id = this.props.id;

      return React.createElement("div", { id: id });
    }
  }]);

  return StackedBar;
}(Component);

var Horizontal = function (_Component) {
  _inherits(Horizontal, _Component);

  function Horizontal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Horizontal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Horizontal.__proto__ || _Object$getPrototypeOf(Horizontal)).call.apply(_ref, [this].concat(args))), _this), _this.drawChart = function () {
      var _this$props = _this.props,
          id = _this$props.id,
          data = _this$props.data,
          margin = _this$props.margin,
          svgWidth = _this$props.svgWidth,
          svgHeight = _this$props.svgHeight,
          barWidth = _this$props.barWidth,
          barSet = _this$props.barSet,
          color = _this$props.color,
          textHeight = _this$props.textHeight,
          textRight = _this$props.textRight,
          textHover = _this$props.textHover,
          showText = _this$props.showText,
          showPercent = _this$props.showPercent,
          decimal = _this$props.decimal,
          showAxis = _this$props.showAxis,
          initX = _this$props.initX;


      var width = svgWidth - margin.left - margin.right;
      var height = svgHeight - margin.top - margin.bottom;
      var mycolor = scaleOrdinal(color);
      var key = _Object$keys(data[0]);
      var BarArray = key.slice(1, key.length);

      var x = scaleBand().domain(initX.concat(data.map(function (d) {
        return d[key[0]];
      }))).rangeRound([0, width]).padding(barWidth);

      var y0 = scaleLinear().domain([max(data.map(function (d, i) {
        return d[key[1]];
      }).concat(data.map(function (d, i) {
        return d[key[2]];
      }))), 0]).range([height, 0]);

      var xAxis = axisBottom().scale(y0).ticks(5);

      // create left yAxis
      var yAxisLeft = axisLeft().scale(x);

      // create right yAxis

      var svg = select("#" + id).append("svg").attr("width", width + margin.left + margin.right).attr("height", height + margin.top + margin.bottom).attr("class", "graph").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      showAxis.xAxis && svg.append("g").attr("class", "x axis").attr("transform", "translate(0, 0 )").call(yAxisLeft);

      showAxis.yAxis && svg.append("g").attr("class", "y axis axisLeft").attr("transform", "translate(0," + height + ")").call(xAxis).append("text").attr("y", 6).attr("dy", "-2em").style("text-anchor", "end").text("Dollars");

      var bars = svg.selectAll("rect").data(data).enter().append("g");

      BarArray.map(function (bar, index) {
        var interIndex = index + 1;
        bars.append("rect").attr("class", "bar").attr("y", function (d) {
          return x(d[key[0]]);
        }).attr("width", function (d) {
          var total = 0;
          for (var i = 1; i <= interIndex; i++) {
            total += d[key[i]];
          }
          return total;
        }).attr("x", 0).attr("height", x.bandwidth() / barSet).attr("fill", mycolor(color[index + 1])).on("mouseover", function () {
          console.log(index);
          console.log(this.parentNode);
          // console.log(this.parentNode.childNodes[3].childNodes[3]);
          // d3.select(this.parentNode.childNodes[index].attr("class","show"))
        });
        // .on("mouseout",function(){
        //   d3.select(this.parentNode.childNodes[3].attr("class","hide"))
        // })

        var percent = data.map(function (d) {
          return d[key[1]] + d[key[2]] + d[key[3]];
        });

        if (showText) {
          showPercent ? bars.append("g").selectAll("text").data(data).enter().append("text").attr("class", "textClass").text(function (d, i) {
            return (d[key[index + 1]] / percent[i] * 100).toFixed(decimal) + "%";
          }).attr("x", function (d) {
            var total = 0;
            for (var i = 1; i <= interIndex; i++) {
              total += d[key[i]];
            }
            return total - textRight;
          }).attr("y", function (d) {
            return x(d[key[0]]) + x.bandwidth() / barSet - textHeight;
          }) : bars.append("g").selectAll("text").data(data).enter().append("text").attr("class", "textClass").text(function (d) {
            return d[key[index + 1]];
          }).attr("x", function (d) {
            var total = 0;
            for (var i = 1; i <= interIndex; i++) {
              total += d[key[i]];
            }
            return total - textRight;
          }).attr("y", function (d) {
            return x(d[key[0]]) + x.bandwidth() / barSet - textHeight;
          });
        } else return;
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Horizontal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.drawChart();
    }
  }, {
    key: "render",
    value: function render() {
      var id = this.props.id;

      return React.createElement("div", { id: "" + id });
    }
  }]);

  return Horizontal;
}(Component);

var BarGraph = function (_Component) {
  _inherits(BarGraph, _Component);

  function BarGraph() {
    _classCallCheck(this, BarGraph);

    return _possibleConstructorReturn(this, (BarGraph.__proto__ || _Object$getPrototypeOf(BarGraph)).apply(this, arguments));
  }

  _createClass(BarGraph, [{
    key: "render",
    value: function render() {
      var _React$createElement;

      var _props = this.props,
          id = _props.id,
          data = _props.data,
          margin = _props.margin,
          svgWidth = _props.svgWidth,
          svgHeight = _props.svgHeight,
          bar = _props.bar,
          color = _props.color,
          text = _props.text,
          showAxis = _props.showAxis,
          initX = _props.initX,
          type = _props.type;

      return type === "classic" && React.createElement(
        Wrapper$3,
        null,
        React.createElement(Classic, (_React$createElement = {
          id: id,
          data: data,
          margin: margin,
          svgWidth: svgWidth,
          svgHeight: svgHeight,
          barWidth: bar.barWidth,
          barSet: bar.barSet,
          color: color,
          textHeight: text.textHeight
        }, _defineProperty(_React$createElement, "textHeight", text.textHeight), _defineProperty(_React$createElement, "textRight", text.textRight), _defineProperty(_React$createElement, "textHover", text.textHover), _defineProperty(_React$createElement, "showText", text.showText), _defineProperty(_React$createElement, "showPercent", text.showPercent), _defineProperty(_React$createElement, "decimal", text.decimal), _defineProperty(_React$createElement, "showAxis", showAxis), _defineProperty(_React$createElement, "initX", initX), _React$createElement))
      ) || type === "stackedBar" && React.createElement(
        Wrapper$3,
        null,
        React.createElement(StackedBar, {
          id: id,
          data: data,
          margin: margin,
          svgWidth: svgWidth,
          svgHeight: svgHeight,
          barWidth: bar.barWidth,
          barSet: bar.barSet,
          color: color,
          textHeight: text.textHeight || 2,
          textRight: text.textRight,
          textHover: text.textHover,
          showText: text.showText,
          showPercent: text.showPercent,
          decimal: text.decimal,
          showAxis: showAxis,
          initX: initX
        })
      ) || type === "horizontal" && React.createElement(
        Wrapper$3,
        null,
        React.createElement(Horizontal, _extends$4({
          id: id,
          data: data,
          margin: margin,
          svgWidth: svgWidth,
          svgHeight: svgHeight,
          barWidth: bar.barWidth,
          barSet: bar.barSet,
          color: color,
          textHeight: text.textHeight || 2,
          textRight: text.textRight,
          textHover: text.textHover,
          showText: text.showText,
          showPercent: text.showPercent,
          decimal: text.decimal,
          showAxis: showAxis,
          initX: initX
        }, text))
      );
    }
  }]);

  return BarGraph;
}(Component);

BarGraph.defaultProps = {
  id: "bar",
  data: [],
  margin: { top: 30, right: 30, bottom: 30, left: 30 },
  svgWidth: 400,
  svgHeight: 300,
  bar: { barWidth: 0.5, barSet: 1 },
  color: ["rgba(235, 136, 150,1)", "rgba(235, 136, 150,0.7)", "rgba(235, 136, 150,0.4)", "rgba(235, 136, 150,0.1)"],
  text: {},
  textHeight: 2,
  textRight: 2,
  textHover: false,
  showText: true,
  showPercent: false,
  decimal: 0,
  showAxis: { xAxis: false, yAxis: false },
  initX: [],
  type: "classic"
};

var TAIWAN_MAP = {
  type: "Topology",
  objects: {
    countries: {
      type: "GeometryCollection",
      bbox: [118.14367476000007, 21.895599675000085, 124.56114950000006, 26.385278130000074],
      geometries: [{
        type: "MultiPolygon",
        properties: {
          COUNTYID: "Z",
          COUNTYCODE: "09007",
          COUNTYNAME: "連江縣",
          COUNTYENG: "Lienchiang County"
        },
        arcs: [[[0]]]
      }, {
        type: "MultiPolygon",
        properties: {
          COUNTYID: "W",
          COUNTYCODE: "09020",
          COUNTYNAME: "金門縣",
          COUNTYENG: "Kinmen County"
        },
        arcs: [[[1]], [[2]]]
      }, {
        type: "MultiPolygon",
        properties: {
          COUNTYID: "G",
          COUNTYCODE: "10002",
          COUNTYNAME: "宜蘭縣",
          COUNTYENG: "Yilan County"
        },
        arcs: [[[3, 4, 5, 6, 7, 8]]]
      }, {
        type: "Polygon",
        properties: {
          COUNTYID: "N",
          COUNTYCODE: "10007",
          COUNTYNAME: "彰化縣",
          COUNTYENG: "Changhua County"
        },
        arcs: [[9, 10, 11, 12]]
      }, {
        type: "Polygon",
        properties: {
          COUNTYID: "M",
          COUNTYCODE: "10008",
          COUNTYNAME: "南投縣",
          COUNTYENG: "Nantou County"
        },
        arcs: [[13, 14, 15, 16, -11, 17]]
      }, {
        type: "MultiPolygon",
        properties: {
          COUNTYID: "P",
          COUNTYCODE: "10009",
          COUNTYNAME: "雲林縣",
          COUNTYENG: "Yunlin County"
        },
        arcs: [[[18]], [[-17, 19, 20, -12]]]
      }, {
        type: "MultiPolygon",
        properties: {
          COUNTYID: "T",
          COUNTYCODE: "10013",
          COUNTYNAME: "屏東縣",
          COUNTYENG: "Pingtung County"
        },
        arcs: [[[21, 22, 23]]]
      }, {
        type: "MultiPolygon",
        properties: {
          COUNTYID: "V",
          COUNTYCODE: "10014",
          COUNTYNAME: "臺東縣",
          COUNTYENG: "Taitung County"
        },
        arcs: [[[24]], [[25]], [[26, -22, 27, 28]]]
      }, {
        type: "Polygon",
        properties: {
          COUNTYID: "U",
          COUNTYCODE: "10015",
          COUNTYNAME: "花蓮縣",
          COUNTYENG: "Hualien County"
        },
        arcs: [[29, -29, 30, -14, 31, -5]]
      }, {
        type: "MultiPolygon",
        properties: {
          COUNTYID: "X",
          COUNTYCODE: "10016",
          COUNTYNAME: "澎湖縣",
          COUNTYENG: "Penghu County"
        },
        arcs: [[[32]], [[33]]]
      }, {
        type: "MultiPolygon",
        properties: {
          COUNTYID: "C",
          COUNTYCODE: "10017",
          COUNTYNAME: "基隆市",
          COUNTYENG: "Keelung City"
        },
        arcs: [[[34, 35]]]
      }, {
        type: "Polygon",
        properties: {
          COUNTYID: "O",
          COUNTYCODE: "10018",
          COUNTYNAME: "新竹市",
          COUNTYENG: "Hsinchu City"
        },
        arcs: [[36, 37, 38]]
      }, {
        type: "Polygon",
        properties: {
          COUNTYID: "A",
          COUNTYCODE: "63000",
          COUNTYNAME: "臺北市",
          COUNTYENG: "Taipei City"
        },
        arcs: [[39]]
      }, {
        type: "Polygon",
        properties: {
          COUNTYID: "F",
          COUNTYCODE: "65000",
          COUNTYNAME: "新北市",
          COUNTYENG: "New Taipei City"
        },
        arcs: [[-35, 40, -9, 41, 42], [-40]]
      }, {
        type: "Polygon",
        properties: {
          COUNTYID: "B",
          COUNTYCODE: "66000",
          COUNTYNAME: "臺中市",
          COUNTYENG: "Taichung City"
        },
        arcs: [[-32, -18, -10, 43, 44, 45, -6]]
      }, {
        type: "Polygon",
        properties: {
          COUNTYID: "D",
          COUNTYCODE: "67000",
          COUNTYNAME: "臺南市",
          COUNTYENG: "Tainan City"
        },
        arcs: [[46, 47, 48]]
      }, {
        type: "Polygon",
        properties: {
          COUNTYID: "H",
          COUNTYCODE: "68000",
          COUNTYNAME: "桃園市",
          COUNTYENG: "Taoyuan City"
        },
        arcs: [[-42, -8, 49, 50]]
      }, {
        type: "Polygon",
        properties: {
          COUNTYID: "K",
          COUNTYCODE: "10005",
          COUNTYNAME: "苗栗縣",
          COUNTYENG: "Miaoli County"
        },
        arcs: [[-45, 51, -37, 52]]
      }, {
        type: "Polygon",
        properties: {
          COUNTYID: "J",
          COUNTYCODE: "10004",
          COUNTYNAME: "新竹縣",
          COUNTYENG: "Hsinchu County"
        },
        arcs: [[-39, 53, -50, -7, -46, -53]]
      }, {
        type: "Polygon",
        properties: {
          COUNTYID: "I",
          COUNTYCODE: "10020",
          COUNTYNAME: "嘉義市",
          COUNTYENG: "Chiayi City"
        },
        arcs: [[54]]
      }, {
        type: "MultiPolygon",
        properties: {
          COUNTYID: "Q",
          COUNTYCODE: "10010",
          COUNTYNAME: "嘉義縣",
          COUNTYENG: "Chiayi County"
        },
        arcs: [[[-16, 55, -49, 56, -20], [-55]]]
      }, {
        type: "Polygon",
        properties: {
          COUNTYID: "E",
          COUNTYCODE: "64000",
          COUNTYNAME: "高雄市",
          COUNTYENG: "Kaohsiung City"
        },
        arcs: [[-47, -56, -15, -31, -28, -24, 57]]
      }]
    }
  },
  arcs: [[[2887, 9671], [20, -43], [-66, 4], [46, 39]], [[164, 5703], [22, -75], [-77, -29], [26, 95], [29, 9]], [[417, 5872], [60, -47], [44, -135], [-35, -74], [-86, 40], [-81, -37], [-44, -73], [-66, 61], [38, 51], [-25, 86], [42, 46], [78, -53], [75, 135]], [[5956, 6876], [-64, -33], [-116, -175], [-49, -194], [6, -141], [55, -273], [43, -38], [-26, -54], [7, -92], [-49, -29], [14, -83], [-79, -114], [-42, -261]], [[5656, 5389], [-153, 49], [-69, 74], [-38, -133], [-128, 71], [-47, -5], [-66, 54]], [[5155, 5499], [-24, 41], [-98, -34], [-72, 68], [-16, 96]], [[4945, 5670], [38, 88], [93, 106], [2, 141]], [[5078, 6005], [39, 31], [49, 150], [32, 1]], [[5198, 6187], [89, 33], [89, 91], [-1, 129], [50, 48], [99, 17], [68, 88], [44, 2], [33, 72], [112, 80], [-13, 77], [188, 52]], [[3604, 5148], [74, -36], [44, -144], [125, -53], [20, -162], [83, -35]], [[3950, 4718], [-63, -15], [13, -98], [-42, -269], [93, -91], [-61, -35]], [[3890, 4210], [-138, 34], [-67, -2], [-121, 67], [-194, -22], [-80, 30], [-54, 72]], [[3236, 4389], [58, 72], [37, 120], [84, 141], [6, 97], [67, 84], [66, 192], [50, 53]], [[4985, 5185], [10, -54], [-99, -49], [-7, -93], [73, -47], [-8, -66], [-63, -70], [-36, -141], [22, -33], [-8, -205], [-46, -96], [-13, -112], [-40, -40], [43, -47], [5, -199], [-35, -137], [-94, -30], [-3, -134], [-25, -26], [-104, 8], [-46, -98], [21, -52], [-58, -35]], [[4474, 3429], [-12, 62], [-78, 14]], [[4384, 3505], [-184, 4], [-48, 164], [26, 93], [-19, 32], [-128, 22]], [[4031, 3820], [-152, 19], [23, 136], [-13, 109], [25, 11], [-24, 115]], [[3950, 4718], [104, -34], [39, 23], [59, 127], [33, 12], [10, 101], [28, 17], [57, -62], [91, 65], [67, -11], [31, 72], [63, 3], [90, 97], [41, -4], [49, 64], [21, -29], [114, 69], [138, -43]], [[3019, 3627], [-35, -101], [-97, -29], [132, 130]], [[4031, 3820], [8, -90], [-99, 15], [-37, 34], [-59, -22], [-113, 26], [-52, 91], [-159, -18], [-57, -43], [-146, -170], [-48, 16], [-30, -76], [-119, 37]], [[3120, 3620], [-13, 256], [-19, 22], [68, 252], [-19, 57], [79, 117], [20, 65]], [[4239, 2110], [-4, -38], [65, -58], [-32, -185], [-134, -62], [-56, -132], [-34, -174], [38, -116], [-19, -92], [60, -90], [-54, -31], [-18, -82], [65, -48], [18, -62], [-30, -44], [139, -152], [46, 37]], [[4289, 781], [-9, -113], [14, -198], [-15, -178], [-67, -88], [-9, -68], [38, -129], [-67, 79], [-108, 47], [-21, -80], [-46, 33], [8, 86], [-45, 130], [47, 138], [-48, 252], [-56, 103], [-21, 134], [-79, 126], [-202, 160], [-49, 61]], [[3554, 1276], [-3, 113], [31, 93], [-10, 230], [31, 123], [-4, 106], [24, 142], [131, -6], [83, 101], [59, 26], [51, -62], [40, 49], [81, -32], [33, -64], [76, 67], [62, -52]], [[5237, 421], [102, -5], [-4, -96], [54, -42], [-47, -37], [-96, 97], [-9, 83]], [[5216, 1741], [31, -17], [-27, -79], [-46, 83], [42, 13]], [[5221, 3421], [-27, -83], [-23, -182], [-49, -62], [-52, -173], [23, -186], [-89, -98], [-28, -133], [-85, -160], [-78, -187], [-64, -31], [14, -123], [-38, -81], [-77, -90], [-157, -137], [-28, -156], [-43, -55], [-52, -231], [-82, -277], [3, -195]], [[4239, 2110], [-37, 86], [-31, 177], [95, 180], [-19, 41], [31, 89], [-20, 114], [53, 65], [8, 128], [89, 98], [87, 33]], [[4495, 3121], [48, -23], [33, -118], [76, -24], [16, -48], [80, 3], [33, -130], [59, -29], [35, -75], [67, 27], [97, 426], [70, 132], [-35, 53], [71, 133], [76, -27]], [[5656, 5389], [-47, -123], [-109, -117], [-24, -82], [9, -81], [-69, -95], [2, -99], [42, -83], [-56, -172], [-21, -169], [-41, -131], [1, -90], [-65, -292], [-2, -71], [-41, -173], [16, -66], [-30, -124]], [[4495, 3121], [32, 59], [-96, 104], [61, 79], [-18, 66]], [[4985, 5185], [66, 71], [-8, 52], [85, 95], [27, 96]], [[2104, 3344], [31, -98], [-43, 6], [12, 92]], [[2245, 3966], [30, -16], [15, -150], [57, 17], [69, -122], [-75, 13], [-113, -118], [-28, 45], [55, 7], [-46, 121], [71, 1], [-40, 169], [-98, -72], [-3, -144], [-37, 12], [33, 191], [42, -33], [68, 79]], [[5702, 7217], [-9, -49], [-65, -12], [25, -102], [-64, -22], [-128, 108], [-33, 86], [128, 81]], [[5556, 7307], [83, -28], [63, -62]], [[4350, 6274], [-45, 63], [-50, -6]], [[4255, 6331], [30, 53], [12, 134], [37, 72]], [[4334, 6590], [117, -72], [33, -47], [10, -96], [-55, 50], [-76, -81], [-13, -70]], [[5340, 7353], [20, -5], [37, -147], [-17, -41], [49, -49], [-5, -113], [61, -33], [-104, -18], [8, -120], [-66, 10], [-10, 45], [-109, 108], [35, 41], [-10, 78], [-66, 43], [70, 148], [28, -9], [66, 90], [13, -28]], [[5702, 7217], [151, -35], [37, 22], [-15, -90], [47, -150], [82, -7], [13, -40], [-61, -41]], [[5198, 6187], [-46, 71], [-42, 125], [41, 54], [-74, 128], [-102, 11], [28, 56], [-53, 59], [10, 175], [66, -4], [53, 50], [-9, 116], [-178, 148]], [[4892, 7176], [165, 67], [99, 234], [128, 86], [67, 17], [81, -72], [6, -61], [118, -140]], [[3604, 5148], [38, 58], [66, 184], [35, 43], [118, 234]], [[3861, 5667], [109, -160], [103, -88], [74, -28], [43, -57], [110, 3], [51, 113], [107, -25], [69, -79], [9, 32], [104, 45], [30, 65], [42, 2], [61, 83], [39, -31], [42, 120]], [[4854, 5662], [91, 8]], [[3910, 2960], [-26, -110], [-55, -71], [-41, -117], [-149, -195], [-30, 0], [-67, -193], [-55, 9], [-48, -70], [-114, 34], [-37, -23], [-93, 59], [-30, -20]], [[3165, 2263], [-25, 141], [-76, 98], [-130, 109], [83, 312], [25, 203], [34, 91]], [[3076, 3217], [111, -111], [49, 12], [112, 178], [87, 57], [145, 27], [90, -58], [8, -91], [51, -29], [-22, -46], [-6, -164], [92, -54], [117, 22]], [[5078, 6005], [-61, 24], [-16, 145], [-84, 61], [13, 134], [-246, 198], [10, 80], [-67, 5], [-87, 52], [1, 69], [-119, 7]], [[4422, 6780], [107, 229], [116, 76], [209, 102], [38, -11]], [[3861, 5667], [68, 97], [70, 241], [103, 154], [73, 26], [80, 146]], [[4350, 6274], [60, -2], [-12, -59], [74, -99], [76, -42], [32, -72], [-31, -71], [27, -37], [-14, -94], [80, 24], [72, -16], [72, 29], [73, -133], [-5, -40]], [[4334, 6590], [88, 190]], [[3590, 3614], [83, -63], [-9, -83], [-41, 20], [-44, -49], [-18, 47], [-55, 4], [-4, 84], [88, 40]], [[4384, 3505], [-75, -26], [-93, -86], [-38, -106], [-176, -141], [-29, -53], [-80, 17], [17, -150]], [[3076, 3217], [21, 100], [46, 9], [-43, 139], [38, 97], [-50, -15], [-10, 64], [42, 9]], [[3554, 1276], [-45, 19], [-115, 113], [-103, 200], [13, 125], [-12, 100], [-68, 198], [-59, 232]]],
  transform: {
    scale: [0.0006418116551655153, 0.0004490127467746764],
    translate: [118.14367476000007, 21.895599675000085]
  }
};

var _templateObject$h = _taggedTemplateLiteral(["\n  path {\n    &:hover {\n      transform: translateY(-10px);\n      transition: all 300ms;\n    }\n  }\n"], ["\n  path {\n    &:hover {\n      transform: translateY(-10px);\n      transition: all 300ms;\n    }\n  }\n"]),
    _templateObject2$c = _taggedTemplateLiteral(["\n  position: absolute;\n  padding: 5px 16px;\n  font-size: 14px;\n  background: white;\n  border-radius: 5px;\n  top: ", ";\n  left: ", ";\n  transition: top 300ms;\n  pointer-events: none;\n  color: #333333;\n  font-weight: bold;\n  text-align: center;\n  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n  span {\n    padding: 0 5px;\n    font-size: 13px;\n  }\n"], ["\n  position: absolute;\n  padding: 5px 16px;\n  font-size: 14px;\n  background: white;\n  border-radius: 5px;\n  top: ", ";\n  left: ", ";\n  transition: top 300ms;\n  pointer-events: none;\n  color: #333333;\n  font-weight: bold;\n  text-align: center;\n  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n  span {\n    padding: 0 5px;\n    font-size: 13px;\n  }\n"]),
    _templateObject3$9 = _taggedTemplateLiteral(["\n  position: relative;\n  height: 20px;\n"], ["\n  position: relative;\n  height: 20px;\n"]),
    _templateObject4$4 = _taggedTemplateLiteral(["\n  width: 35%;\n  height: 100%;\n  display: flex;\n  position: absolute;\n  top: 0;\n  right: 0;\n"], ["\n  width: 35%;\n  height: 100%;\n  display: flex;\n  position: absolute;\n  top: 0;\n  right: 0;\n"]),
    _templateObject5$4 = _taggedTemplateLiteral(["\n  width: 20%;\n  height: 100%;\n  background: ", ";\n  border-width: 1px 0 1px 1px;\n  border-style: solid;\n  border-color: #ffffff;\n  /* display: flex;\n  justify-content: center;\n  align-items: center; */\n  font-size: 10px;\n  color: #333333;\n  position: relative;\n  &:first-child {\n    border-radius: 50px 0 0 50px;\n  }\n  &:last-child {\n    border-width: 1px 1px 1px 1px;\n    border-radius: 0 50px 50px 0;\n  }\n  &:hover div {\n    opacity: 1;\n    transform: translateY(0px);\n  }\n  div {\n    font-size: 13px;\n    position: absolute;\n    width: 100%;\n    background: #ffffff;\n    padding: 8px 16px;\n    text-align: center;\n    top: -50px;\n    left: 0;\n    opacity: 0;\n    border-radius: 5px;\n    transition: all 300ms;\n    border: 1px solid #e9e8e7;\n    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n    transform: translateY(-10px);\n  }\n"], ["\n  width: 20%;\n  height: 100%;\n  background: ", ";\n  border-width: 1px 0 1px 1px;\n  border-style: solid;\n  border-color: #ffffff;\n  /* display: flex;\n  justify-content: center;\n  align-items: center; */\n  font-size: 10px;\n  color: #333333;\n  position: relative;\n  &:first-child {\n    border-radius: 50px 0 0 50px;\n  }\n  &:last-child {\n    border-width: 1px 1px 1px 1px;\n    border-radius: 0 50px 50px 0;\n  }\n  &:hover div {\n    opacity: 1;\n    transform: translateY(0px);\n  }\n  div {\n    font-size: 13px;\n    position: absolute;\n    width: 100%;\n    background: #ffffff;\n    padding: 8px 16px;\n    text-align: center;\n    top: -50px;\n    left: 0;\n    opacity: 0;\n    border-radius: 5px;\n    transition: all 300ms;\n    border: 1px solid #e9e8e7;\n    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n    transform: translateY(-10px);\n  }\n"]);

var Svg = styled.svg(_templateObject$h);

var Tag$3 = styled.div(_templateObject2$c, function (props) {
  return props.top + "px";
}, function (props) {
  return props.left + "px";
});

var ScaleOutline = styled.div(_templateObject3$9);

var Scale = styled.div(_templateObject4$4);

var Range = styled.div(_templateObject5$4, function (props) {
  return props.background ? props.background : "pink";
});

var AreaGraph = function (_Component) {
  _inherits(AreaGraph, _Component);

  function AreaGraph() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AreaGraph);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AreaGraph.__proto__ || _Object$getPrototypeOf(AreaGraph)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      worlddata: [],
      graticule: geoGraticule10(),
      show: false,
      name: "",
      top: 0,
      left: 0,
      percent: 0
    }, _this.changeColor = function (d, range) {
      var svgSetup = _this.props.svgSetup ? _this.props.svgSetup : { rgb: "" };
      var background = svgSetup.rgb ? svgSetup.rgb : "198,153,103";
      var data = _this.props.data ? _this.props.data : [];
      var selectCity = data.find(function (k) {
        return k.name === d.properties.COUNTYNAME;
      });
      var percent = selectCity ? selectCity.value : 0;
      if (percent >= 0 && percent <= range) {
        return "rgba(" + background + ",0.2)";
      } else if (percent > range && percent <= range * 2) {
        return "rgba(" + background + ",0.4)";
      } else if (percent > range * 2 && percent <= range * 3) {
        return "rgba(" + background + ",0.6)";
      } else if (percent > range * 3 && percent <= range * 4) {
        return "rgba(" + background + ",0.8)";
      } else {
        return "rgba(" + background + ",1)";
      }
    }, _this.hover = function (d) {
      var data = _this.props.data ? _this.props.data : [];
      var selectCity = data.find(function (k) {
        return k.name === d.properties.COUNTYNAME;
      });
      var percent = selectCity ? selectCity.value : 0;
      _this.setState({
        show: true,
        name: d.properties.COUNTYNAME,
        percent: percent
      });
      // 偵測滑鼠移動事件
      var id = _this.props.clsNa ? _this.props.clsNa : "taiwan-map";
      var element = document.getElementById(id);
      element.addEventListener("mousemove", _this.myEfficientFn.bind(_this));
    }, _this.hoverOff = function () {
      _this.setState({
        show: false
      });
    }, _this.move = function (event) {
      console.log(event);
      var x = event.offsetX;
      var y = event.offsetY;
      _this.setState({
        top: y - 40,
        left: x - 50
      });
    }, _this.myEfficientFn = _this.debounce(function (event) {
      this.move(event);
    }, 20), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AreaGraph, [{
    key: "componentDidMount",


    // 載入台灣地圖的JSON並轉存至state裡
    value: function componentDidMount() {
      var taiwanMap = TAIWAN_MAP;
      this.setState({
        worlddata: feature(taiwanMap, taiwanMap.objects.countries).features
      });
    }

    // 離開頁面時，移除滑鼠監聽事件

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var id = this.props.clsNa ? this.props.clsNa : "taiwan-map";
      var element = document.getElementById(id);
      element.removeEventListener("mousemove", this.myEfficientFn.bind(this));
    }

    // 縮放大小與置中位置

  }, {
    key: "projection",
    value: function projection() {
      return geoMercator().scale(8500).center([121.5, 23.9]);
    }

    // 計算每個地區的顏色


    // 滑鼠移入事件


    // 滑鼠移出事件


    // 讓地區的顯示區塊跟著滑鼠移動


    // 優化滑鼠事件

  }, {
    key: "debounce",
    value: function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this,
            args = arguments;
        var later = function later() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var svgSetup = this.props.svgSetup ? this.props.svgSetup : { rgb: "" };
      var background = svgSetup.rgb ? svgSetup.rgb : "198,153,103";
      var id = this.props.clsNa ? this.props.clsNa : "taiwan-map";
      var range = svgSetup.maxRange ? Math.round(svgSetup.maxRange / 5) : 100 / 5;
      var rangeLists = [{ min: 0, max: range, background: "rgba(" + background + ",0.2)" }, { min: range + 1, max: range * 2, background: "rgba(" + background + ",0.4)" }, {
        min: range * 2 + 1,
        max: range * 3,
        background: "rgba(" + background + ",0.6)"
      }, {
        min: range * 3 + 1,
        max: range * 4,
        background: "rgba(" + background + ",0.8)"
      }, {
        min: range * 4 + 1,
        max: range * 5,
        background: "rgba(" + background + ",1)"
      }];
      return React.createElement(
        "div",
        {
          style: {
            width: svgSetup.width ? svgSetup.width : "100%",
            position: "relative"
          }
        },
        this.state.show ? React.createElement(
          Tag$3,
          { top: this.state.top, left: this.state.left },
          this.state.name,
          React.createElement("br", null),
          svgSetup.maxRange ? React.createElement(
            "span",
            null,
            this.state.percent
          ) : React.createElement(
            "span",
            null,
            this.state.percent,
            "%"
          )
        ) : null,
        React.createElement(
          Svg,
          {
            className: "map-svg",
            width: "100%",
            height: svgSetup.height ? svgSetup.height : 600,
            viewBox: "0 0 800 600",
            id: id
          },
          this.state.worlddata.map(function (d, i) {
            return React.createElement("path", {
              key: "path-" + i,
              d: geoPath().projection(_this2.projection())(d),
              className: "country",
              fill: _this2.changeColor(d, range),
              stroke: "#fff",
              strokeWidth: 0.5,
              onMouseOver: _this2.hover.bind(_this2, d),
              onMouseLeave: _this2.hoverOff
            });
          })
        ),
        this.props.needScale ? React.createElement(
          ScaleOutline,
          null,
          React.createElement(
            Scale,
            null,
            rangeLists.map(function (range, index) {
              return React.createElement(
                Range,
                { key: index, background: range.background },
                React.createElement(
                  "div",
                  null,
                  range.min,
                  " - ",
                  range.max
                )
              );
            })
          )
        ) : null
      );
    }
  }]);

  return AreaGraph;
}(Component);

var _templateObject$i = _taggedTemplateLiteral(["\n  position: fixed;\n  width: 100vw;\n  background: rgba(0, 0, 0, 0.5);\n  top: 0;\n  left: 100vw;\n  bottom:0\n  transition: transform 0s ease 0.5s, -webkit-transform 0s ease 0.5s;\n  transform: ", ";\n  transition-delay: ", ";\n  z-index: 100;\n"], ["\n  position: fixed;\n  width: 100vw;\n  background: rgba(0, 0, 0, 0.5);\n  top: 0;\n  left: 100vw;\n  bottom:0\n  transition: transform 0s ease 0.5s, -webkit-transform 0s ease 0.5s;\n  transform: ", ";\n  transition-delay: ", ";\n  z-index: 100;\n"]),
    _templateObject2$d = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 100vw;\n  bottom: 0;\n  width: 95%;\n  max-width: 500px;\n  transform: ", ";\n  background: #fff;\n  transition: transform 0.5s ease, -webkit-transform 0.5s ease;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 100vw;\n  bottom: 0;\n  width: 95%;\n  max-width: 500px;\n  transform: ", ";\n  background: #fff;\n  transition: transform 0.5s ease, -webkit-transform 0.5s ease;\n"]);

var Bg = styled.div(_templateObject$i, function (props) {
  return props.open ? "translate3d(-100%, 0, 0);" : "translate3d(0, 0, 0)";
}, function (props) {
  return props.open ? "0s;" : "";
});
var Content$2 = styled.div(_templateObject2$d, function (props) {
  return props.open ? "translate3d(-100%, 0, 0);" : "translate3d(0, 0, 0)";
});

var FullBar = function (_Component) {
  _inherits(FullBar, _Component);

  function FullBar() {
    _classCallCheck(this, FullBar);

    return _possibleConstructorReturn(this, (FullBar.__proto__ || _Object$getPrototypeOf(FullBar)).apply(this, arguments));
  }

  _createClass(FullBar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var open = this.props.open;

      if (open) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(
        Bg,
        { open: this.props.open },
        React.createElement(
          Content$2,
          { open: this.props.open },
          this.props.content
        )
      );
    }
  }]);

  return FullBar;
}(Component);

var _templateObject$j = _taggedTemplateLiteral(["\n  width: ", ";\n  // max-width: 1230px;\n  margin: 0 auto;\n  padding-left: 30px;\n  padding-right: 30px;\n\n  @media only screen and (max-width: 991px) {\n    padding-left: 15px;\n    padding-right: 15px;\n    padding-top: 60px;\n  }\n"], ["\n  width: ", ";\n  // max-width: 1230px;\n  margin: 0 auto;\n  padding-left: 30px;\n  padding-right: 30px;\n\n  @media only screen and (max-width: 991px) {\n    padding-left: 15px;\n    padding-right: 15px;\n    padding-top: 60px;\n  }\n"]);

var Div$5 = styled.div(_templateObject$j, function (props) {
  return props.width ? props.width : "100%";
});
var Layout = function Layout(Header, Component$$1, Footer, state) {
  return function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, (_class.__proto__ || _Object$getPrototypeOf(_class)).call(this, props));

      _this.state = state;
      return _this;
    }

    _createClass(_class, [{
      key: "render",
      value: function render() {
        return React.createElement(
          Div$5,
          null,
          React.createElement(Header, null),
          React.createElement(Component$$1, _extends$4({}, this.props, this.state)),
          React.createElement(Footer, null)
        );
      }
    }]);

    return _class;
  }(React.Component);
};

// import ExampleComponent from "./ExampleComponent";

export { Button$1 as Button, Checkbox, Dialog, Form$1 as Form, Input$1 as Input, Radio, SearchBar, Select$1 as Select, SliderSet as Slider, NavBar, Nav, NavWithColumn, Step$1 as Step, FullBar, Header$1 as Header, Footer, Card, SubMenu, PieGraph, LineGraph, BarGraph, AreaGraph, Layout };
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 10
// module chunks = 0